var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path5, _g8, _g9, _g10, _g11, _path6, _path7, _path8, _g12, _path9, _polygon, _g13, _path10, _path11, _path12, _g14, _path13, _path14, _path15, _path16, _polygon2, _polygon3, _polygon4, _g15, _g16, _g17, _path17, _g18, _path18, _g19, _path19, _g20, _g21, _polygon5, _polygon6, _polygon7, _g22, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g23, _g24, _path62, _g25, _path63, _g26, _path64, _g27, _path65, _g28, _path66, _g29, _g30, _path67, _g31, _g32, _path68, _g33, _path69, _g34, _path70, _g35, _path71, _g36, _path72, _g37, _path73, _g38, _path74, _g39, _path75, _g40, _g41, _path76, _g42, _g43, _path77, _g44, _path78, _g45, _path79, _g46, _g47, _g48, _g49, _g50, _path80, _path81, _path82, _path83, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "720px",
    height: "696px",
    viewBox: "0 0 720 696",
    enableBackground: "new 0 0 720 696",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.3169,
    y1: 649.9404,
    x2: 184.4181,
    y2: 538.8262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFE0ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#E4E5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7504,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_1_)",
    d: "M262.415,567.285l-47.133-25.955 c-2.944-1.775-6.658-1.871-9.697-0.25L44.916,629.266c-6.355,3.391-6.59,12.107-0.423,15.809l46.376,27.303 c2.974,1.787,6.728,1.859,9.772,0.191l161.425-89.535C268.334,579.6,268.522,570.973,262.415,567.285z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.6729,
    y1: 147.7334,
    x2: 376.2617,
    y2: 147.7334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFE0ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9013,
    style: {
      stopColor: "#FCFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M126.763,201.234c-11.19,4.883,25.964,18.46,30.862,15.799L376.262,93.891l-30.863-15.8 L126.763,201.234z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.29,
    y1: 237.6621,
    x2: 506.8789,
    y2: 237.6621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFE0ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9013,
    style: {
      stopColor: "#FCFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M257.38,291.163c-11.189,4.883,25.966,18.461,30.864,15.8l218.635-123.145l-30.86-15.799 L257.38,291.163z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.6572,
    y1: 585.7998,
    x2: 594.8425,
    y2: 467.9796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFE0ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#E4E5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7504,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_4_)",
    d: "M714.794,527.712l-144.089-83.219 c-3.067-1.882-6.858-1.982-9.896-0.264L409.054,534.36c-6.356,3.596-6.271,12.827,0.152,16.755l143.367,84.646 c3.098,1.894,6.928,1.972,9.973,0.201l152.477-91.561C721.286,540.761,721.162,531.619,714.794,527.712z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M70.057,370.092c-0.042-0.018-0.085-0.039-0.125-0.057c-3.701-1.775-8.129-0.119-9.679,3.678 c0,0-10.095,23.459-12.223,32.742c-0.724,3.154,12.205,5.484,13.492,1.787c2.534-7.289,11.98-29.111,11.98-29.111 C74.91,375.68,73.423,371.691,70.057,370.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M95.09,434.709c-9.28-4.906-23.563-21-35.061-29.523c-3.424-2.539-9.066-3.834-11.223-0.561l-0.081,0.119 c-2.158,3.27,0.513,6.945,3.677,9.807c6.514,5.887,33.955,21.607,36.672,24.541C89.074,439.092,96.676,435.547,95.09,434.709z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M99.751,442.391c-1.141-1.354-1.41-3.354-2.469-4.781c-0.573-0.773-1.355-1.346-2.069-1.979 c-0.96-0.859-1.86-1.586-3.076-2.045c-2.035-0.764-5.451,2.295-3.583,4.674c1.452,1.854,1.867,4.666,3.263,6.619 c0.629,0.883,1.41,1.629,2.191,2.369c1.068,1.01,2.137,2.025,3.205,3.037c0.342,0.326,0.691,0.656,1.131,0.834 c0.359,0.148,0.759,0.184,1.154,0.221c0.812,0.076,4.313-0.387,5.071-1.367c0.579-0.75-1.341-2.785-2.278-4.053 C101.23,444.486,100.901,443.746,99.751,442.391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M99.939,436.236c-0.656-0.412-4.15-1.672-6.695-2.521c-0.168,0.859-1.178,2.787-0.484,3.32 c1.149,0.893,2.342,1.801,3.748,2.168c1.481,0.389,3.238-0.021,6.126,2.121c0.553,0.414,1.198,0.775,1.887,0.732 c0.688-0.039,1.375-0.617,1.319-1.301c-1.403-0.908-2.816-1.82-4.053-2.939C101.189,437.268,100.625,436.674,99.939,436.236z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M71.895,365.732c-0.38-0.166-0.765-0.309-1.15-0.418c-4.275-1.221-8.878,0.918-10.65,5.029 c-2.157,4.988-8.49,20.018-8.49,20.018c4.622,6.443,16.151,8.117,16.151,8.117l8.818-18.344c0.962-2.186,1.055-7.17,0.188-9.4 C75.896,368.506,74.213,366.752,71.895,365.732z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M122.542,408.59l-10.939-6.623c-0.817-0.496-2.178-0.492-3.042,0.004l-8.857,5.131 c-0.865,0.496-0.896,1.307-0.078,1.801l10.942,6.621c0.819,0.494,2.182,0.494,3.043-0.008l8.858-5.127 C123.328,409.889,123.365,409.08,122.542,408.59z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M182.499,405.162l-63.769-38.602c-0.904-0.551-2.414-0.551-3.368,0.006l-45.364,26.258 c-0.955,0.561-0.995,1.451-0.087,1.996l63.767,38.602c0.905,0.553,2.414,0.549,3.368-0.004l45.366-26.264 C183.365,406.6,183.406,405.709,182.499,405.162z M122.467,410.389l-8.858,5.127c-0.861,0.502-2.224,0.502-3.043,0.008 l-10.942-6.621c-0.817-0.494-0.787-1.305,0.078-1.801l8.857-5.131c0.865-0.496,2.226-0.5,3.042-0.004l10.939,6.623 C123.365,409.08,123.328,409.889,122.467,410.389z M150.363,421.141l-59.335-35.914l23.753-13.758l59.333,35.92 L150.363,421.141z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M182.411,407.154l-45.366,26.264c-0.113,0.064-0.241,0.121-0.37,0.18 c-0.016,0.002-0.039,0.008-0.055,0.016c-0.112,0.045-0.223,0.076-0.335,0.104c-0.025,0.004-0.05,0.008-0.071,0.014 c-0.125,0.033-0.255,0.057-0.382,0.07c-0.023,0.004-0.043,0.004-0.065,0.004c-0.127,0.016-0.259,0.027-0.395,0.027 c-0.02,0.004-0.042,0-0.064,0c-0.134,0-0.268-0.008-0.402-0.02c-0.021-0.008-0.042-0.008-0.067-0.012 c-0.098-0.014-0.197-0.027-0.288-0.049c-0.078-0.021-0.161-0.041-0.235-0.063c-0.062-0.014-0.122-0.031-0.178-0.057 c-0.161-0.059-0.321-0.121-0.46-0.211L69.911,394.82c-0.057-0.029-0.098-0.068-0.145-0.109 c-0.056-0.035-0.116-0.078-0.163-0.119c-0.069-0.072-0.132-0.135-0.18-0.211c-0.012-0.016-0.016-0.035-0.025-0.049 c-0.045-0.066-0.082-0.145-0.103-0.219c-0.004-0.01-0.004-0.02-0.004-0.029c-0.025-0.084-0.038-0.168-0.037-0.252l-0.108,3.213 v0.025c-0.005,0.045,0,0.088,0.006,0.137c0.006,0.029,0.016,0.057,0.023,0.088c0,0.014,0.002,0.018,0.006,0.025 c0,0.012,0.006,0.021,0.006,0.021c0.017,0.045,0.035,0.098,0.061,0.139c0.006,0.023,0.026,0.047,0.043,0.066 c0.004,0.014,0.013,0.027,0.02,0.041c0.009,0.014,0.015,0.027,0.025,0.041c0.04,0.053,0.087,0.109,0.146,0.166 c0,0,0.004,0.004,0.009,0.008c0.047,0.039,0.107,0.08,0.16,0.121c0.043,0.027,0.072,0.066,0.114,0.096 c0.013,0,0.025,0.01,0.03,0.016l63.769,38.602c0.142,0.084,0.297,0.152,0.462,0.211c0.016,0.006,0.033,0.018,0.051,0.021 c0.042,0.008,0.085,0.021,0.125,0.033c0.08,0.025,0.157,0.041,0.233,0.057c0.031,0.012,0.056,0.014,0.089,0.027 c0.065,0.012,0.134,0.021,0.203,0.027c0.025,0,0.045,0.006,0.078,0.012l0.02,0.002c0.089,0.006,0.18,0.016,0.265,0.016 c0.034,0,0.067,0,0.108,0h0.062c0.023,0,0.046,0,0.072,0c0.078,0,0.158-0.004,0.234-0.016c0.029,0,0.056-0.002,0.088-0.008 c0.023,0,0.04,0,0.06-0.006c0.027,0,0.056-0.004,0.086-0.006c0.081-0.016,0.16-0.035,0.236-0.049 c0.023-0.002,0.043-0.01,0.063-0.016c0.027-0.004,0.045-0.008,0.069-0.012c0.038-0.016,0.08-0.02,0.119-0.029 c0.073-0.029,0.145-0.049,0.216-0.082c0.02-0.002,0.038-0.006,0.058-0.012c0.009-0.002,0.021-0.008,0.021-0.008 c0.12-0.051,0.24-0.104,0.35-0.17l45.363-26.264c0.479-0.279,0.731-0.645,0.741-1.012l0.115-3.207 C183.142,406.514,182.894,406.875,182.411,407.154z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DEDCE9",
    points: "89.688,384.398 151.427,421.77 176.144,407.461 114.403,370.084  "
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M172.014,407.818c-0.057,0.037-0.125,0.055-0.198,0.08h-0.004c-0.068,0.016-0.145,0.029-0.213,0.029 h-0.009c-0.072,0-0.138-0.014-0.205-0.029l-0.019-0.008c-0.07-0.018-0.13-0.039-0.187-0.066l-2.78-1.68 c-0.045-0.039-0.082-0.072-0.103-0.1l1.95-1.137c0.114-0.07,0.18-0.16,0.182-0.25l0.023-0.795 c-0.005,0.092-0.062,0.182-0.181,0.246l-2.24,1.299c-0.06,0.029-0.122,0.063-0.192,0.076l-0.011,0.004 c-0.068,0.012-0.142,0.025-0.214,0.025h-0.002c-0.072,0-0.145-0.014-0.206-0.025l-0.029-0.004 c-0.065-0.014-0.127-0.047-0.176-0.076l-2.782-1.686c-0.047-0.02-0.076-0.063-0.107-0.094l1.95-1.133 c0.114-0.063,0.178-0.152,0.187-0.24l0.021-0.805c-0.005,0.094-0.063,0.184-0.182,0.248L164.043,403 c-0.058,0.027-0.126,0.057-0.19,0.07h-0.009c-0.072,0.014-0.146,0.027-0.219,0.027h-0.004c-0.07,0-0.143-0.014-0.203-0.025 c-0.009-0.002-0.018-0.002-0.03-0.006c-0.063-0.014-0.125-0.039-0.174-0.066l-2.788-1.689 c-0.045-0.025-0.072-0.057-0.105-0.096l1.956-1.125c0.118-0.068,0.177-0.158,0.179-0.25l0.031-0.803 c-0.002,0.092-0.069,0.178-0.181,0.248l-2.246,1.297c-0.052,0.035-0.123,0.063-0.193,0.078h-0.004 c-0.074,0.021-0.143,0.025-0.22,0.025h-0.001c-0.073,0-0.145-0.004-0.207-0.021c-0.011-0.004-0.015-0.004-0.025-0.008 c-0.067-0.012-0.127-0.039-0.181-0.066l-2.782-1.688c-0.045-0.027-0.076-0.066-0.109-0.104l1.95-1.127 c0.12-0.066,0.179-0.152,0.179-0.242l0.033-0.805c0,0.047-0.018,0.094-0.047,0.135c-0.037,0.037-0.074,0.078-0.136,0.115 l-2.238,1.297c-0.062,0.033-0.124,0.059-0.2,0.07c0,0,0,0-0.007,0.004c-0.071,0.02-0.136,0.025-0.218,0.025h-0.003 c-0.071,0-0.135-0.006-0.203-0.025h-0.023c-0.067-0.023-0.127-0.041-0.18-0.074l-2.782-1.686 c-0.044-0.021-0.082-0.059-0.102-0.09l1.95-1.133c0.114-0.063,0.174-0.154,0.18-0.242l0.025-0.811 c0,0.049-0.018,0.094-0.047,0.135c-0.031,0.045-0.073,0.08-0.131,0.117l-2.239,1.303c-0.064,0.027-0.127,0.051-0.2,0.074 h-0.005c-0.071,0.016-0.142,0.023-0.22,0.023h-0.003c-0.073,0-0.136-0.008-0.203-0.021c-0.011-0.002-0.017-0.002-0.033-0.002 c-0.059-0.023-0.121-0.047-0.172-0.074l-2.782-1.684c-0.047-0.035-0.09-0.072-0.11-0.104l1.944-1.135 c0.118-0.061,0.178-0.16,0.182-0.246l0.025-0.807c-0.002,0.092-0.062,0.184-0.178,0.254l-2.249,1.295 c-0.054,0.033-0.116,0.063-0.19,0.082H147.9c-0.073,0.012-0.147,0.023-0.219,0.023h-0.006c-0.072,0-0.138-0.012-0.199-0.023 c-0.016,0-0.022-0.006-0.022-0.006c-0.07-0.014-0.134-0.035-0.188-0.076l-2.78-1.682c-0.045-0.025-0.08-0.051-0.104-0.094 l1.95-1.125c0.116-0.07,0.182-0.162,0.182-0.25l0.029-0.801c-0.009,0.088-0.067,0.178-0.185,0.242l-2.242,1.301 c-0.058,0.037-0.125,0.057-0.192,0.074h-0.011c-0.063,0.021-0.142,0.029-0.211,0.029h-0.004c-0.073,0-0.144-0.006-0.203-0.029 c0,0-0.023-0.004-0.031-0.004c-0.067-0.014-0.127-0.037-0.179-0.07l-2.781-1.68c-0.047-0.031-0.083-0.066-0.109-0.102 l1.951-1.129c0.118-0.068,0.18-0.158,0.18-0.242l0.029-0.809c-0.002,0.088-0.062,0.182-0.18,0.25l-2.243,1.293 c-0.058,0.039-0.125,0.066-0.19,0.082h-0.011c-0.071,0.016-0.143,0.021-0.215,0.021h-0.009c-0.067,0-0.136-0.006-0.203-0.016 c-0.004-0.006-0.015-0.006-0.025-0.014c-0.065-0.016-0.124-0.035-0.178-0.063l-2.776-1.686c-0.051-0.031-0.08-0.064-0.11-0.1 l1.952-1.125c0.116-0.068,0.179-0.166,0.182-0.254l0.028-0.799c-0.001,0.086-0.068,0.176-0.18,0.242l-2.246,1.305 c-0.062,0.031-0.123,0.055-0.193,0.074h-0.013c-0.065,0.02-0.139,0.031-0.214,0.031h-0.003c-0.071,0-0.138-0.012-0.203-0.023 c-0.011-0.008-0.022-0.008-0.028-0.012c-0.063-0.014-0.121-0.039-0.179-0.064l-2.782-1.691 c-0.051-0.025-0.076-0.059-0.103-0.096l1.948-1.135c0.116-0.064,0.178-0.152,0.18-0.242l0.034-0.803 c-0.009,0.088-0.073,0.178-0.183,0.248l-2.244,1.301c-0.06,0.025-0.126,0.055-0.196,0.074l-0.007,0.004 c-0.073,0.014-0.14,0.016-0.212,0.016h-0.007c-0.076,0-0.142-0.002-0.21-0.016l-0.028-0.004 c-0.061-0.02-0.124-0.049-0.175-0.074l-2.78-1.686c-0.051-0.023-0.078-0.061-0.106-0.094l1.952-1.131 c0.115-0.066,0.177-0.156,0.181-0.244l0.029-0.803c-0.004,0.088-0.062,0.18-0.185,0.24l-2.242,1.303 c-0.052,0.037-0.123,0.061-0.193,0.072c0,0,0,0-0.004,0.008c-0.071,0.014-0.147,0.018-0.22,0.018h-0.001 c-0.073,0-0.138-0.004-0.205-0.018l-0.033-0.008c-0.055-0.018-0.12-0.035-0.17-0.064l-2.786-1.693 c-0.052-0.027-0.091-0.07-0.119-0.107v-0.004c-0.004-0.006-0.004-0.01-0.004-0.01l1.928-1.121 c0.118-0.072,0.18-0.16,0.181-0.248l0.025-0.793c-0.002,0.086-0.067,0.176-0.174,0.234l-2.244,1.303 c-0.06,0.025-0.125,0.055-0.198,0.066l-0.002,0.008c-0.076,0.016-0.146,0.023-0.223,0.023h-0.004 c-0.072,0-0.139-0.008-0.205-0.023c-0.009-0.008-0.016-0.008-0.031-0.012c-0.058-0.012-0.123-0.029-0.176-0.063l-2.78-1.686 c-0.049-0.033-0.076-0.061-0.102-0.098l1.952-1.129c0.111-0.068,0.174-0.158,0.183-0.242l0.024-0.809 c-0.007,0.09-0.063,0.182-0.187,0.25l-2.24,1.303c-0.054,0.029-0.124,0.057-0.19,0.07h-0.003 c-0.082,0.02-0.15,0.023-0.224,0.023h-0.005c-0.069,0-0.138-0.004-0.212-0.02c0,0-0.009,0-0.017-0.008 c-0.069-0.016-0.128-0.037-0.176-0.066l-2.786-1.689c-0.016-0.006-0.025-0.025-0.042-0.035l1.963-1.143 c0.125-0.066,0.183-0.154,0.185-0.238l0.031-0.811c-0.001,0.094-0.071,0.182-0.183,0.252l-2.243,1.297 c-0.058,0.029-0.124,0.063-0.195,0.076l-0.008,0.002c-0.067,0.016-0.145,0.02-0.211,0.02h-0.01 c-0.068,0-0.139-0.004-0.213-0.02c0,0-0.004-0.002-0.015-0.002c-0.062-0.021-0.128-0.045-0.181-0.076l-2.783-1.684 c-0.052-0.027-0.096-0.07-0.119-0.107c-0.002-0.002-0.002-0.002-0.002-0.002c-0.026-0.049-0.04-0.09-0.04-0.139l-0.029,0.814 v0.004l0.007,0.02c0.003,0.027,0.003,0.033,0.006,0.047c0.005,0.014,0.01,0.023,0.012,0.033 c0.007,0.01,0.009,0.014,0.009,0.014l0.009,0.01c0.003,0.004,0.003,0.004,0.008,0.012c0.01,0.016,0.02,0.021,0.038,0.041 c0.016,0.021,0.042,0.033,0.063,0.053h0.009l2.788,1.689c0.04,0.027,0.076,0.047,0.121,0.057 c0.017,0.008,0.036,0.008,0.053,0.012l0.031,0.006c0.011,0.008,0.017,0.008,0.029,0.01c0.02,0.004,0.048,0.004,0.071,0.01 c0.02,0,0.047,0.01,0.063,0.01h0.065c0.022,0,0.035-0.01,0.055-0.01c0.022,0,0.043-0.006,0.057-0.006 c0.016-0.004,0.043-0.004,0.06-0.006l0.014-0.008c0.015,0,0.015,0,0.015,0c0.015-0.006,0.027-0.006,0.033-0.01 c0.029-0.004,0.05-0.014,0.076-0.027c0.028-0.006,0.058-0.023,0.089-0.043l0.145-0.084l-0.017,0.531v0.004 c0,0,0,0.016,0.002,0.025l0.003,0.037c0.007,0.018,0.013,0.025,0.018,0.035l0.013,0.018l0.005,0.004c0,0,0,0.012,0,0.016 c0.011,0.014,0.025,0.023,0.039,0.043c0.02,0.014,0.045,0.033,0.074,0.047l0.008,0.008l2.778,1.684 c0.04,0.027,0.08,0.041,0.125,0.059c0.02,0.002,0.058,0.014,0.058,0.014s0.013,0.002,0.025,0.002 c0.007,0.01,0.017,0.01,0.029,0.014c0.021,0,0.049,0,0.095,0.012c0,0,0.02,0,0.043,0.002h0.031h0.01h0.02 c0.02,0,0.042-0.002,0.06-0.002c0.017,0,0.054-0.012,0.054-0.012c0.025-0.004,0.043-0.004,0.06-0.006 c0.009-0.008,0.013-0.008,0.013-0.008l0.017-0.002c0.011,0,0.02-0.006,0.03-0.006c0.025-0.008,0.053-0.016,0.078-0.025 c0.035-0.006,0.058-0.025,0.087-0.043l0.229-0.133l-0.025,0.623v0.004c0,0,0,0.023,0.009,0.033c0,0,0.004,0.023,0.009,0.031 c0.002,0.016,0.007,0.025,0.011,0.035c0,0,0.005,0.012,0.011,0.02l0.003,0.006l0.003,0.006 c0.009,0.025,0.026,0.027,0.038,0.047c0.022,0.021,0.043,0.033,0.073,0.049l0.006,0.008l1.225,0.74 c-0.022,0.021-0.034,0.041-0.062,0.053l-2.24,1.297c-0.057,0.037-0.125,0.061-0.196,0.084h-0.006 c-0.068,0.016-0.143,0.02-0.216,0.02h-0.007c-0.067,0-0.137-0.004-0.197-0.02l-0.031-0.01 c-0.062-0.014-0.125-0.041-0.173-0.07l-9.384-5.682c-0.056-0.029-0.1-0.076-0.125-0.107v-0.006 c-0.029-0.041-0.043-0.082-0.042-0.129l-0.026,0.803v0.004c0,0,0,0.023,0.003,0.035l0.005,0.025 c0.002,0.021,0.009,0.029,0.012,0.041c0.006,0.012,0.012,0.018,0.019,0.02l0.004,0.006l0.003,0.012 c0.009,0.012,0.024,0.027,0.031,0.041c0.023,0.021,0.045,0.037,0.078,0.057h0.003l2.726,1.65 c-0.027,0.027-0.046,0.055-0.081,0.074l-2.244,1.301c-0.058,0.033-0.124,0.059-0.192,0.076h-0.011 c-0.063,0.016-0.136,0.02-0.207,0.02h-0.003c-0.073,0-0.143-0.008-0.209-0.018c-0.007-0.002-0.018-0.002-0.027-0.008 c-0.068-0.016-0.128-0.037-0.177-0.07l-3.007-1.816c-0.056-0.035-0.096-0.074-0.118-0.119h-0.005 c-0.024-0.045-0.036-0.08-0.036-0.129l-0.032,0.809l0.002,0.039c0,0,0.001,0.018,0.013,0.029 c0.005,0.008,0.007,0.018,0.011,0.031c0.005,0.01,0.009,0.01,0.009,0.01c0.005,0.02,0.005,0.02,0.005,0.02 c0.005,0.004,0.005,0.008,0.005,0.008c0.016,0.014,0.025,0.029,0.04,0.039c0.018,0.023,0.047,0.047,0.067,0.059l0.009,0.006 l1.829,1.104c-0.02,0.023-0.043,0.051-0.074,0.066l-5.659,3.273c-0.058,0.033-0.125,0.061-0.192,0.074l-0.01,0.01 c-0.065,0.014-0.138,0.02-0.21,0.02h-0.009c-0.072,0-0.136-0.006-0.201-0.02l-0.015-0.01c-0.076-0.018-0.139-0.041-0.19-0.068 l-2.106-1.277c-0.054-0.033-0.096-0.074-0.124-0.111v-0.006c-0.03-0.041-0.038-0.084-0.038-0.127l-0.025,0.803 c0,0-0.003,0.031,0.003,0.039l0.001,0.037c0.006,0.014,0.01,0.018,0.021,0.033c0,0,0.003,0.012,0.007,0.018l0.007,0.006 l0.001,0.01c0.013,0.008,0.025,0.023,0.035,0.037c0.023,0.025,0.047,0.043,0.076,0.055c0.008,0.006,0.008,0.006,0.008,0.006 l1.829,1.113c-0.028,0.02-0.044,0.047-0.08,0.063l-5.683,3.291c-0.054,0.029-0.123,0.057-0.192,0.072l-0.007,0.002 c-0.069,0.021-0.142,0.031-0.214,0.031h-0.011c-0.065,0-0.14-0.01-0.203-0.031l-0.025-0.002 c-0.067-0.016-0.125-0.043-0.174-0.072l-2.11-1.271c-0.056-0.033-0.096-0.07-0.118-0.113l-0.009-0.002 c-0.02-0.045-0.034-0.086-0.03-0.129l-0.033,0.805l0.003,0.043c0.005,0.004,0.005,0.02,0.009,0.029 c0.003,0.008,0.009,0.018,0.016,0.035l0.014,0.016v0.008l0.002,0.004c0.017,0.021,0.027,0.035,0.042,0.047 c0.016,0.025,0.042,0.041,0.067,0.057c0,0,0.005,0,0.009,0.006l2.107,1.273c0.037,0.02,0.078,0.041,0.124,0.057 c0.02,0.008,0.037,0.008,0.056,0.012c0.003,0.006,0.013,0.006,0.023,0.012l0.031,0.004c0.029,0.004,0.049,0.008,0.078,0.008 c0.018,0.012,0.038,0.012,0.058,0.012h0.116c0.021-0.012,0.043-0.012,0.087-0.016c0,0,0.014-0.004,0.032-0.008 c0.011,0,0.016,0,0.02-0.006h0.007c0.017-0.006,0.024-0.006,0.035-0.01c0.023-0.008,0.054-0.02,0.076-0.033 c0.028-0.008,0.062-0.023,0.083-0.037l3.595-2.072l-0.02,0.52v0.01c0,0,0,0.014,0.006,0.027c0,0,0.003,0.027,0.011,0.037 c0,0,0.002,0.025,0.009,0.029c0,0,0.01,0.014,0.015,0.023l0.001,0.004l0.006,0.012c0.009,0.016,0.021,0.025,0.035,0.043 c0.026,0.016,0.046,0.037,0.074,0.053h0.004l3.173,1.924c0.042,0.027,0.082,0.041,0.134,0.061 c0.015,0.004,0.028,0.006,0.05,0.012c0.009,0,0.023,0.006,0.023,0.006c0.01,0.008,0.02,0.008,0.034,0.008 c0.024,0.006,0.049,0.006,0.071,0.014c0.029,0,0.047,0,0.07,0h0.028h0.005h0.029c0.014,0,0.036-0.002,0.058-0.002 c0.018,0,0.056-0.006,0.056-0.006c0.02-0.006,0.04-0.006,0.052-0.012l0.026-0.002h0.003c0.015-0.006,0.027-0.006,0.04-0.012 c0.02-0.002,0.049-0.018,0.069-0.025c0.033-0.014,0.054-0.027,0.088-0.041l0.249-0.139l-0.026,0.639v0.006l0.008,0.027 c0,0,0.002,0.025,0.011,0.047c0,0,0.008,0.014,0.011,0.023c0.004,0.01,0.009,0.012,0.009,0.012 c0.003,0.008,0.003,0.008,0.003,0.008c0.004,0.008,0.004,0.016,0.004,0.016c0.018,0.016,0.029,0.027,0.044,0.041 c0.02,0.02,0.042,0.039,0.063,0.057l0.009,0.006l1.581,0.949c0.037,0.027,0.072,0.049,0.12,0.061 c0.017,0.006,0.038,0.006,0.052,0.01c0.009,0.004,0.02,0.004,0.029,0.01c0.011,0,0.022,0.004,0.034,0.004 c0.02,0.004,0.049,0.01,0.073,0.01c0.021,0.008,0.047,0.008,0.063,0.008h0.062c0.023,0,0.043,0,0.056-0.008 c0.022,0,0.042,0,0.062-0.006c0.018,0,0.036-0.004,0.058-0.008c0,0,0.011,0,0.017-0.006h0.009 c0.012-0.004,0.025-0.004,0.032-0.008c0.029-0.006,0.051-0.016,0.076-0.018c0.035-0.016,0.057-0.035,0.083-0.049l0.368-0.211 l-0.023,0.775v0.01c0,0,0,0.02,0.005,0.027c0,0,0.004,0.029,0.005,0.041c0,0,0.006,0.021,0.015,0.027 c0,0,0.005,0.02,0.009,0.023l0.008,0.004l0.007,0.004c0.007,0.025,0.02,0.035,0.029,0.053 c0.022,0.018,0.045,0.033,0.076,0.049h0.003l0.49,0.299c-0.023,0.023-0.036,0.045-0.07,0.059l-2.239,1.303 c-0.058,0.031-0.123,0.055-0.192,0.068c-0.008,0.006-0.008,0.006-0.008,0.006c-0.074,0.02-0.146,0.025-0.219,0.025h-0.005 c-0.071,0-0.144-0.006-0.201-0.025h-0.029c-0.067-0.018-0.125-0.043-0.179-0.074l-2.78-1.691 c-0.051-0.018-0.076-0.055-0.107-0.088l1.954-1.133c0.116-0.066,0.176-0.154,0.18-0.242l0.03-0.809 c-0.005,0.096-0.07,0.182-0.181,0.25l-2.244,1.301c-0.061,0.029-0.128,0.051-0.196,0.066l-0.003,0.01 c-0.075,0.02-0.143,0.023-0.216,0.023h-0.011c-0.065,0-0.14-0.004-0.203-0.023c-0.009,0-0.025,0-0.025,0 c-0.067-0.025-0.127-0.047-0.178-0.076l-2.784-1.682c-0.055-0.033-0.094-0.078-0.118-0.107c-0.003-0.01-0.003-0.01-0.003-0.01 c-0.025-0.043-0.038-0.082-0.038-0.133l-0.032,0.809l0.003,0.039c0.007,0.016,0.007,0.021,0.015,0.031 c0.002,0.018,0.011,0.02,0.011,0.029c0.003,0.018,0.011,0.023,0.011,0.023c0.005,0.004,0.003,0.012,0.003,0.012 c0.004,0.002,0.004,0.002,0.011,0.006c0.011,0.016,0.018,0.023,0.033,0.041c0.018,0.02,0.047,0.039,0.068,0.059h0.011 l2.78,1.684c0.04,0.025,0.08,0.047,0.128,0.068c0.011,0.002,0.047,0.002,0.047,0.002c0.011,0.012,0.022,0.012,0.022,0.012 c0.018,0.002,0.038,0.006,0.038,0.006c0.021,0.006,0.045,0.006,0.075,0.01c0.018,0,0.042,0.004,0.065,0.004h0.06 c0.022,0,0.036,0,0.055-0.004c0.023,0,0.043-0.004,0.056-0.004c0.021-0.006,0.042-0.006,0.063-0.01l0.013-0.002h0.013 c0.012-0.012,0.027-0.012,0.035-0.014c0.025,0,0.054-0.021,0.072-0.031c0.03-0.008,0.065-0.023,0.087-0.037l0.23-0.131 l-0.018,0.617v0.004v0.035c0.005,0.01,0.005,0.027,0.009,0.035c0.005,0.012,0.008,0.021,0.012,0.029 c0.005,0.008,0.013,0.021,0.013,0.021h0.007v0.018c0.014,0.01,0.029,0.029,0.038,0.039c0.02,0.021,0.045,0.043,0.075,0.059 l0.005,0.004l2.78,1.688c0.04,0.02,0.083,0.037,0.128,0.051c0.017,0.01,0.053,0.01,0.053,0.01 c0.007,0.008,0.013,0.008,0.037,0.016c0,0,0.009,0.004,0.02,0.004c0.025,0.004,0.051,0.008,0.098,0.008 c0,0,0.022,0.01,0.046,0.01h0.029h0.003h0.027c0.016,0,0.034,0,0.054-0.01c0.021,0,0.043,0,0.078-0.008 c0,0,0.021,0,0.042-0.004l0.02-0.008h0.001c0.015-0.008,0.027-0.008,0.042-0.012c0.025-0.006,0.049-0.016,0.072-0.023 c0.029-0.01,0.061-0.023,0.085-0.047l0.27-0.154l-0.025,0.678l0.005,0.023c0.004,0.023,0.004,0.033,0.007,0.043 c0.008,0.014,0.011,0.023,0.019,0.033c0.003,0.01,0.005,0.014,0.011,0.02v0.006c0.006,0.008,0.006,0.012,0.006,0.012 c0.018,0.014,0.023,0.023,0.038,0.039c0.02,0.021,0.043,0.041,0.067,0.059c0,0,0.009,0,0.014,0.006l2.779,1.682 c0.042,0.027,0.082,0.045,0.127,0.064c0.017,0.002,0.034,0,0.05,0.002c0.009,0.008,0.02,0.008,0.029,0.008 c0.009,0.006,0.03,0.006,0.03,0.006c0.024,0.01,0.047,0.014,0.073,0.014c0.021,0,0.043,0.006,0.065,0.006h0.058 c0.022,0,0.038,0,0.058-0.006c0.02,0,0.042,0,0.055-0.004c0.023,0,0.043-0.01,0.063-0.016l0.022-0.004h0.009 c0.007-0.004,0.023-0.004,0.03-0.006c0.027-0.008,0.049-0.018,0.073-0.027c0.031-0.006,0.063-0.029,0.089-0.047l0.229-0.125 l-0.021,0.619v0.004c0,0-0.002,0.018,0.005,0.031c0,0.018,0.008,0.029,0.008,0.029c0,0.021,0.007,0.029,0.009,0.043 l0.013,0.014l0.009,0.008l0.002,0.016c0.015,0.01,0.026,0.027,0.035,0.035c0.018,0.02,0.045,0.049,0.075,0.063h0.008 l2.78,1.682c0.037,0.025,0.08,0.041,0.125,0.057c0.017,0.018,0.033,0.018,0.055,0.018c0.01,0.002,0.012,0.002,0.021,0.006 c0.012,0,0.021,0.006,0.021,0.006c0.038,0.006,0.062,0.014,0.087,0.014c0.02,0.006,0.038,0.006,0.067,0.006h0.029h0.008h0.022 c0.016,0,0.038,0,0.054-0.006c0.025,0,0.042,0,0.08-0.008c0,0,0.019-0.006,0.045-0.012c0,0,0.003,0,0.016-0.004h0.004 c0.014-0.002,0.025-0.002,0.036-0.012c0.025-0.008,0.052-0.016,0.072-0.027c0.029-0.012,0.062-0.025,0.087-0.039l0.232-0.131 l-0.016,0.627l-0.006,0.004v0.027c0.006,0.01,0.009,0.02,0.009,0.02c0.007,0.031,0.01,0.043,0.015,0.049 c0,0,0.008,0.016,0.012,0.021l0.002,0.002c0,0,0,0.008,0.011,0.01c0.007,0.008,0.02,0.035,0.03,0.047 c0.023,0.016,0.048,0.035,0.077,0.049l0.002,0.002l18.729,11.346c0.042,0.023,0.083,0.041,0.13,0.059 c0.015,0.002,0.033,0.002,0.055,0.008c0.003,0.004,0.016,0.004,0.023,0.016c0.009,0,0.023,0,0.023,0 c0.032,0.004,0.057,0.012,0.085,0.012c0.018,0.004,0.038,0.004,0.061,0.004h0.058c0.019,0,0.042,0,0.054,0 c0.022,0,0.042,0,0.064-0.012c0.02,0,0.032-0.004,0.056-0.012l0.017-0.004c0.009,0,0.009,0,0.009,0 c0.014-0.004,0.027-0.004,0.038-0.01c0.025-0.002,0.051-0.02,0.075-0.023c0.034-0.014,0.06-0.029,0.088-0.043l0.232-0.135 l-0.028,0.627c0,0,0,0.025,0.004,0.037c0,0,0.009,0.018,0.009,0.029c0,0,0.007,0.029,0.016,0.039c0,0,0.002,0.012,0.006,0.018 v0.002l0.013,0.014l0.034,0.033c0.02,0.027,0.043,0.043,0.071,0.061l0.011,0.004l2.78,1.686 c0.037,0.02,0.078,0.047,0.128,0.063c0.013,0.004,0.026,0.004,0.051,0.01c0.007,0.004,0.013,0.004,0.034,0.008 c0,0,0.009,0.002,0.025,0.002c0.02,0.008,0.045,0.012,0.073,0.012c0.021,0.004,0.043,0.004,0.064,0.004h0.029 c0.007,0,0.007,0,0.007,0h0.087c0.015-0.004,0.035-0.004,0.056-0.008c0.022,0,0.037-0.008,0.064-0.01c0,0,0.007,0,0.013-0.004 h0.007c0.015-0.004,0.023-0.004,0.033-0.01c0.024-0.004,0.053-0.02,0.071-0.023c0.033-0.02,0.063-0.029,0.089-0.043 l0.231-0.135l-0.025,0.621v0.006c0,0,0,0.023,0.011,0.031c0,0,0.001,0.029,0.006,0.039c0,0,0.004,0.018,0.015,0.033 l0.009,0.012l0.001,0.014l0.007,0.008c0.009,0.018,0.021,0.027,0.034,0.041c0.021,0.016,0.045,0.037,0.074,0.055l0.004,0.004 l2.78,1.686c0.042,0.023,0.085,0.037,0.13,0.051c0.017,0.01,0.037,0.014,0.052,0.023l0.026,0.006 c0.01,0.004,0.018,0.004,0.027,0.008c0.029,0.004,0.055,0.004,0.078,0.01c0.021,0,0.042,0,0.067,0.004h0.029h0.009h0.02 c0.018-0.004,0.056-0.004,0.056-0.004c0.022,0,0.034-0.006,0.063-0.006c0.014-0.008,0.032-0.008,0.058-0.008 c0.004-0.004,0.007-0.004,0.019-0.004l0.014-0.016c0,0,0.019-0.004,0.025-0.004c0.031-0.01,0.048-0.014,0.078-0.023 c0.027-0.008,0.06-0.023,0.085-0.041l0.227-0.137l-0.021,0.623v0.004v0.031c0.008,0.014,0.008,0.025,0.013,0.037 c0.001,0.016,0.007,0.023,0.01,0.035c0.006,0.004,0.013,0.02,0.013,0.02v0.004c0.009,0.008,0.009,0.008,0.013,0.014 c0.01,0.016,0.018,0.023,0.032,0.043c0.023,0.02,0.045,0.033,0.075,0.055c0,0,0,0,0.007,0.004l2.782,1.678 c0.035,0.029,0.079,0.043,0.125,0.059c0.013,0.004,0.035,0.016,0.047,0.016s0.029,0.002,0.029,0.002 c0.013,0.01,0.024,0.01,0.035,0.01c0.02,0.008,0.044,0.008,0.069,0.014c0.025,0,0.043,0.006,0.065,0.006h0.06 c0.022,0,0.043-0.006,0.08-0.006c0,0,0.021-0.006,0.04-0.006c0.02-0.008,0.043-0.008,0.061-0.008l0.015-0.01h0.007 c0.015-0.002,0.022-0.002,0.04-0.01c0.025-0.008,0.046-0.01,0.072-0.023c0.029-0.008,0.058-0.027,0.081-0.045l0.237-0.131 l-0.023,0.627c0.007,0.008,0.003,0.029,0.003,0.029c0.005,0.021,0.004,0.027,0.009,0.039c0.004,0.014,0.009,0.025,0.015,0.037 c0,0,0.009,0.008,0.016,0.018v0.004c0.004,0.002,0.004,0.014,0.007,0.018c0.009,0.01,0.02,0.021,0.035,0.033 c0.019,0.018,0.043,0.043,0.069,0.055l0.011,0.01l2.782,1.68c0.031,0.025,0.073,0.043,0.125,0.057 c0.015,0.01,0.047,0.016,0.047,0.016c0.011,0.004,0.023,0.004,0.031,0.006l0.02,0.008c0.038,0.002,0.067,0.01,0.085,0.01 c0.021,0.004,0.044,0.004,0.069,0.004h0.12c0.017-0.004,0.039-0.004,0.051-0.012c0.023,0,0.043-0.002,0.063-0.01h0.013 c0.007-0.002,0.007-0.002,0.007-0.002c0.018,0,0.032-0.004,0.04-0.01c0.029-0.01,0.047-0.014,0.073-0.023 c0.032-0.014,0.062-0.027,0.09-0.043l0.221-0.123l-0.017,0.609v0.039c0.004,0.008,0.004,0.016,0.01,0.029 c0,0.012,0.007,0.029,0.012,0.039c0.006,0.006,0.011,0.01,0.016,0.016v0.004c0,0.006,0,0.01,0.01,0.014 c0.007,0.008,0.016,0.027,0.034,0.043c0.017,0.016,0.04,0.035,0.073,0.051l0.003,0.004l2.161,1.311 c0.034,0.02,0.078,0.041,0.126,0.059c0.017,0.002,0.032,0.008,0.051,0.012l0.018,0.004l0.026,0.004 c0.032,0.006,0.061,0.016,0.083,0.016c0.021,0.004,0.047,0.004,0.069,0.004h0.027h0.016h0.073 c0.02-0.004,0.04-0.004,0.06-0.014c0.024,0,0.038-0.006,0.06-0.01h0.021c0.004-0.004,0.004-0.004,0.004-0.004l0.034-0.01 c0.026-0.002,0.053-0.014,0.077-0.02c0.025-0.018,0.06-0.027,0.085-0.041l2.245-1.303c0.115-0.063,0.175-0.154,0.178-0.246 l0.029-0.762c0,0,0.025,0,0.035-0.006c0.021,0,0.04-0.004,0.062-0.008h0.015c0.007-0.004,0.007-0.004,0.007-0.004 c0.015,0,0.027-0.008,0.04-0.012c0.022-0.004,0.047-0.012,0.072-0.021c0.026-0.018,0.057-0.031,0.083-0.041l2.24-1.297 c0.12-0.076,0.18-0.164,0.185-0.254l0.022-0.58l0.87,0.527c0.04,0.027,0.08,0.043,0.125,0.053 c0.016,0.02,0.036,0.02,0.05,0.02l0.031,0.006c0.007,0.008,0.02,0.008,0.029,0.008c0.025,0.004,0.05,0.004,0.074,0.014 c0.024,0,0.044,0.006,0.071,0.006h0.058c0.015,0,0.035,0,0.074-0.006c0,0,0.026,0,0.04-0.01 c0.017-0.004,0.038-0.004,0.058-0.01l0.017-0.002h0.015c0.007-0.006,0.021-0.006,0.034-0.016 c0.026-0.006,0.048-0.014,0.067-0.025c0.031-0.006,0.063-0.025,0.084-0.037l2.246-1.295c0.119-0.072,0.179-0.164,0.179-0.252 l0.022-0.535l0.158,0.102c0.036,0.016,0.082,0.037,0.126,0.049c0.018,0.008,0.037,0.008,0.062,0.016c0,0,0.008,0,0.014,0.008 c0.017,0,0.021,0.004,0.021,0.004c0.038,0.012,0.06,0.016,0.085,0.016c0.018,0.006,0.047,0.006,0.067,0.006h0.031h0.009h0.025 c0.017,0,0.035,0,0.051-0.006c0.022,0,0.044,0,0.062-0.004c0.02,0,0.042-0.012,0.054-0.016l0.019-0.008 c0.011,0,0.011,0,0.011,0c0.013-0.008,0.025-0.008,0.034-0.012c0.026-0.004,0.051-0.012,0.082-0.021 c0.021-0.01,0.056-0.025,0.083-0.039l2.236-1.299c0.124-0.061,0.182-0.158,0.184-0.248l0.02-0.541l0.168,0.098 c0.031,0.027,0.076,0.047,0.124,0.061c0.013,0.006,0.031,0.008,0.047,0.014c0.012,0,0.025,0.004,0.025,0.004 c0.011,0.006,0.021,0.006,0.032,0.01c0.026,0,0.049,0.006,0.075,0.01h0.068c0.011,0.004,0.017,0.004,0.017,0.004 c0.018,0,0.018,0,0.018,0h0.025c0.018-0.004,0.038-0.004,0.074-0.004c0,0,0.024-0.004,0.044-0.004 c0.018-0.006,0.032-0.01,0.054-0.01c0.007-0.006,0.01-0.006,0.01-0.006l0.025-0.004c0,0,0.019-0.006,0.026-0.006 c0.027-0.008,0.054-0.01,0.073-0.021c0.03-0.014,0.057-0.033,0.079-0.047l2.248-1.301c0.12-0.066,0.181-0.15,0.185-0.244 l0.029-0.805c-0.007,0.092-0.067,0.184-0.185,0.256l-2.242,1.293c-0.056,0.029-0.123,0.063-0.192,0.076h-0.007 c-0.071,0.018-0.147,0.023-0.218,0.023h-0.003c-0.072,0-0.137-0.012-0.205-0.021c-0.009-0.002-0.02-0.002-0.03-0.01 c-0.06-0.012-0.12-0.039-0.176-0.068l-6.086-3.682c-0.051-0.031-0.093-0.074-0.116-0.111h-0.001 c-0.006-0.02-0.006-0.023-0.011-0.037l1.921-1.109c0.12-0.072,0.176-0.164,0.179-0.252l0.02-0.547l2.231,1.346 c0.039,0.023,0.079,0.047,0.125,0.063c0.012,0.004,0.038,0.008,0.052,0.012l0.027,0.008c0.012,0,0.022,0.002,0.032,0.008 c0.022,0,0.049,0.006,0.076,0.02h0.087h0.017h0.017h0.056c0.02,0,0.042-0.014,0.056-0.014c0.02-0.006,0.042-0.012,0.06-0.012 c0.007-0.002,0.019-0.002,0.019-0.002l0.018-0.008c0,0,0.011-0.004,0.029-0.004c0.014-0.008,0.045-0.012,0.071-0.023 c0.029-0.012,0.056-0.025,0.083-0.047l0.237-0.129l-0.027,0.619l0.002,0.039c0,0,0.003,0.018,0.011,0.027 c0.005,0.01,0.009,0.023,0.016,0.043l0.006,0.01c0.009,0.008,0.009,0.008,0.009,0.008s0,0.014,0.004,0.016 c0.013,0.008,0.021,0.021,0.036,0.031c0.02,0.02,0.045,0.047,0.069,0.063l0.011,0.004l2.78,1.682 c0.043,0.021,0.082,0.041,0.129,0.063c0.017,0.004,0.037,0.012,0.051,0.016l0.018,0.004c0.018,0,0.029,0.006,0.04,0.01 c0.027,0,0.049,0.004,0.078,0.008c0.025,0,0.043,0,0.067,0.006h0.058c0.022,0,0.053-0.006,0.053-0.006 c0.023,0,0.044-0.004,0.058-0.004c0.021-0.004,0.043-0.004,0.062-0.008l0.01-0.006c0.012,0,0.012,0,0.012,0 c0.018-0.008,0.029-0.008,0.043-0.008c0.02-0.018,0.047-0.018,0.065-0.033c0.031-0.012,0.062-0.023,0.088-0.041l0.062-0.035 l2.181-1.262c0.118-0.068,0.176-0.156,0.181-0.242l0.02-0.545l1.463,0.889c0.034,0.02,0.081,0.035,0.126,0.053 c0.015,0.004,0.033,0.004,0.049,0.02c0.013,0.004,0.024,0.004,0.027,0.008l0.027,0.004c0.031,0.006,0.049,0.008,0.078,0.008 c0.02,0.008,0.045,0.008,0.065,0.008h0.033h0.009h0.077c0.021-0.008,0.04-0.01,0.061-0.01c0.017,0,0.037-0.006,0.058-0.014 c0.004,0,0.021,0,0.021,0h0.005c0.012-0.004,0.021-0.004,0.035-0.02c0.023-0.004,0.048-0.014,0.072-0.021 c0.033-0.014,0.06-0.021,0.09-0.041l2.239-1.295c0.124-0.068,0.182-0.164,0.183-0.252l0.023-0.793 c-0.002,0.086-0.069,0.174-0.177,0.236L172.014,407.818z M120.144,381.914l-3.013,1.744l-0.027,0.801l1.046-0.604l-0.027,0.67 c0,0,0,0.023,0.003,0.039c0,0,0.005,0.018,0.009,0.027c0.005,0.01,0.011,0.021,0.02,0.045c0,0,0,0.004,0.002,0.012 c0.009,0.006,0.009,0.006,0.009,0.006l0.003,0.012c0.011,0.016,0.022,0.025,0.039,0.035c0.02,0.02,0.045,0.047,0.067,0.063 c0,0,0.005,0,0.011,0.004l1.204,0.725c-0.02,0.025-0.029,0.041-0.054,0.055l-2.244,1.301 c-0.061,0.027-0.125,0.059-0.195,0.076h-0.005c-0.076,0.02-0.147,0.021-0.224,0.021h-0.003c-0.07,0-0.132-0.002-0.207-0.018 l-0.016-0.004c-0.071-0.018-0.132-0.049-0.187-0.076l-5.5-3.334c-0.058-0.027-0.096-0.072-0.125-0.111c0,0,0,0-0.005-0.006 c-0.022-0.031-0.037-0.084-0.033-0.123l-0.027,0.801v0.008l-0.001,0.037c0.003,0.002,0.007,0.012,0.007,0.012 c0.007,0.035,0.011,0.041,0.016,0.051c0.006,0.006,0.011,0.014,0.013,0.023c0,0,0,0,0.008,0l0.003,0.016 c0.011,0.02,0.027,0.027,0.037,0.039c0.018,0.02,0.042,0.037,0.068,0.055h0.01l2.506,1.521 c-0.021,0.016-0.03,0.035-0.058,0.049l-2.238,1.309c-0.06,0.023-0.129,0.053-0.192,0.066h-0.007 c-0.074,0.016-0.143,0.027-0.221,0.027h-0.005c-0.07,0-0.136-0.012-0.202-0.021c-0.006-0.006-0.02-0.006-0.025-0.01 c-0.065-0.016-0.127-0.039-0.18-0.063l-3.665-2.23c-0.058-0.027-0.098-0.074-0.124-0.111c0,0,0,0-0.009-0.004 c-0.013-0.02-0.011-0.049-0.015-0.076l1.863-1.08c0.116-0.07,0.176-0.158,0.182-0.25l0.018-0.518l0.146,0.09 c0.036,0.023,0.08,0.035,0.126,0.055c0.013,0.004,0.031,0.01,0.047,0.02c0.007,0,0.02,0,0.035,0 c0.005,0.006,0.016,0.006,0.029,0.016c0.021,0.002,0.048,0.002,0.075,0.002c0.02,0,0.045,0,0.067,0.01h0.058 c0.023,0,0.042-0.01,0.057-0.01c0.017,0,0.042-0.002,0.06-0.002c0.017-0.008,0.035-0.008,0.058-0.01l0.017-0.006h0.001 c0.017-0.006,0.035-0.006,0.04-0.01c0.029-0.01,0.048-0.016,0.076-0.033c0.029-0.004,0.054-0.018,0.083-0.039l2.242-1.289 c0.118-0.074,0.178-0.164,0.179-0.25l0.024-0.561l1.011,0.613c0.042,0.02,0.082,0.043,0.127,0.057 c0.014,0.01,0.038,0.01,0.052,0.016c0.008,0.004,0.019,0.004,0.031,0.008l0.017,0.006c0.036,0.004,0.063,0.008,0.088,0.008 c0.018,0.006,0.041,0.006,0.062,0.006h0.029h0.011h0.019c0.025,0,0.04,0,0.058-0.006c0.02,0,0.042,0,0.054-0.004 c0.021,0,0.038-0.004,0.063-0.01c0,0,0.009,0,0.017-0.004h0.009c0.008-0.004,0.02-0.004,0.034-0.01 c0.022-0.014,0.045-0.02,0.075-0.029c0.03-0.01,0.057-0.021,0.083-0.037l2.246-1.299c0.114-0.072,0.177-0.164,0.187-0.254 l0.013-0.568l2.417,1.469c0.038,0.018,0.083,0.039,0.132,0.053c0.013,0.008,0.028,0.008,0.048,0.016 c0.01,0.006,0.014,0.006,0.036,0.006c0,0,0.015,0.01,0.026,0.01c0.025,0.002,0.044,0.002,0.072,0.002 c0.018,0.01,0.043,0.01,0.062,0.01h0.119c0.02-0.01,0.037-0.01,0.057-0.01c0.021,0,0.04-0.002,0.058-0.012h0.018h0.008 c0.014-0.006,0.026-0.006,0.036-0.014c0.025-0.008,0.051-0.016,0.069-0.021c0.032-0.016,0.063-0.027,0.088-0.047l0.253-0.146 l-0.017,0.643v0.008c0,0,0,0.027,0.003,0.037l0.007,0.037c0.002,0.01,0.005,0.016,0.015,0.029c0,0,0.009,0.012,0.01,0.021 l0.006,0.008l0.005,0.004c0.011,0.02,0.024,0.033,0.031,0.047c0.029,0.016,0.054,0.039,0.08,0.059h0.007l0.412,0.242 C120.186,381.867,120.17,381.895,120.144,381.914z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M105.582,381.186c-0.027-0.016-0.05-0.035-0.072-0.055c-0.013-0.012-0.024-0.025-0.036-0.045 c-0.004,0-0.006-0.002-0.006-0.002l-0.003-0.014c0,0-0.007-0.008-0.009-0.018c-0.007-0.008-0.014-0.02-0.017-0.027 c-0.002-0.016-0.003-0.025-0.012-0.051v-0.021v-0.002l0.025-0.627l-3.357,1.941c0.025,0.037,0.06,0.07,0.11,0.098l3.005,1.824 c0.048,0.027,0.108,0.055,0.185,0.068c0,0,0.012,0.004,0.021,0.01c0.067,0.014,0.136,0.02,0.199,0.02h0.005 c0.076,0,0.148-0.006,0.217-0.02l0.009-0.006c0.07-0.018,0.136-0.039,0.192-0.072l2.246-1.299 c0.02-0.012,0.025-0.023,0.043-0.039l-2.741-1.656L105.582,381.186z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M109.872,379.693c-0.029-0.021-0.054-0.033-0.07-0.053c-0.018-0.014-0.027-0.031-0.035-0.047 l-0.01-0.01l-0.002-0.004c-0.001-0.006-0.011-0.016-0.013-0.02c-0.005-0.01-0.013-0.021-0.015-0.033 c-0.003-0.018-0.007-0.037-0.007-0.037l-0.004-0.033v-0.004l0.02-0.547l-0.173,0.098c-0.027,0.014-0.054,0.033-0.085,0.047 c-0.021,0.006-0.049,0.014-0.074,0.02c-0.009,0.01-0.022,0.01-0.035,0.014h-0.005c-0.006,0-0.013,0-0.02,0.008 c-0.018,0.002-0.04,0.002-0.058,0.006c-0.018,0-0.037,0.004-0.058,0.01c-0.018,0-0.056,0-0.056,0c-0.007,0-0.02,0-0.02,0 h-0.009h-0.035c-0.017,0-0.038,0-0.06-0.006c-0.025-0.004-0.05-0.004-0.072-0.008c-0.015,0-0.035-0.01-0.035-0.01l-0.03-0.004 c-0.011-0.006-0.029-0.01-0.043-0.016c-0.048-0.014-0.093-0.033-0.131-0.061l-1.077-0.645l-0.018,0.555 c-0.007,0.09-0.067,0.18-0.187,0.25l-1.946,1.123c0.028,0.037,0.057,0.074,0.105,0.104l3.009,1.818 c0.054,0.027,0.114,0.051,0.177,0.07c0.009,0.002,0.02,0.002,0.027,0.008c0.065,0.016,0.134,0.023,0.204,0.023h0.008 c0.076,0,0.147-0.008,0.214-0.023l0.013-0.006c0.063-0.016,0.129-0.039,0.19-0.072l2.24-1.297 c0.035-0.021,0.049-0.045,0.075-0.063l-1.896-1.152L109.872,379.693z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M111.991,377.465c-0.001,0.084-0.063,0.176-0.187,0.242l-1.957,1.137 c0.021,0.014,0.037,0.033,0.058,0.049l3.007,1.82c0.055,0.037,0.114,0.057,0.174,0.074l0.033,0.004 c0.063,0.018,0.132,0.029,0.203,0.029h0.009c0.067,0,0.14-0.012,0.21-0.029l0.009-0.004c0.068-0.014,0.136-0.037,0.193-0.074 l2.239-1.299c0.037-0.021,0.06-0.045,0.085-0.066l-4.056-2.459L111.991,377.465z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M117.39,387.516l-0.229,0.129c-0.031,0.016-0.058,0.035-0.087,0.047 c-0.025,0.01-0.045,0.02-0.076,0.025c-0.007,0-0.022,0.008-0.032,0.008l-0.009,0.002c-0.009,0-0.012,0-0.019,0.008 c-0.023,0-0.041,0.002-0.059,0.01c-0.021,0-0.038,0.002-0.06,0.002c-0.019,0-0.038,0.004-0.065,0.004h-0.011h-0.005 c-0.013,0-0.037,0-0.037,0c-0.02,0-0.04-0.004-0.064-0.004c-0.022-0.002-0.045-0.002-0.073-0.012c-0.009,0-0.021,0-0.03-0.008 l-0.028-0.002c-0.014-0.008-0.034-0.012-0.05-0.014c-0.045-0.016-0.089-0.035-0.127-0.059l-2.878-1.744l-0.018,0.533 c-0.009,0.086-0.065,0.182-0.186,0.256l-1.93,1.115c0,0,0,0.004,0.004,0.008l0.005,0.006c0.023,0.037,0.065,0.078,0.12,0.113 l2.784,1.678c0.049,0.037,0.108,0.061,0.181,0.076c0,0,0.012,0.004,0.023,0.008c0.063,0.014,0.125,0.02,0.197,0.02h0.009 c0.072,0,0.145-0.006,0.212-0.023l0.011-0.004c0.068-0.016,0.134-0.039,0.192-0.076l2.24-1.297 c0.043-0.023,0.071-0.049,0.094-0.076c-0.005-0.016-0.007-0.025-0.009-0.033c-0.009-0.01-0.009-0.025-0.009-0.035 l-0.001-0.037v-0.004L117.39,387.516z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M119.378,393.561c-0.031-0.02-0.052-0.039-0.072-0.055c-0.015-0.012-0.024-0.023-0.034-0.041 c0,0-0.003-0.008-0.011-0.018h-0.002c-0.002-0.006-0.003-0.014-0.01-0.016c-0.006-0.01-0.009-0.023-0.012-0.033 c-0.005-0.01-0.01-0.039-0.01-0.039l-0.002-0.033v-0.004l0.022-0.621l-0.236,0.135c-0.029,0.014-0.053,0.023-0.083,0.037 c-0.023,0.012-0.049,0.02-0.075,0.027c-0.01,0.008-0.025,0.008-0.038,0.012l-0.004,0.004h-0.014 c-0.025,0.004-0.043,0.008-0.062,0.012c-0.021,0-0.04,0.004-0.056,0.004c-0.02,0-0.042,0-0.062,0h-0.02h-0.009h-0.035 c-0.022,0-0.039,0-0.064,0c-0.023-0.004-0.049-0.004-0.072-0.012l-0.044-0.004c0,0-0.005-0.004-0.016-0.008 c-0.018-0.008-0.035-0.008-0.053-0.016c-0.045-0.01-0.085-0.033-0.125-0.057l-1.498-0.902l-0.02,0.578 c-0.001,0.096-0.063,0.184-0.181,0.244l-1.95,1.131c0.025,0.035,0.058,0.066,0.108,0.1l2.782,1.684 c0.05,0.029,0.112,0.049,0.178,0.07c0.009,0.004,0.027,0.004,0.027,0.004c0.064,0.021,0.132,0.025,0.2,0.025h0.009 c0.075,0,0.144-0.01,0.212-0.025h0.011c0.067-0.021,0.132-0.045,0.192-0.074l2.241-1.301c0.043-0.025,0.067-0.051,0.092-0.078 l-1.203-0.73H119.378z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M123.365,395.971c-0.029-0.016-0.057-0.035-0.075-0.057c-0.017-0.012-0.027-0.021-0.038-0.037 c-0.003-0.004-0.003-0.01-0.007-0.014v-0.008c-0.009-0.002-0.013-0.006-0.013-0.016c-0.007-0.012-0.011-0.023-0.015-0.037 c-0.006-0.01-0.006-0.02-0.012-0.043v-0.023v-0.006l0.02-0.617l-0.229,0.133c-0.025,0.018-0.054,0.031-0.08,0.045 c-0.027,0.01-0.047,0.014-0.075,0.021c-0.009,0-0.025,0.008-0.038,0.008l-0.006,0.006l-0.015,0.002 c-0.023,0-0.038,0.01-0.058,0.01c-0.021,0.008-0.039,0.008-0.063,0.008c-0.018,0.006-0.034,0.006-0.054,0.006h-0.029h-0.004 h-0.03c-0.02,0-0.042-0.006-0.063-0.006c-0.026,0-0.049-0.008-0.074-0.008c-0.012-0.01-0.022-0.01-0.044-0.018h-0.02 c-0.017-0.008-0.033-0.01-0.047-0.016c-0.047-0.014-0.093-0.031-0.131-0.059l-1.495-0.902l-0.019,0.576 c-0.008,0.092-0.065,0.182-0.185,0.254l-1.949,1.123c0.031,0.039,0.058,0.07,0.105,0.1l2.782,1.682 c0.053,0.035,0.109,0.059,0.187,0.07c0,0,0.009,0.006,0.021,0.01c0.062,0.014,0.13,0.018,0.196,0.018h0.01 c0.073,0,0.146-0.004,0.218-0.021h0.005c0.069-0.018,0.134-0.035,0.191-0.08l2.241-1.297c0.042-0.018,0.067-0.045,0.089-0.078 l-1.196-0.723L123.365,395.971z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M127.346,398.389c-0.031-0.023-0.055-0.037-0.072-0.061c-0.013-0.014-0.027-0.025-0.033-0.033 c-0.001-0.01-0.011-0.021-0.011-0.021l-0.001-0.002c-0.001-0.006-0.011-0.008-0.013-0.018 c-0.005-0.012-0.007-0.02-0.015-0.035c-0.003-0.008-0.005-0.023-0.007-0.047v-0.023v-0.004l0.02-0.621l-0.237,0.135 c-0.023,0.014-0.056,0.027-0.083,0.047c-0.024,0.004-0.047,0.014-0.073,0.018c-0.009,0.008-0.021,0.01-0.038,0.01 l-0.011,0.006h-0.016c-0.016,0.004-0.032,0.01-0.055,0.014c-0.022,0-0.038,0-0.057,0.004c-0.02,0.002-0.037,0.002-0.058,0.002 c-0.006,0-0.022,0-0.022,0h-0.008h-0.031c-0.021,0-0.044,0-0.063-0.006c-0.027,0-0.055-0.004-0.089-0.01 c0,0-0.009-0.004-0.016-0.004l-0.029-0.006c-0.016-0.01-0.033-0.01-0.053-0.014c-0.043-0.014-0.088-0.037-0.125-0.061 l-1.497-0.906l-0.021,0.584c-0.003,0.09-0.069,0.184-0.183,0.246l-1.948,1.129c0.026,0.031,0.058,0.07,0.105,0.098 l2.782,1.684c0.054,0.029,0.11,0.059,0.179,0.072c0.009,0.002,0.02,0.002,0.026,0.008c0.067,0.01,0.136,0.018,0.205,0.025 h0.009c0.069-0.008,0.144-0.012,0.214-0.031h0.009c0.063-0.014,0.136-0.045,0.192-0.074l2.242-1.295 c0.04-0.023,0.065-0.057,0.087-0.08l-1.202-0.729H127.346z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M131.328,400.797c-0.029-0.02-0.05-0.039-0.074-0.055c-0.013-0.02-0.024-0.031-0.031-0.043 c-0.003-0.008-0.005-0.012-0.005-0.012l-0.008-0.002c-0.005-0.004-0.007-0.014-0.007-0.014 c-0.009-0.016-0.012-0.027-0.016-0.045c-0.005-0.01-0.009-0.029-0.009-0.029l-0.002-0.033v-0.006l0.019-0.621l-0.23,0.135 c-0.026,0.018-0.053,0.027-0.084,0.037c-0.023,0.014-0.045,0.018-0.072,0.029c-0.011,0-0.023,0.002-0.04,0.012h-0.006 l-0.016,0.008c-0.015,0-0.038,0.002-0.078,0.008c0,0-0.02,0.004-0.039,0.004c-0.018,0-0.038,0.004-0.06,0.004h-0.025h-0.002 c-0.011,0-0.02,0-0.032,0c-0.022-0.004-0.042-0.004-0.066-0.004c-0.023-0.004-0.049-0.004-0.083-0.012c0,0-0.01,0-0.029-0.008 c0,0-0.009,0-0.023-0.01c-0.015-0.002-0.033-0.008-0.048-0.014c-0.045-0.014-0.088-0.033-0.126-0.053l-1.496-0.906 l-0.021,0.576c-0.002,0.096-0.067,0.184-0.183,0.25l-1.949,1.133c0.032,0.029,0.058,0.064,0.105,0.09l2.782,1.689 c0.051,0.029,0.113,0.053,0.178,0.07c0.009,0,0.015,0,0.027,0.002c0.067,0.021,0.132,0.033,0.199,0.033h0.011 c0.075,0,0.143-0.021,0.214-0.035h0.007c0.069-0.018,0.136-0.041,0.189-0.07l2.244-1.305c0.04-0.025,0.064-0.047,0.089-0.074 l-1.198-0.73H131.328z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M135.325,403.215c-0.027-0.012-0.052-0.043-0.072-0.055c-0.015-0.014-0.027-0.031-0.036-0.043 c-0.002-0.004-0.006-0.012-0.006-0.012v-0.002c-0.009-0.006-0.014-0.023-0.014-0.023c-0.007-0.01-0.011-0.023-0.017-0.033 s-0.007-0.031-0.007-0.031c-0.003-0.016-0.003-0.039-0.003-0.039v-0.004l0.02-0.631l-0.241,0.139 c-0.028,0.016-0.058,0.035-0.088,0.041c-0.026,0.018-0.043,0.021-0.073,0.029c-0.011,0-0.019,0.004-0.033,0.004h-0.008 c-0.004,0.008-0.021,0.012-0.021,0.012c-0.015,0.004-0.036,0.004-0.058,0.01c-0.018,0-0.038,0.002-0.055,0.002 c-0.021,0-0.041,0.006-0.057,0.006h-0.018h-0.011c-0.011,0-0.033,0-0.033,0c-0.02,0-0.044-0.006-0.065-0.006 c-0.025-0.002-0.051-0.002-0.074-0.008c-0.011-0.004-0.022-0.004-0.041-0.016c0,0-0.008,0-0.018,0 c-0.021-0.004-0.036-0.012-0.053-0.012c-0.046-0.016-0.086-0.035-0.123-0.063l-1.501-0.904l-0.016,0.582 c-0.004,0.088-0.069,0.184-0.187,0.252l-1.944,1.123c0.027,0.037,0.063,0.076,0.117,0.107l2.781,1.678 c0.051,0.039,0.111,0.061,0.178,0.08h0.027c0.063,0.016,0.133,0.025,0.201,0.025h0.009c0.073,0,0.148-0.01,0.212-0.025h0.009 c0.073-0.018,0.135-0.041,0.192-0.08l2.244-1.295c0.04-0.021,0.064-0.057,0.089-0.084l-1.202-0.719L135.325,403.215z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M139.305,405.619c-0.025-0.014-0.05-0.033-0.07-0.047c-0.013-0.014-0.025-0.033-0.038-0.045 c0,0-0.002-0.006-0.005-0.012l-0.002-0.002c-0.001-0.014-0.008-0.016-0.008-0.016c-0.006-0.014-0.015-0.027-0.019-0.037 c-0.002-0.016-0.004-0.037-0.004-0.037c-0.006-0.01-0.009-0.035-0.009-0.035v-0.002l0.027-0.617l-0.234,0.129 c-0.029,0.014-0.056,0.031-0.088,0.041c-0.019,0.01-0.043,0.016-0.067,0.029c-0.012,0.006-0.038,0.006-0.038,0.006 l-0.007,0.006c-0.007,0.004-0.021,0.004-0.021,0.004c-0.015,0.004-0.032,0.008-0.055,0.008 c-0.02,0.004-0.038,0.004-0.076,0.01c0,0-0.021,0-0.042,0h-0.02h-0.02h-0.02c-0.02,0-0.043,0-0.065-0.006 c-0.024,0-0.051-0.004-0.083-0.008c0,0-0.013-0.004-0.018-0.004c-0.013-0.004-0.029-0.01-0.029-0.01 c-0.018-0.006-0.038-0.006-0.052-0.02c-0.043-0.016-0.087-0.025-0.123-0.053l-1.499-0.904l-0.02,0.578 c-0.003,0.094-0.067,0.18-0.187,0.248l-1.947,1.131c0.029,0.033,0.058,0.063,0.106,0.094l2.782,1.686 c0.054,0.033,0.114,0.051,0.175,0.064c0.009,0.004,0.029,0.016,0.029,0.016c0.063,0.014,0.132,0.018,0.203,0.018h0.006 c0.071,0,0.145-0.004,0.214-0.018l0.007-0.012c0.071-0.018,0.136-0.035,0.192-0.068l2.242-1.307 c0.043-0.016,0.067-0.047,0.094-0.072l-1.205-0.727L139.305,405.619z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M143.289,408.041c-0.025-0.018-0.047-0.041-0.069-0.064c-0.014-0.01-0.025-0.02-0.036-0.031 c-0.002-0.006-0.004-0.014-0.004-0.014h-0.005c-0.004-0.012-0.006-0.018-0.011-0.031c-0.005-0.008-0.009-0.018-0.013-0.027 c-0.005-0.016-0.012-0.021-0.012-0.031v-0.043v-0.004l0.02-0.617l-0.234,0.133c-0.025,0.021-0.054,0.037-0.085,0.045 c-0.02,0.004-0.047,0.014-0.067,0.021c-0.015,0.006-0.029,0.006-0.04,0.012h-0.006c-0.009,0-0.011,0-0.017,0.006 c-0.021,0.004-0.042,0.006-0.058,0.006c-0.021,0.004-0.042,0.004-0.06,0.01c-0.021,0-0.04,0-0.058,0h-0.023h-0.007 c-0.013,0-0.028,0-0.028,0c-0.025,0-0.047,0-0.071-0.006c-0.026,0-0.048-0.004-0.072-0.006c-0.013,0-0.024-0.004-0.033-0.01 l-0.025-0.006c-0.018-0.006-0.037-0.008-0.053-0.014c-0.048-0.014-0.088-0.029-0.128-0.059l-1.498-0.904l-0.022,0.578 c-0.001,0.094-0.061,0.186-0.181,0.254l-1.948,1.121c0.025,0.043,0.062,0.074,0.109,0.105l2.786,1.678 c0.051,0.041,0.109,0.061,0.176,0.074c0.005,0,0.017,0.006,0.029,0.01c0.063,0.01,0.133,0.02,0.2,0.02h0.005 c0.076,0,0.148-0.01,0.216-0.029h0.009c0.071-0.014,0.134-0.033,0.192-0.074l2.241-1.295c0.043-0.023,0.065-0.049,0.091-0.08 l-1.199-0.727H143.289z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M147.277,410.449c-0.028-0.018-0.057-0.035-0.071-0.055c-0.015-0.014-0.025-0.027-0.038-0.041 c-0.002-0.008-0.003-0.008-0.007-0.016l-0.001-0.004c-0.003-0.004-0.011-0.012-0.013-0.018 c-0.006-0.01-0.009-0.027-0.012-0.033c-0.004-0.012-0.014-0.037-0.014-0.037c0-0.01-0.001-0.033-0.001-0.033v-0.006 l0.025-0.617l-0.232,0.137c-0.027,0.012-0.058,0.027-0.089,0.039c-0.024,0.01-0.046,0.021-0.072,0.027 c-0.009,0.002-0.022,0.002-0.035,0.008h-0.005l-0.021,0.006c-0.018,0.006-0.038,0.01-0.06,0.01 c-0.017,0.004-0.035,0.004-0.057,0.006c-0.018,0-0.039,0-0.054,0.006l-0.021-0.006h-0.009c-0.012,0-0.019,0.006-0.032,0 c-0.018,0-0.043,0-0.062-0.002c-0.029,0-0.051-0.004-0.087-0.008l-0.02-0.006c-0.011-0.006-0.02-0.006-0.026-0.012 c-0.023-0.002-0.038-0.002-0.052-0.008c-0.045-0.018-0.089-0.041-0.126-0.061l-1.498-0.908l-0.022,0.588 c-0.003,0.084-0.065,0.174-0.183,0.24l-1.947,1.133c0.029,0.025,0.056,0.066,0.104,0.1l2.782,1.678 c0.051,0.031,0.113,0.051,0.176,0.074c0.009,0,0.022,0.006,0.033,0.006c0.061,0.014,0.131,0.025,0.203,0.025h0.003 c0.074,0,0.149-0.012,0.216-0.025l0.009-0.006c0.068-0.016,0.132-0.043,0.192-0.074l2.239-1.295 c0.043-0.031,0.068-0.057,0.094-0.08l-1.198-0.729L147.277,410.449z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M151.315,412.895c-0.028-0.016-0.051-0.033-0.073-0.053c-0.009-0.014-0.023-0.033-0.03-0.043 c-0.006-0.004-0.008-0.01-0.008-0.01l-0.003-0.008c-0.003-0.006-0.01-0.01-0.012-0.016c-0.006-0.014-0.014-0.02-0.017-0.031 c-0.002-0.02-0.006-0.043-0.006-0.043l-0.003-0.027v-0.002l0.023-0.697l-0.293,0.172c-0.025,0.018-0.054,0.025-0.085,0.041 c-0.022,0.008-0.047,0.012-0.069,0.023c-0.013,0.004-0.023,0.004-0.038,0.01h-0.005c-0.008,0.004-0.02,0.004-0.02,0.004 c-0.023,0.006-0.037,0.006-0.058,0.01c-0.022,0.01-0.037,0.01-0.062,0.016c-0.015,0-0.035,0-0.051,0h-0.023h-0.007 c-0.013,0-0.053,0-0.053,0s-0.027,0-0.045-0.006c-0.027,0-0.049-0.01-0.079-0.014l-0.026-0.006 c-0.012-0.004-0.02-0.004-0.027-0.01c-0.018-0.004-0.035-0.004-0.056-0.016c-0.042-0.012-0.087-0.027-0.124-0.051l-1.495-0.91 l-0.024,0.58c0,0.094-0.065,0.186-0.182,0.252l-1.948,1.127c0.031,0.037,0.06,0.07,0.109,0.092l2.778,1.691 c0.056,0.029,0.116,0.051,0.178,0.07c0.011,0.002,0.031,0.002,0.031,0.002c0.065,0.014,0.132,0.025,0.199,0.025h0.007 c0.073,0,0.145-0.012,0.22-0.025h0.006c0.064-0.016,0.137-0.043,0.192-0.072l2.239-1.303c0.043-0.02,0.065-0.047,0.092-0.078 l-1.144-0.691L151.315,412.895z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M155.659,403.313c-0.026-0.018-0.055-0.035-0.069-0.053c-0.017-0.016-0.029-0.031-0.042-0.045 c0,0-0.002-0.004-0.003-0.008l-0.001-0.004c-0.007-0.008-0.011-0.016-0.014-0.023c-0.009-0.012-0.015-0.02-0.015-0.033 c-0.004-0.01-0.008-0.033-0.008-0.033c0-0.01,0-0.033,0-0.033v-0.01l0.02-0.613l-0.23,0.131 c-0.027,0.018-0.055,0.033-0.085,0.043c-0.021,0.008-0.047,0.02-0.075,0.021c-0.012,0.008-0.023,0.008-0.037,0.012 l-0.008,0.004h-0.017c-0.018,0.004-0.04,0.008-0.056,0.016c-0.02,0-0.038,0.002-0.06,0.002c-0.019,0-0.038,0-0.064,0.004 c0,0-0.009,0-0.017,0h-0.014h-0.024c-0.018-0.004-0.04-0.004-0.061-0.004c-0.025-0.002-0.055-0.002-0.087-0.014l-0.02-0.004 c-0.011,0-0.021-0.004-0.026-0.008c-0.02,0-0.038-0.008-0.054-0.01c-0.044-0.016-0.087-0.033-0.125-0.063l-2.231-1.346 l-0.018,0.545c-0.002,0.09-0.062,0.18-0.185,0.254l-1.945,1.123c0.025,0.039,0.06,0.072,0.107,0.098l2.78,1.684 c0.055,0.039,0.113,0.057,0.178,0.07c0.007,0.004,0.02,0.004,0.03,0.008c0.064,0.016,0.134,0.02,0.2,0.02h0.007 c0.072,0,0.146-0.004,0.212-0.023h0.01c0.069-0.018,0.134-0.035,0.192-0.08l2.24-1.295c0.032-0.014,0.048-0.035,0.071-0.057 l-0.453-0.27L155.659,403.313z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M151.681,400.9c-0.027-0.016-0.056-0.033-0.076-0.053c-0.011-0.018-0.023-0.033-0.038-0.047 l-0.003-0.004l-0.004-0.006c0,0-0.007-0.018-0.009-0.023c-0.01-0.01-0.014-0.021-0.016-0.035 c-0.009-0.01-0.009-0.033-0.009-0.033c-0.004-0.012-0.004-0.035-0.004-0.035v-0.004l0.02-0.621l-0.232,0.143 c-0.025,0.012-0.054,0.025-0.09,0.035c-0.022,0.01-0.047,0.018-0.069,0.023c-0.011,0.01-0.021,0.01-0.034,0.016h-0.005 c-0.013,0.004-0.023,0.004-0.023,0.004c-0.018,0.004-0.037,0.008-0.056,0.008c-0.019,0.004-0.04,0.004-0.057,0.01 c-0.021,0-0.038,0-0.063,0.004c0,0-0.008-0.004-0.016-0.004h-0.005c-0.011,0-0.021,0.004-0.035,0c-0.02,0-0.038,0-0.061-0.006 c-0.023,0-0.049-0.004-0.083-0.008l-0.022-0.004c-0.009-0.004-0.02-0.004-0.032-0.01c-0.013-0.01-0.029-0.01-0.049-0.016 c-0.041-0.014-0.085-0.037-0.125-0.053l-2.224-1.354l-0.021,0.551c-0.002,0.09-0.064,0.184-0.186,0.248l-1.944,1.127 c0.025,0.037,0.058,0.066,0.104,0.094l2.78,1.691c0.056,0.027,0.118,0.045,0.179,0.066c0.012,0.006,0.028,0.006,0.028,0.006 c0.065,0.016,0.132,0.023,0.207,0.023h0.003c0.073,0,0.147-0.008,0.216-0.023h0.005c0.074-0.018,0.138-0.045,0.192-0.072 l2.246-1.303c0.031-0.02,0.045-0.041,0.063-0.057l-0.444-0.275L151.681,400.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M147.691,398.492c-0.029-0.025-0.055-0.041-0.071-0.063c-0.016-0.01-0.028-0.021-0.038-0.041 l-0.005-0.006l-0.003-0.01c0,0-0.009-0.012-0.013-0.02c-0.005-0.012-0.011-0.018-0.012-0.029 c-0.005-0.01-0.008-0.029-0.008-0.029c-0.003-0.021-0.003-0.041-0.003-0.041v-0.008l0.022-0.609l-0.23,0.129 c-0.028,0.014-0.06,0.033-0.086,0.041c-0.023,0.008-0.047,0.02-0.071,0.025c-0.011,0.006-0.024,0.006-0.038,0.01h-0.014 c0,0-0.003,0.004-0.013,0.008c-0.018,0-0.036,0.004-0.057,0.004c-0.015,0.004-0.037,0.012-0.055,0.012 c-0.021,0-0.038,0-0.065,0c0,0-0.009,0-0.018,0h-0.003h-0.031c-0.023,0-0.043,0-0.065,0c-0.025-0.008-0.049-0.012-0.077-0.016 c-0.012,0-0.02-0.004-0.03-0.008c-0.013,0-0.017,0-0.031-0.004c-0.016-0.006-0.031-0.006-0.053-0.012 c-0.043-0.02-0.088-0.031-0.124-0.061l-2.238-1.355l-0.019,0.549c-0.005,0.086-0.068,0.18-0.185,0.248l-1.946,1.125 c0.028,0.039,0.063,0.08,0.117,0.107l2.783,1.684c0.05,0.035,0.11,0.059,0.173,0.07c0.013,0.004,0.033,0.004,0.033,0.004 c0.062,0.018,0.131,0.023,0.199,0.023h0.008c0.07,0,0.145-0.006,0.212-0.023h0.01c0.071-0.016,0.134-0.039,0.191-0.074 l2.242-1.299c0.029-0.016,0.047-0.039,0.067-0.063l-0.449-0.266L147.691,398.492z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M143.711,396.076c-0.029-0.02-0.054-0.031-0.074-0.049c-0.013-0.021-0.023-0.033-0.036-0.049 c0,0-0.002-0.002-0.005-0.008l-0.001-0.006c-0.006-0.006-0.013-0.014-0.015-0.018c-0.003-0.012-0.01-0.027-0.013-0.037 c-0.001-0.014-0.009-0.033-0.009-0.033l-0.004-0.027v-0.01l0.024-0.637l-0.247,0.143c-0.025,0.016-0.055,0.031-0.083,0.043 c-0.023,0.008-0.047,0.016-0.072,0.025c-0.011,0.004-0.02,0.004-0.04,0.008h-0.009c0,0-0.004,0-0.013,0.006 c-0.017,0.008-0.036,0.008-0.054,0.012c-0.022,0-0.041,0.004-0.062,0.004c-0.018,0.01-0.038,0.01-0.065,0.01 c0,0-0.007,0-0.014,0h-0.007h-0.029c-0.021,0-0.045,0-0.062-0.01c-0.031-0.004-0.056-0.004-0.078-0.008l-0.031-0.014 c-0.011,0-0.029-0.004-0.029-0.004c-0.015-0.004-0.038-0.01-0.05-0.014c-0.045-0.016-0.09-0.027-0.126-0.053L140.277,394 l-0.019,0.551c-0.003,0.086-0.067,0.174-0.183,0.25l-1.947,1.129c0.028,0.029,0.055,0.064,0.102,0.098l2.784,1.678 c0.051,0.033,0.111,0.053,0.187,0.07c0,0,0.007,0.004,0.02,0.004c0.063,0.02,0.132,0.027,0.199,0.027h0.009 c0.074,0,0.144-0.008,0.214-0.031h0.007c0.071-0.018,0.134-0.037,0.193-0.07l2.242-1.299c0.029-0.02,0.047-0.039,0.07-0.057 l-0.44-0.27L143.711,396.076z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M139.72,393.656c-0.033-0.016-0.056-0.037-0.076-0.053c-0.015-0.01-0.025-0.023-0.038-0.043 c-0.001-0.004-0.004-0.01-0.005-0.016h-0.007c0-0.008-0.007-0.012-0.009-0.023c-0.005-0.004-0.007-0.016-0.013-0.027 c-0.003-0.012-0.012-0.049-0.012-0.049l-0.002-0.023l0.023-0.617l-0.233,0.127c-0.022,0.018-0.055,0.033-0.086,0.051 c-0.023,0.008-0.047,0.012-0.083,0.023c0,0-0.014,0.002-0.025,0.002l-0.005,0.006c-0.004,0.004-0.018,0.004-0.018,0.004 c-0.021,0.006-0.04,0.006-0.062,0.01c-0.016,0.004-0.034,0.004-0.054,0.004c-0.018,0.008-0.04,0.008-0.062,0.008 c0,0-0.009,0-0.02,0h-0.005c-0.013,0-0.029,0-0.029,0c-0.026,0-0.043,0-0.062-0.008c-0.029,0-0.055-0.004-0.076-0.008 l-0.037-0.006c-0.006-0.004-0.014-0.01-0.026-0.01c-0.013-0.002-0.031-0.002-0.047-0.014c-0.048-0.012-0.09-0.035-0.131-0.063 l-2.228-1.344l-0.014,0.545c-0.007,0.094-0.067,0.182-0.187,0.248l-1.95,1.129c0.029,0.035,0.057,0.074,0.105,0.098 l2.788,1.689c0.054,0.029,0.11,0.055,0.178,0.07c0.009,0,0.017,0.006,0.025,0.01c0.063,0.008,0.134,0.02,0.203,0.02h0.011 c0.069,0,0.142-0.012,0.212-0.023l0.007-0.006c0.067-0.016,0.138-0.041,0.192-0.076l2.244-1.293 c0.031-0.02,0.043-0.045,0.066-0.064l-0.446-0.268C139.724,393.666,139.72,393.66,139.72,393.656z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M135.733,391.248c-0.031-0.016-0.053-0.037-0.075-0.057c-0.014-0.018-0.027-0.025-0.034-0.041 c-0.003-0.002-0.007-0.008-0.007-0.008l-0.002-0.004c-0.005-0.006-0.006-0.016-0.01-0.02 c-0.007-0.016-0.011-0.029-0.016-0.037c-0.002-0.01-0.012-0.033-0.012-0.033v-0.033v-0.01l0.021-0.621l-0.23,0.141 c-0.033,0.02-0.059,0.027-0.087,0.037c-0.023,0.016-0.046,0.02-0.082,0.025c0,0-0.013,0.008-0.025,0.012h-0.006l-0.021,0.004 c-0.02,0-0.038,0.006-0.076,0.01c0,0-0.02,0.01-0.039,0.01c-0.018,0-0.038,0-0.064,0.006c0,0-0.008,0-0.017,0h-0.007 c-0.009,0-0.027,0-0.027,0c-0.023-0.006-0.045-0.006-0.065-0.006c-0.024-0.01-0.049-0.01-0.089-0.02c0,0-0.008,0-0.031-0.004 c0,0-0.007-0.004-0.034-0.012c0,0-0.018-0.002-0.033-0.006c-0.048-0.014-0.092-0.033-0.126-0.057l-2.228-1.346l-0.018,0.545 c-0.006,0.09-0.067,0.178-0.182,0.248l-1.948,1.127c0.027,0.039,0.056,0.066,0.101,0.096l2.785,1.688 c0.05,0.033,0.112,0.049,0.177,0.066c0.013,0.002,0.018,0.01,0.027,0.01c0.063,0.012,0.134,0.023,0.199,0.023h0.007 c0.078,0,0.147-0.012,0.219-0.023l0.003-0.008c0.073-0.02,0.136-0.035,0.196-0.068l2.236-1.305 c0.033-0.014,0.047-0.033,0.074-0.057l-0.448-0.268L135.733,391.248z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M131.745,388.83c-0.025-0.014-0.053-0.031-0.073-0.051c-0.013-0.012-0.025-0.033-0.038-0.041 c0-0.004-0.003-0.01-0.003-0.01l-0.001-0.008c-0.008-0.004-0.009-0.01-0.011-0.02c-0.009-0.008-0.009-0.018-0.018-0.029 c-0.002-0.012-0.005-0.037-0.005-0.037l-0.007-0.039l0.025-0.617l-0.23,0.133c-0.029,0.014-0.058,0.027-0.091,0.043 c-0.021,0.014-0.043,0.02-0.069,0.021c-0.013,0.01-0.022,0.01-0.036,0.016h-0.007c0,0-0.015,0-0.021,0.002 c-0.015,0.008-0.037,0.008-0.059,0.01c-0.016,0-0.038,0.008-0.056,0.01c-0.016,0-0.042,0-0.056,0h-0.023h-0.007 c-0.006,0-0.027,0-0.027,0c-0.023,0-0.045,0-0.065-0.002c-0.024-0.008-0.053-0.008-0.083-0.01c0,0-0.013-0.008-0.031-0.01 c0,0-0.01-0.006-0.017-0.006c-0.02-0.002-0.038-0.01-0.052-0.012c-0.045-0.02-0.09-0.039-0.127-0.063l-2.232-1.352 l-0.02,0.551c-0.003,0.094-0.06,0.184-0.179,0.248l-1.95,1.127c0.027,0.035,0.058,0.07,0.107,0.1l2.78,1.684 c0.053,0.029,0.113,0.057,0.18,0.076c0.011,0,0.025,0.004,0.025,0.004c0.067,0.014,0.14,0.023,0.207,0.023h0.007 c0.073,0,0.145-0.01,0.212-0.023l0.009-0.004c0.071-0.016,0.136-0.043,0.194-0.076l2.242-1.297 c0.031-0.012,0.045-0.041,0.065-0.059l-0.451-0.277L131.745,388.83z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M127.762,386.422c-0.027-0.012-0.052-0.035-0.069-0.055c-0.018-0.01-0.027-0.023-0.04-0.043 l-0.002-0.006l-0.004-0.004c-0.007-0.006-0.009-0.014-0.011-0.025c-0.007-0.012-0.013-0.021-0.016-0.029 c-0.005-0.016-0.009-0.033-0.009-0.033l-0.002-0.035v-0.008l0.02-0.615l-0.229,0.131c-0.029,0.018-0.059,0.033-0.088,0.047 c-0.024,0.008-0.049,0.012-0.071,0.023c-0.013,0-0.025,0.004-0.037,0.004l-0.009,0.004c-0.005,0-0.016,0.004-0.016,0.004 c-0.02,0-0.038,0.004-0.058,0.004c-0.02,0.012-0.058,0.012-0.058,0.012c-0.017,0.004-0.04,0.004-0.06,0.004h-0.025h-0.004 c-0.011,0-0.029,0-0.029,0c-0.023,0-0.042-0.004-0.067-0.004c-0.021,0-0.05-0.012-0.07-0.012 c-0.011-0.004-0.026-0.004-0.037-0.008s-0.025-0.004-0.025-0.004c-0.02-0.004-0.034-0.01-0.051-0.016 c-0.047-0.012-0.088-0.031-0.126-0.059l-2.228-1.344l-0.02,0.543c0,0.09-0.063,0.184-0.185,0.25l-1.947,1.125 c0.029,0.041,0.058,0.07,0.105,0.098l2.782,1.686c0.056,0.031,0.114,0.055,0.175,0.068c0.013,0.006,0.032,0.01,0.032,0.01 c0.063,0.01,0.13,0.02,0.2,0.02h0.008c0.074,0,0.145-0.01,0.215-0.023h0.006c0.071-0.02,0.132-0.043,0.192-0.074l2.242-1.301 c0.034-0.016,0.049-0.039,0.072-0.059l-0.452-0.264L127.762,386.422z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M123.779,384.01c-0.031-0.018-0.056-0.031-0.072-0.053c-0.017-0.012-0.027-0.031-0.042-0.049 l-0.002-0.006l-0.003-0.004c0-0.008-0.01-0.012-0.014-0.016c-0.005-0.014-0.01-0.023-0.014-0.037 c-0.003-0.014-0.009-0.033-0.009-0.033l-0.003-0.031v-0.01l0.023-0.613l-0.229,0.131c-0.029,0.014-0.06,0.029-0.088,0.035 c-0.024,0.012-0.048,0.021-0.073,0.035l-0.032,0.006l-0.011,0.004c-0.006,0-0.011,0-0.017,0.002 c-0.019,0-0.04,0.008-0.06,0.012c-0.016,0-0.036,0.006-0.072,0.006c0,0-0.021,0.002-0.042,0.002h-0.024h-0.007h-0.031 c-0.021-0.002-0.042-0.002-0.063-0.002c-0.026-0.006-0.047-0.006-0.073-0.018c-0.012,0-0.02,0-0.043-0.002 c0,0-0.004-0.004-0.02-0.004c-0.015-0.006-0.035-0.01-0.051-0.02c-0.043-0.014-0.081-0.033-0.121-0.053l-2.267-1.375 l-0.022,0.545c-0.006,0.092-0.066,0.18-0.182,0.252l-1.934,1.117c0.006,0.004,0.006,0.004,0.009,0.014v0.01 c0.026,0.035,0.065,0.07,0.12,0.107l2.78,1.686c0.056,0.029,0.116,0.051,0.181,0.068l0.029,0.01 c0.063,0.012,0.131,0.02,0.2,0.02h0.009c0.073,0,0.143-0.008,0.212-0.023h0.005c0.073-0.023,0.138-0.045,0.195-0.082 l2.24-1.295c0.035-0.018,0.048-0.039,0.071-0.061l-0.451-0.271L123.779,384.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M122.26,387.174c-0.026-0.021-0.054-0.039-0.071-0.059c-0.012-0.012-0.025-0.021-0.038-0.049 c0,0-0.005,0-0.008-0.002l-0.001-0.01c-0.002-0.004-0.007-0.01-0.011-0.014c-0.009-0.016-0.013-0.023-0.015-0.033 c-0.005-0.014-0.007-0.043-0.007-0.043l-0.006-0.027v-0.004l0.026-0.619l-0.236,0.131c-0.027,0.016-0.055,0.029-0.085,0.045 c-0.021,0.008-0.047,0.018-0.083,0.027c0,0-0.012,0.004-0.024,0.004l-0.013,0.004c0,0-0.009,0-0.015,0 c-0.02,0.012-0.042,0.012-0.058,0.016c-0.02,0-0.038,0.002-0.06,0.002c-0.015,0.006-0.037,0.006-0.057,0.006h-0.02h-0.009 h-0.031c-0.02,0-0.042,0-0.065-0.006c-0.023-0.002-0.047-0.002-0.082-0.006l-0.021-0.012c-0.011,0-0.025-0.004-0.025-0.004 c-0.018-0.004-0.037-0.008-0.059-0.014c-0.042-0.018-0.084-0.033-0.123-0.055l-1.461-0.893l-0.022,0.545 c-0.002,0.086-0.063,0.178-0.181,0.242l-1.951,1.131c0.028,0.035,0.057,0.066,0.106,0.1l2.779,1.686 c0.055,0.029,0.114,0.051,0.178,0.064c0.013,0.002,0.02,0.002,0.029,0.008c0.067,0.016,0.134,0.029,0.201,0.029h0.011 c0.073-0.006,0.147-0.014,0.212-0.035h0.012c0.072-0.016,0.137-0.037,0.193-0.066l2.242-1.307 c0.025-0.014,0.04-0.033,0.058-0.053l-1.209-0.73H122.26z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M125.338,392.99v-0.025v-0.006l0.021-0.617l-0.226,0.129c-0.033,0.018-0.062,0.031-0.091,0.047 c-0.025,0.006-0.049,0.014-0.075,0.018c-0.012,0.008-0.021,0.012-0.035,0.012l-0.004,0.004c-0.011,0-0.018,0-0.023,0.004 c-0.02,0.006-0.038,0.006-0.058,0.01c-0.022,0-0.038,0.006-0.06,0.006c-0.019,0.004-0.037,0.004-0.061,0.004h-0.018h-0.003 c-0.011,0-0.036,0-0.036,0c-0.02,0-0.04,0-0.063-0.004c-0.025-0.006-0.047-0.006-0.076-0.01c-0.007,0-0.018-0.006-0.038-0.01 c0,0-0.004-0.004-0.017-0.004c-0.018-0.004-0.034-0.012-0.05-0.016c-0.049-0.014-0.091-0.033-0.125-0.061l-2.786-1.68 l-0.004-0.002c-0.025-0.02-0.04-0.031-0.056-0.039l-0.02,0.539c0,0.086-0.06,0.182-0.183,0.246l-1.945,1.129 c0.027,0.037,0.06,0.066,0.107,0.098l2.78,1.684c0.054,0.031,0.114,0.055,0.176,0.074c0.013,0,0.021,0,0.029,0.004 c0.069,0.018,0.136,0.027,0.201,0.027h0.011c0.075,0,0.143-0.01,0.216-0.031h0.007c0.067-0.016,0.134-0.043,0.194-0.074 l2.24-1.297c0.043-0.023,0.07-0.051,0.094-0.084c-0.007-0.014-0.01-0.023-0.014-0.033 C125.342,393.023,125.342,393.008,125.338,392.99z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M129.112,394.885c-0.027,0.016-0.055,0.029-0.087,0.035c-0.026,0.012-0.047,0.023-0.069,0.029 c-0.014,0.006-0.025,0.006-0.034,0.014c-0.007,0-0.02,0-0.02,0s-0.007,0-0.011,0.004c-0.018,0-0.042,0.008-0.076,0.012 c0,0-0.023,0.004-0.042,0.004c-0.018,0-0.038,0-0.056,0.004h-0.02h-0.009c-0.009,0-0.035-0.004-0.035-0.004 c-0.022,0-0.043,0-0.065,0c-0.02-0.004-0.049-0.004-0.075-0.008c-0.009-0.008-0.03-0.012-0.03-0.012 c-0.007,0-0.017,0-0.044-0.008c0,0-0.016-0.006-0.034-0.012c-0.047-0.018-0.085-0.035-0.125-0.053l-2.786-1.689h-0.001 c-0.019-0.014-0.035-0.033-0.049-0.043l-0.021,0.545c-0.002,0.088-0.062,0.182-0.181,0.246l-1.949,1.133 c0.029,0.027,0.058,0.064,0.105,0.092l2.782,1.686c0.049,0.027,0.108,0.055,0.178,0.07c0.007,0,0.016,0.002,0.025,0.008 c0.063,0.016,0.137,0.021,0.204,0.021h0.006c0.075,0,0.144-0.006,0.22-0.027h0.004c0.068-0.018,0.134-0.045,0.188-0.076 l2.248-1.297c0.038-0.025,0.069-0.057,0.094-0.082c-0.007-0.014-0.009-0.021-0.011-0.033 c-0.002-0.008-0.009-0.021-0.009-0.035l-0.002-0.031l0.021-0.627L129.112,394.885z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M133.309,397.813l-0.007-0.018v-0.016l0.027-0.617l-0.232,0.133c-0.025,0.018-0.053,0.031-0.083,0.047 c-0.025,0.008-0.051,0.012-0.087,0.021c0,0-0.012,0.006-0.024,0.01H132.9c-0.011,0.006-0.017,0.006-0.024,0.006 c-0.016,0.004-0.036,0.004-0.058,0.008c-0.018,0.006-0.038,0.006-0.056,0.006c-0.02,0.006-0.056,0.006-0.056,0.006 c-0.009,0-0.016,0-0.025,0h-0.007h-0.026c-0.029,0-0.049,0-0.07-0.006c-0.023,0-0.049-0.006-0.083-0.01 c0,0-0.013-0.004-0.033-0.01l-0.017-0.004c-0.02-0.006-0.034-0.006-0.056-0.016c-0.04-0.012-0.087-0.033-0.124-0.059 l-2.786-1.686h-0.002c-0.021-0.014-0.038-0.023-0.054-0.037l-0.016,0.539c-0.002,0.088-0.069,0.182-0.187,0.252l-1.946,1.119 c0.025,0.041,0.056,0.074,0.106,0.1l2.785,1.689c0.052,0.029,0.108,0.053,0.175,0.064c0.011,0.008,0.017,0.008,0.028,0.012 c0.068,0.018,0.134,0.023,0.202,0.023h0.009c0.073,0,0.144-0.006,0.214-0.027h0.003c0.073-0.016,0.14-0.037,0.198-0.072 l2.242-1.301c0.042-0.023,0.065-0.049,0.094-0.078c-0.005-0.014-0.013-0.027-0.016-0.039 C133.313,397.846,133.309,397.838,133.309,397.813z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M137.299,400.197l0.026-0.629l-0.244,0.139c-0.029,0.014-0.058,0.027-0.087,0.041 c-0.024,0.012-0.051,0.02-0.072,0.029l-0.033,0.004l-0.02,0.006c0,0-0.004,0-0.009,0.004c-0.022,0.006-0.042,0.01-0.06,0.01 c-0.022,0-0.043,0.006-0.058,0.006c-0.02,0.004-0.042,0.004-0.067,0.004c0,0-0.003,0-0.013,0h-0.009h-0.029 c-0.025,0-0.045,0-0.068-0.004c-0.021-0.006-0.049-0.006-0.078-0.01c0,0-0.017-0.006-0.024-0.01l-0.025-0.006 c-0.018-0.004-0.035-0.01-0.053-0.014c-0.047-0.02-0.088-0.033-0.127-0.055l-2.784-1.684l-0.007-0.006 c-0.017-0.008-0.031-0.025-0.046-0.043l-0.02,0.549c-0.003,0.086-0.063,0.176-0.187,0.25l-1.947,1.125 c0.025,0.027,0.062,0.064,0.105,0.09l2.782,1.688c0.05,0.029,0.113,0.055,0.18,0.068c0.005,0.008,0.017,0.008,0.023,0.01 c0.065,0.014,0.132,0.02,0.205,0.02h0.007c0.067,0,0.142-0.006,0.21-0.021h0.012c0.068-0.018,0.132-0.047,0.189-0.076 l2.246-1.297c0.043-0.027,0.069-0.061,0.1-0.088c0-0.012-0.007-0.016-0.007-0.025c-0.004-0.008-0.004-0.016-0.013-0.045 v-0.021V400.197z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M141.284,402.652l-0.001-0.035l0.021-0.623l-0.228,0.137c-0.026,0.012-0.057,0.027-0.086,0.037 c-0.027,0.01-0.046,0.018-0.074,0.023c-0.011,0.002-0.026,0.002-0.04,0.008h-0.012c0,0-0.005,0.006-0.011,0.014 c-0.018,0-0.056,0.006-0.056,0.006c-0.021,0.008-0.042,0.01-0.063,0.01c-0.017,0-0.037,0-0.057,0h-0.018h-0.009h-0.033 c-0.022,0-0.045,0-0.065,0c-0.025-0.002-0.051-0.01-0.076-0.016l-0.03-0.008c-0.007-0.006-0.017-0.006-0.042-0.012 c0,0-0.022-0.002-0.037-0.008c-0.045-0.014-0.087-0.033-0.126-0.055l-2.779-1.684h-0.009 c-0.026-0.023-0.043-0.039-0.063-0.059l-0.014,0.549c-0.008,0.084-0.069,0.17-0.188,0.248l-1.943,1.127 c0.026,0.037,0.063,0.07,0.114,0.107l2.786,1.68c0.049,0.031,0.108,0.057,0.176,0.07c0.005,0,0.027,0.01,0.027,0.01 c0.062,0.014,0.13,0.023,0.201,0.023h0.005c0.078,0,0.145-0.01,0.212-0.023l0.014-0.01c0.069-0.014,0.131-0.039,0.187-0.07 l2.244-1.297c0.043-0.025,0.067-0.057,0.096-0.082c-0.005-0.012-0.009-0.025-0.015-0.035 C141.29,402.672,141.29,402.664,141.284,402.652z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M145.273,405.063l-0.005-0.039l0.022-0.619l-0.236,0.131c-0.023,0.02-0.054,0.035-0.085,0.045 c-0.025,0.01-0.047,0.02-0.072,0.023c-0.011,0-0.021,0.002-0.036,0.012h-0.007l-0.018,0.004 c-0.022,0.004-0.04,0.008-0.06,0.008c-0.02,0.008-0.038,0.008-0.06,0.008c-0.017,0.004-0.037,0.004-0.058,0.004h-0.014h-0.011 c-0.015,0-0.05,0-0.05,0s-0.026,0-0.046-0.004c-0.027,0-0.05-0.008-0.074-0.008c-0.011-0.004-0.029-0.008-0.029-0.008 c-0.012-0.004-0.02-0.004-0.029-0.014c-0.02-0.002-0.038-0.002-0.05-0.006c-0.046-0.014-0.091-0.039-0.127-0.061l-2.782-1.684 l-0.009-0.006c-0.018-0.008-0.033-0.023-0.047-0.037l-0.017,0.541c-0.005,0.086-0.068,0.18-0.186,0.252l-1.949,1.125 c0.025,0.039,0.057,0.064,0.104,0.094l2.782,1.686c0.053,0.037,0.116,0.055,0.179,0.066c0.009,0.008,0.019,0.012,0.027,0.012 c0.063,0.012,0.136,0.023,0.207,0.023h0.004c0.072,0,0.145-0.012,0.214-0.023l0.009-0.004 c0.071-0.016,0.135-0.037,0.193-0.074l2.24-1.297c0.045-0.023,0.072-0.051,0.098-0.084c-0.003-0.008-0.01-0.018-0.012-0.029 C145.275,405.088,145.273,405.078,145.273,405.063z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M149.254,407.477v-0.031v-0.008l0.02-0.625l-0.229,0.137c-0.027,0.018-0.058,0.025-0.085,0.041 c-0.025,0.008-0.054,0.018-0.08,0.023c-0.009,0.004-0.018,0.004-0.034,0.014c0,0-0.004,0-0.013,0.004c0,0-0.007,0-0.015,0 c-0.014,0.004-0.036,0.01-0.057,0.016c-0.02,0-0.038,0.004-0.055,0.004c-0.022,0-0.04,0-0.067,0.004h-0.013h-0.015 c0,0-0.016,0-0.027-0.004c-0.02,0-0.041,0-0.063,0c-0.023-0.004-0.048-0.004-0.075-0.016l-0.03-0.004 c-0.011,0-0.027-0.004-0.027-0.004c-0.015-0.01-0.035-0.014-0.051-0.02c-0.045-0.014-0.089-0.033-0.125-0.051l-2.783-1.688 l-0.008-0.008c-0.019-0.014-0.036-0.025-0.052-0.041l-0.019,0.551c-0.003,0.086-0.063,0.176-0.181,0.242l-1.95,1.131 c0.027,0.033,0.058,0.064,0.107,0.094l2.78,1.686c0.056,0.029,0.115,0.051,0.18,0.07l0.027,0.012 c0.065,0.016,0.134,0.02,0.205,0.02h0.006c0.07,0,0.143-0.012,0.216-0.023l0.007-0.008c0.067-0.016,0.134-0.041,0.192-0.07 l2.241-1.297c0.042-0.029,0.066-0.057,0.096-0.084c-0.008-0.012-0.012-0.02-0.015-0.037 C149.259,407.5,149.255,407.484,149.254,407.477z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M150.159,404.057c-0.029-0.012-0.053-0.033-0.069-0.051c-0.013-0.008-0.025-0.023-0.038-0.047 c0,0-0.002-0.004-0.005-0.008h-0.003c-0.002-0.012-0.009-0.016-0.009-0.021c-0.007-0.008-0.015-0.023-0.015-0.031 c-0.008-0.016-0.011-0.027-0.013-0.039c0-0.006,0-0.033,0-0.033v-0.004l0.021-0.619l-0.23,0.135 c-0.033,0.016-0.058,0.027-0.088,0.035c-0.024,0.008-0.047,0.027-0.067,0.029c-0.016,0.004-0.031,0.004-0.042,0.01h-0.003 c-0.007,0.004-0.012,0.004-0.02,0.01c-0.017,0-0.038,0.004-0.06,0.004c-0.015,0.004-0.058,0.01-0.058,0.01 c-0.015,0-0.037,0-0.055,0c-0.011,0.004-0.025,0-0.025,0h-0.007c-0.011,0-0.029,0-0.029,0c-0.022,0-0.043,0-0.067,0 c-0.024-0.006-0.05-0.01-0.083-0.014c0,0-0.013,0-0.024-0.006c-0.01-0.004-0.019-0.004-0.026-0.01 c-0.018,0-0.035-0.004-0.049-0.006c-0.047-0.021-0.089-0.041-0.129-0.063l-1.462-0.885l-0.018,0.537 c-0.004,0.09-0.067,0.178-0.183,0.248l-1.949,1.125c0.025,0.041,0.061,0.072,0.107,0.1l2.78,1.689 c0.055,0.027,0.116,0.053,0.178,0.064c0.011,0.008,0.029,0.008,0.029,0.008c0.063,0.018,0.133,0.025,0.205,0.025h0.003 c0.073,0,0.146-0.008,0.216-0.025h0.007c0.073-0.02,0.138-0.045,0.193-0.076l2.246-1.301c0.021-0.012,0.04-0.033,0.06-0.053 l-1.207-0.729L150.159,404.057z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M146.172,401.646c-0.023-0.012-0.048-0.035-0.068-0.053c-0.017-0.018-0.026-0.025-0.035-0.039 c-0.005-0.006-0.005-0.01-0.011-0.014v-0.004c-0.003-0.004-0.009-0.01-0.011-0.02c-0.007-0.014-0.014-0.025-0.017-0.035 c-0.001-0.008-0.003-0.02-0.009-0.045l-0.004-0.027v-0.004l0.022-0.615l-0.231,0.133c-0.027,0.02-0.056,0.033-0.087,0.043 c-0.021,0.008-0.047,0.018-0.072,0.023c-0.012,0.004-0.022,0.004-0.035,0.008c0,0.006-0.003,0.006-0.003,0.006 c-0.008,0-0.015,0-0.024,0.004c-0.017,0-0.036,0.002-0.058,0.01c-0.016,0-0.038,0.004-0.058,0.004c-0.02,0-0.036,0-0.056,0 h-0.023h-0.003c-0.013,0-0.033,0-0.033,0c-0.022,0-0.044,0-0.065,0c-0.023-0.004-0.049-0.004-0.085-0.014 c0,0-0.009,0-0.031-0.004c0,0-0.006-0.006-0.017-0.01c-0.017,0-0.034-0.004-0.051-0.01c-0.047-0.018-0.085-0.033-0.125-0.061 l-1.464-0.885l-0.02,0.543c-0.004,0.09-0.063,0.176-0.181,0.244l-1.952,1.131c0.025,0.033,0.06,0.07,0.104,0.094l2.787,1.686 c0.049,0.029,0.108,0.053,0.175,0.074l0.024,0.002c0.067,0.014,0.135,0.025,0.202,0.025h0.01c0.072,0,0.145-0.012,0.213-0.027 h0.011c0.063-0.014,0.134-0.049,0.194-0.074l2.239-1.303c0.03-0.014,0.04-0.037,0.061-0.057l-1.207-0.725L146.172,401.646z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M142.192,399.234c-0.026-0.014-0.053-0.033-0.071-0.051c-0.016-0.016-0.027-0.033-0.04-0.047 c0,0-0.002-0.006-0.002-0.008l-0.005-0.006c-0.004-0.006-0.011-0.012-0.013-0.018c-0.007-0.01-0.012-0.021-0.014-0.031 c-0.001-0.018-0.006-0.025-0.009-0.041v-0.027V399l0.02-0.635l-0.243,0.141c-0.025,0.014-0.056,0.027-0.087,0.043 c-0.022,0.008-0.047,0.012-0.072,0.023c-0.013,0.008-0.02,0.008-0.037,0.014h-0.005c-0.006,0.004-0.02,0.004-0.02,0.004 c-0.017,0.002-0.041,0.002-0.061,0.006c-0.016,0.008-0.054,0.008-0.054,0.008c-0.022,0.004-0.036,0.004-0.06,0.004h-0.021 h-0.007c-0.007,0-0.018,0-0.029,0c-0.021,0-0.047,0-0.063-0.004c-0.027,0-0.053-0.008-0.087-0.012l-0.022-0.002 c-0.009-0.004-0.019-0.01-0.027-0.01c-0.014-0.008-0.036-0.008-0.051-0.02c-0.047-0.012-0.087-0.027-0.123-0.053l-1.466-0.887 l-0.018,0.537c-0.003,0.088-0.065,0.184-0.18,0.254l-1.948,1.119c0.021,0.043,0.061,0.078,0.11,0.111l2.786,1.688 c0.051,0.027,0.11,0.047,0.174,0.064c0.013,0.004,0.03,0.004,0.03,0.004c0.063,0.016,0.133,0.031,0.201,0.031h0.005 c0.076,0,0.146-0.016,0.216-0.031h0.011c0.067-0.016,0.134-0.041,0.194-0.074l2.244-1.303 c0.023-0.014,0.038-0.029,0.058-0.047l-1.207-0.736L142.192,399.234z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M138.196,396.82c-0.025-0.023-0.049-0.043-0.071-0.055c-0.014-0.014-0.025-0.029-0.04-0.043v-0.01 l-0.009-0.008c-0.001-0.006-0.005-0.016-0.007-0.02c-0.009-0.008-0.009-0.023-0.012-0.033c-0.01-0.01-0.01-0.016-0.011-0.047 v-0.023l0.018-0.617l-0.23,0.131c-0.025,0.016-0.056,0.033-0.084,0.043c-0.025,0.01-0.045,0.018-0.071,0.021 c-0.013,0-0.022,0.012-0.037,0.012h-0.009c-0.003,0.004-0.016,0.004-0.016,0.004c-0.022,0.004-0.038,0.008-0.058,0.008 c-0.02,0.004-0.04,0.004-0.056,0.004c-0.022,0.008-0.042,0.008-0.062,0.012h-0.021h-0.006c-0.014,0-0.033,0-0.033,0 c-0.02-0.004-0.045-0.004-0.063-0.012c-0.029,0-0.051-0.004-0.084-0.008c0,0-0.013-0.004-0.022-0.004 c-0.01-0.004-0.02-0.004-0.025-0.004c-0.02-0.012-0.041-0.012-0.057-0.016c-0.042-0.014-0.085-0.033-0.123-0.061l-1.464-0.885 l-0.02,0.545c-0.002,0.086-0.061,0.178-0.178,0.24l-1.95,1.133c0.024,0.033,0.058,0.063,0.1,0.094l2.786,1.689 c0.051,0.027,0.11,0.047,0.175,0.066c0.007,0.002,0.027,0.01,0.027,0.01c0.064,0.012,0.131,0.018,0.203,0.018h0.009 c0.072,0,0.139-0.006,0.214-0.018l0.007-0.008c0.071-0.021,0.138-0.041,0.198-0.078l2.24-1.297 c0.024-0.018,0.037-0.035,0.058-0.049l-1.207-0.734L138.196,396.82z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M134.212,394.406c-0.027-0.016-0.049-0.033-0.072-0.049c-0.011-0.021-0.02-0.033-0.033-0.041 c0-0.008-0.004-0.012-0.009-0.018l-0.002-0.004c0-0.004-0.008-0.008-0.013-0.02c-0.003-0.01-0.005-0.018-0.013-0.035 c-0.003-0.012-0.007-0.029-0.007-0.029c-0.003-0.014-0.003-0.037-0.003-0.037v-0.006l0.023-0.623l-0.237,0.139 c-0.025,0.02-0.056,0.027-0.089,0.039c-0.018,0.012-0.043,0.018-0.068,0.02c-0.008,0.012-0.026,0.012-0.037,0.016h-0.005 c-0.006,0-0.016,0.01-0.016,0.01c-0.023,0.002-0.042,0.002-0.062,0.01c-0.02,0-0.037,0.004-0.077,0.01c0,0-0.018,0-0.042,0 c-0.005,0-0.019,0-0.019,0h-0.005c-0.013,0-0.024,0-0.035,0c-0.022,0-0.045,0-0.063-0.006 c-0.027-0.004-0.051-0.004-0.087-0.012c0,0-0.005-0.002-0.029-0.012c0,0-0.01,0-0.016-0.004 c-0.017-0.004-0.038-0.012-0.051-0.014c-0.049-0.018-0.089-0.033-0.127-0.055l-1.466-0.887l-0.017,0.541 c-0.007,0.092-0.064,0.178-0.183,0.244l-1.946,1.127c0.025,0.039,0.058,0.076,0.102,0.1l2.782,1.684 c0.052,0.037,0.114,0.055,0.18,0.074l0.027,0.004c0.063,0.016,0.134,0.027,0.208,0.027h0.004c0.072,0,0.146-0.012,0.218-0.031 h0.007c0.069-0.014,0.134-0.037,0.192-0.074l2.246-1.293c0.024-0.018,0.036-0.041,0.058-0.055l-1.207-0.734L134.212,394.406z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M130.23,391.998c-0.03-0.023-0.055-0.041-0.073-0.061c-0.014-0.008-0.027-0.023-0.036-0.037 l-0.007-0.014l-0.003-0.004c-0.005-0.008-0.009-0.016-0.011-0.02c-0.007-0.008-0.009-0.023-0.016-0.033 c-0.003-0.014-0.009-0.039-0.009-0.039c0-0.008,0-0.031,0-0.031v-0.006l0.024-0.615l-0.232,0.131 c-0.025,0.02-0.058,0.025-0.087,0.045c-0.021,0.01-0.047,0.016-0.07,0.025c-0.009,0.002-0.023,0.002-0.035,0.008h-0.009 c-0.003,0.004-0.016,0.004-0.016,0.004c-0.02,0.006-0.038,0.006-0.06,0.012c-0.017,0.006-0.037,0.006-0.077,0.008 c0,0-0.018,0-0.04,0h-0.02h-0.009h-0.031c-0.023,0-0.042,0-0.064-0.002c-0.025,0-0.054-0.006-0.076-0.012 c-0.011,0-0.021-0.006-0.032-0.006c-0.009-0.004-0.027-0.01-0.027-0.01c-0.018-0.002-0.034-0.002-0.052-0.012 c-0.047-0.016-0.088-0.039-0.125-0.061l-1.468-0.885l-0.014,0.543c-0.002,0.088-0.063,0.176-0.182,0.246l-1.95,1.131 c0.027,0.037,0.056,0.063,0.109,0.096l2.776,1.684c0.051,0.029,0.116,0.053,0.179,0.066c0.01,0.01,0.027,0.01,0.027,0.01 c0.067,0.021,0.131,0.021,0.201,0.021h0.008c0.072,0,0.146-0.008,0.215-0.021h0.011c0.067-0.023,0.134-0.047,0.192-0.076 l2.242-1.301c0.027-0.018,0.04-0.035,0.06-0.057l-1.206-0.725L130.23,391.998z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M126.244,389.586c-0.027-0.016-0.053-0.037-0.07-0.057c-0.012-0.014-0.024-0.029-0.037-0.043 c0,0-0.003-0.004-0.005-0.014h-0.003c0,0-0.009-0.014-0.009-0.018c-0.009-0.01-0.011-0.029-0.017-0.033 c-0.005-0.016-0.009-0.023-0.009-0.041l-0.003-0.029l0.003-0.006l0.02-0.625l-0.238,0.143 c-0.023,0.016-0.049,0.025-0.082,0.035c-0.023,0.008-0.047,0.016-0.085,0.027c0,0-0.012,0.004-0.025,0.008h-0.013 c0,0-0.006,0-0.031,0.006c0,0-0.017,0.014-0.038,0.014s-0.04,0.004-0.058,0.004c-0.018,0-0.058,0.004-0.058,0.004 c-0.009,0-0.013,0-0.027,0h-0.002h-0.031c-0.025,0-0.043-0.004-0.067-0.004c-0.021-0.004-0.049-0.004-0.084-0.018 c0,0-0.009,0-0.031-0.006l-0.016-0.004c-0.018-0.004-0.035-0.008-0.053-0.016c-0.042-0.012-0.085-0.031-0.125-0.051 l-1.463-0.887l-0.018,0.537c-0.003,0.088-0.063,0.182-0.183,0.248l-1.949,1.131c0.025,0.029,0.059,0.068,0.107,0.094 l2.78,1.686c0.051,0.035,0.116,0.057,0.178,0.07c0.009,0.004,0.014,0.01,0.025,0.01c0.066,0.012,0.136,0.016,0.206,0.016 h0.007c0.071,0,0.143-0.004,0.212-0.016c0.001-0.006,0.009-0.006,0.009-0.006c0.073-0.018,0.134-0.041,0.192-0.08l2.246-1.297 c0.022-0.014,0.037-0.031,0.058-0.051l-1.205-0.729C126.248,389.586,126.244,389.586,126.244,389.586z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M154.144,406.471c-0.029-0.016-0.054-0.033-0.07-0.055c-0.014-0.016-0.027-0.031-0.034-0.041 c-0.007-0.004-0.007-0.008-0.013-0.01v-0.008c-0.007-0.002-0.009-0.008-0.011-0.012c-0.003-0.021-0.013-0.027-0.017-0.037 c-0.003-0.018-0.005-0.027-0.009-0.037l-0.002-0.029v-0.012l0.024-0.615l-0.234,0.135c-0.029,0.014-0.054,0.027-0.087,0.045 c-0.02,0.002-0.047,0.012-0.07,0.018c-0.015,0.004-0.024,0.01-0.037,0.01c0,0-0.007,0-0.007,0.002h-0.02 c-0.02,0.01-0.036,0.01-0.058,0.016c-0.018,0-0.056,0.006-0.056,0.006c-0.018,0.01-0.042,0.01-0.063,0.01h-0.013h-0.011 c-0.011,0-0.031,0-0.031,0c-0.024,0-0.044-0.01-0.065-0.01c-0.025-0.006-0.05-0.006-0.085-0.012l-0.02-0.01 c-0.011,0-0.018-0.002-0.025-0.002c-0.02-0.006-0.036-0.01-0.054-0.016c-0.044-0.012-0.087-0.033-0.124-0.057l-1.466-0.881 l-0.019,0.535c-0.002,0.092-0.062,0.182-0.181,0.248l-1.952,1.129c0.027,0.031,0.06,0.068,0.105,0.094l2.78,1.686 c0.052,0.029,0.118,0.053,0.179,0.072c0.011,0.004,0.026,0.004,0.026,0.004c0.068,0.012,0.134,0.023,0.206,0.023h0.009 c0.073,0,0.144-0.012,0.214-0.023h0.005c0.071-0.02,0.139-0.047,0.196-0.084l2.242-1.293c0.025-0.012,0.043-0.029,0.06-0.055 l-1.208-0.73L154.144,406.471z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M153.238,409.889l-0.002-0.037v-0.002l0.022-0.619l-0.23,0.133c-0.029,0.012-0.055,0.031-0.086,0.043 c-0.024,0.006-0.044,0.016-0.075,0.021c-0.011,0.004-0.021,0.004-0.035,0.008h-0.007c-0.007,0.004-0.015,0.004-0.015,0.004 c-0.02,0.006-0.043,0.01-0.063,0.01c-0.014,0.004-0.038,0.012-0.058,0.012c-0.018,0-0.058,0.002-0.058,0.002 c-0.008,0-0.02,0-0.02,0h-0.01h-0.032c-0.019-0.002-0.046-0.002-0.062-0.002c-0.025-0.008-0.051-0.012-0.082-0.016 l-0.027-0.006c-0.009-0.004-0.022-0.004-0.031-0.008c-0.015,0-0.031-0.004-0.049-0.01c-0.043-0.014-0.089-0.031-0.125-0.059 l-2.782-1.686l-0.006-0.004c-0.02-0.01-0.034-0.023-0.048-0.041l-0.024,0.545c0,0.09-0.065,0.18-0.179,0.254l-1.949,1.121 c0.027,0.037,0.058,0.07,0.104,0.098l2.784,1.68c0.049,0.035,0.111,0.059,0.178,0.076l0.025,0.004 c0.065,0.012,0.136,0.025,0.201,0.025h0.011c0.072,0,0.143-0.014,0.212-0.025l0.007-0.004 c0.069-0.014,0.138-0.041,0.192-0.076l2.243-1.295c0.043-0.023,0.071-0.051,0.098-0.086c-0.007-0.008-0.009-0.016-0.011-0.027 C153.241,409.914,153.241,409.904,153.238,409.889z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M121.376,389.928l-0.229,0.135c-0.031,0.012-0.061,0.025-0.091,0.037 c-0.023,0.01-0.047,0.02-0.072,0.033c-0.009,0-0.02,0.004-0.031,0.004h-0.015c-0.003,0.004-0.007,0.004-0.014,0.01 c-0.019,0-0.042,0.006-0.062,0.006c-0.02,0.004-0.034,0.01-0.056,0.01c-0.02,0-0.039,0.002-0.062,0.002h-0.016h-0.009 c-0.009,0-0.033,0-0.033,0c-0.02,0-0.044-0.002-0.065-0.002c-0.025,0-0.05-0.01-0.072-0.01 c-0.013-0.006-0.022-0.006-0.035-0.012c-0.009-0.004-0.025-0.004-0.025-0.004c-0.02-0.004-0.039-0.016-0.055-0.018 c-0.043-0.014-0.086-0.033-0.127-0.057l-2.78-1.686l-0.007-0.002c-0.018-0.012-0.035-0.029-0.048-0.039l-0.021,0.543 c-0.004,0.09-0.063,0.176-0.183,0.248l-1.946,1.129c0.027,0.031,0.058,0.063,0.105,0.098l2.786,1.682 c0.047,0.031,0.111,0.051,0.172,0.07l0.029,0.006c0.063,0.014,0.134,0.021,0.204,0.021h0.005c0.075,0,0.147-0.008,0.22-0.021 h0.007c0.065-0.025,0.133-0.045,0.191-0.08l2.24-1.295c0.042-0.029,0.071-0.057,0.096-0.084 c-0.001-0.01-0.007-0.02-0.011-0.029c-0.004-0.014-0.01-0.045-0.01-0.045l-0.002-0.025v-0.004L121.376,389.928z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M124.528,380.4c-0.025-0.021-0.051-0.035-0.071-0.053c-0.01-0.014-0.026-0.029-0.033-0.047 l-0.009-0.01v-0.004c-0.004-0.006-0.011-0.01-0.013-0.02c-0.005-0.01-0.013-0.018-0.013-0.033 c-0.007-0.01-0.009-0.018-0.014-0.047v-0.018v-0.01l0.025-0.67l-0.273,0.158c-0.024,0.02-0.055,0.029-0.083,0.041 c-0.026,0.01-0.048,0.021-0.086,0.029c0,0-0.012,0.006-0.03,0.012h-0.004l-0.011,0.002c-0.027,0.008-0.045,0.012-0.063,0.012 c-0.02,0.004-0.04,0.004-0.058,0.004c-0.022,0.006-0.038,0.006-0.069,0.01c0,0-0.003-0.004-0.013-0.004h-0.003 c-0.017,0-0.035,0-0.035,0c-0.021,0-0.043-0.006-0.065-0.006c-0.029,0-0.05-0.004-0.076-0.008l-0.033-0.008 c-0.007-0.002-0.019-0.002-0.027-0.008c-0.017-0.006-0.033-0.014-0.049-0.014c-0.049-0.014-0.087-0.039-0.129-0.055 l-1.442-0.881l-0.017,0.543c-0.011,0.09-0.067,0.18-0.187,0.246l-1.939,1.119v0.006c0.029,0.039,0.067,0.08,0.124,0.115 l2.78,1.682c0.053,0.033,0.112,0.057,0.18,0.068c0.007,0.006,0.016,0.006,0.025,0.006c0.065,0.018,0.132,0.025,0.202,0.025 h0.009c0.071,0,0.145-0.008,0.214-0.025h0.005c0.072-0.018,0.14-0.041,0.194-0.074l2.244-1.301 c0.025-0.016,0.038-0.035,0.058-0.055l-1.204-0.725L124.528,380.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M128.513,382.813c-0.03-0.02-0.052-0.033-0.072-0.061c-0.015-0.01-0.024-0.025-0.037-0.043 c0,0-0.004,0-0.009-0.004l-0.002-0.006c-0.002-0.004-0.006-0.01-0.011-0.018c-0.005-0.01-0.007-0.023-0.014-0.039 c-0.002-0.01-0.011-0.027-0.011-0.027v-0.037v-0.004l0.021-0.623l-0.229,0.135c-0.025,0.016-0.058,0.027-0.087,0.043 c-0.021,0.006-0.052,0.016-0.072,0.021c-0.011,0.006-0.033,0.006-0.033,0.006c-0.008,0.008-0.02,0.008-0.02,0.008 s-0.004,0-0.007,0c-0.023,0.012-0.043,0.016-0.06,0.016c-0.021,0.004-0.042,0.004-0.06,0.01c-0.021,0-0.04,0-0.058,0h-0.02 h-0.006c-0.012,0-0.023,0-0.032,0c-0.025,0-0.045,0-0.067-0.006c-0.024,0-0.049-0.004-0.08-0.008c0,0-0.013-0.012-0.023-0.012 c-0.009,0-0.02,0-0.026-0.008c-0.018-0.006-0.035-0.008-0.052-0.008c-0.048-0.02-0.09-0.035-0.131-0.059l-1.462-0.883 l-0.016,0.539c-0.006,0.088-0.068,0.178-0.186,0.242l-1.943,1.127c0.023,0.031,0.056,0.072,0.102,0.1l2.782,1.684 c0.055,0.033,0.117,0.051,0.178,0.068c0.011,0.008,0.019,0.008,0.029,0.012c0.066,0.014,0.131,0.023,0.203,0.023h0.008 c0.07,0,0.143-0.01,0.21-0.027h0.009c0.073-0.016,0.142-0.043,0.193-0.076l2.247-1.299c0.025-0.01,0.038-0.035,0.058-0.047 l-1.207-0.74H128.513z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M132.498,385.227c-0.027-0.021-0.051-0.039-0.073-0.059c-0.011-0.014-0.022-0.027-0.038-0.039 c0,0-0.002-0.006-0.002-0.016l-0.001-0.008c-0.009-0.004-0.011-0.004-0.015-0.016c-0.004-0.008-0.009-0.018-0.013-0.029 c-0.004-0.014-0.004-0.021-0.007-0.037l-0.006-0.031v-0.004l0.024-0.623l-0.232,0.131c-0.025,0.012-0.056,0.029-0.085,0.045 c-0.024,0.008-0.047,0.021-0.085,0.023c0,0-0.01,0.008-0.027,0.014h-0.013c0,0-0.006,0.004-0.029,0.004 c0,0-0.022,0.008-0.038,0.008c-0.02,0.002-0.042,0.002-0.064,0.002c-0.016,0.006-0.036,0.006-0.055,0.006h-0.021h-0.005 c-0.017,0-0.035,0-0.035,0c-0.019,0-0.044-0.006-0.065-0.006c-0.025,0-0.05-0.002-0.076-0.01c-0.009,0-0.016,0-0.042-0.004 c0,0-0.006-0.006-0.019-0.006c-0.012-0.008-0.034-0.01-0.048-0.018c-0.047-0.014-0.089-0.035-0.129-0.057l-1.459-0.883 l-0.02,0.543c-0.001,0.09-0.063,0.18-0.181,0.242l-1.943,1.133c0.021,0.027,0.058,0.063,0.104,0.094l2.783,1.684 c0.053,0.033,0.109,0.053,0.176,0.07c0.005,0.006,0.018,0.01,0.029,0.01c0.065,0.014,0.127,0.02,0.2,0.02h0.007 c0.067,0,0.145-0.006,0.21-0.02l0.015-0.004c0.065-0.023,0.13-0.043,0.19-0.076l2.242-1.299 c0.029-0.02,0.042-0.037,0.06-0.051l-1.206-0.73L132.498,385.227z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M136.481,387.635c-0.027-0.018-0.052-0.033-0.07-0.053c-0.017-0.02-0.027-0.031-0.035-0.039 c-0.002-0.006-0.007-0.01-0.012-0.018v-0.002c-0.004-0.008-0.011-0.01-0.013-0.02c-0.003-0.01-0.008-0.02-0.015-0.037 c-0.001-0.01-0.007-0.031-0.007-0.031c0-0.012,0-0.035,0-0.035v-0.004l0.02-0.621l-0.233,0.135 c-0.024,0.014-0.053,0.027-0.085,0.043c-0.024,0.008-0.047,0.012-0.074,0.021c-0.005,0.006-0.033,0.006-0.033,0.006 l-0.007,0.01c-0.007,0.004-0.011,0.004-0.021,0.004c-0.018,0.004-0.036,0.004-0.058,0.01c-0.02,0.004-0.036,0.004-0.059,0.012 c-0.018,0-0.038,0-0.06,0h-0.016h-0.008h-0.035c-0.02,0-0.043,0-0.063-0.008c-0.027,0-0.049-0.004-0.085-0.01l-0.02-0.004 c-0.013-0.004-0.019-0.004-0.027-0.014c-0.017-0.006-0.035-0.006-0.048-0.016c-0.049-0.012-0.091-0.031-0.129-0.051 l-1.458-0.889l-0.024,0.541c-0.003,0.092-0.063,0.178-0.181,0.248l-1.945,1.125c0.025,0.039,0.055,0.07,0.1,0.098l2.788,1.684 c0.047,0.035,0.109,0.057,0.176,0.072c0.005,0.002,0.017,0.002,0.029,0.002c0.06,0.016,0.133,0.023,0.2,0.023h0.007 c0.073,0,0.147-0.004,0.212-0.023h0.011c0.071-0.014,0.134-0.039,0.194-0.074l2.24-1.301c0.029-0.014,0.042-0.027,0.058-0.045 l-1.2-0.734C136.487,387.641,136.481,387.635,136.481,387.635z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M140.465,390.049c-0.025-0.014-0.05-0.037-0.071-0.059c-0.011-0.01-0.023-0.021-0.034-0.035 c0-0.004-0.002-0.012-0.006-0.016h-0.003c-0.006-0.012-0.009-0.018-0.013-0.027c-0.006-0.01-0.011-0.02-0.015-0.025 c-0.001-0.018-0.009-0.033-0.009-0.033l-0.002-0.039v-0.004l0.024-0.625l-0.232,0.133c-0.028,0.018-0.057,0.033-0.086,0.047 c-0.025,0.01-0.045,0.014-0.074,0.023c-0.013,0.004-0.026,0.004-0.035,0.01h-0.01l-0.018,0.004 c-0.02,0.004-0.039,0.004-0.058,0.01c-0.023,0-0.038,0.006-0.06,0.01c-0.017,0-0.038,0-0.06,0c-0.006,0-0.013,0-0.023,0 h-0.002h-0.035c-0.022,0-0.042,0-0.063-0.004c-0.025-0.006-0.051-0.006-0.083-0.012c0,0-0.011-0.004-0.026-0.008 c0,0-0.014,0-0.026-0.006c-0.014-0.004-0.032-0.012-0.047-0.014c-0.045-0.014-0.088-0.027-0.125-0.057l-1.464-0.887 l-0.018,0.545c-0.004,0.09-0.067,0.18-0.183,0.242l-1.947,1.131c0.029,0.031,0.058,0.074,0.107,0.098l2.782,1.682 c0.052,0.033,0.112,0.051,0.185,0.076c0,0,0.011,0,0.018,0.006c0.065,0.012,0.135,0.023,0.206,0.023h0.003 c0.073,0,0.145-0.012,0.217-0.029h0.006c0.07-0.014,0.137-0.043,0.195-0.076l2.24-1.293c0.029-0.018,0.037-0.043,0.06-0.059 l-1.209-0.729L140.465,390.049z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M144.45,392.455c-0.03-0.012-0.05-0.031-0.07-0.051c-0.018-0.014-0.027-0.031-0.04-0.047l-0.004-0.002 l-0.003-0.01c-0.001-0.004-0.011-0.012-0.015-0.021c-0.005-0.01-0.01-0.018-0.011-0.025c-0.003-0.018-0.007-0.037-0.007-0.037 c-0.003-0.014-0.003-0.035-0.003-0.035v-0.002l0.02-0.617l-0.225,0.129c-0.029,0.016-0.056,0.027-0.09,0.035 c-0.025,0.012-0.048,0.02-0.069,0.033c-0.014,0.002-0.025,0.006-0.04,0.006l-0.004,0.006c-0.011,0-0.021,0-0.021,0 c-0.019,0.006-0.037,0.008-0.058,0.008c-0.019,0.006-0.039,0.006-0.052,0.012c-0.028,0-0.043,0.004-0.06,0.004h-0.025h-0.006 c-0.009,0-0.036,0-0.036,0c-0.016,0-0.042-0.004-0.061-0.01c-0.026,0-0.049-0.006-0.075-0.006 c-0.013-0.002-0.031-0.008-0.031-0.008c-0.009-0.006-0.029-0.006-0.029-0.006c-0.015-0.006-0.033-0.006-0.051-0.02 c-0.047-0.012-0.09-0.031-0.127-0.055l-1.466-0.883l-0.017,0.533c-0.003,0.088-0.065,0.182-0.181,0.252l-1.948,1.127 c0.031,0.033,0.06,0.066,0.107,0.094l2.784,1.684c0.049,0.039,0.109,0.057,0.176,0.07c0.006,0.004,0.027,0.01,0.027,0.01 c0.063,0.014,0.133,0.018,0.198,0.018h0.011c0.072,0,0.145-0.004,0.212-0.018l0.01-0.006c0.063-0.018,0.134-0.035,0.192-0.074 l2.244-1.301c0.028-0.016,0.037-0.031,0.058-0.047l-1.208-0.73L144.45,392.455z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M148.445,394.881c-0.027-0.021-0.056-0.035-0.071-0.061c-0.016-0.016-0.029-0.025-0.036-0.041 c0,0-0.005-0.006-0.009-0.01h-0.001c-0.002-0.01-0.01-0.018-0.012-0.02c-0.006-0.018-0.014-0.029-0.018-0.039 c-0.002-0.01-0.003-0.021-0.005-0.041v-0.029v-0.004l0.02-0.631l-0.241,0.135c-0.027,0.02-0.054,0.033-0.089,0.047 c-0.025,0.01-0.049,0.014-0.074,0.023c-0.01,0.006-0.022,0.006-0.032,0.006c-0.003,0.004-0.007,0.004-0.007,0.004 c-0.009,0.004-0.022,0.004-0.022,0.004c-0.02,0.004-0.04,0.01-0.06,0.01c-0.02,0.006-0.04,0.006-0.054,0.01 c-0.023,0-0.042,0-0.058,0h-0.025h-0.003c-0.011,0-0.022,0-0.033,0c-0.024,0-0.04,0-0.065-0.004 c-0.024,0-0.047-0.006-0.087-0.012c0,0-0.006-0.004-0.027-0.004c0,0-0.006-0.004-0.019-0.008 c-0.018-0.006-0.032-0.006-0.05-0.01c-0.045-0.02-0.085-0.033-0.125-0.063l-1.466-0.885l-0.015,0.545 c-0.005,0.086-0.067,0.178-0.185,0.242l-1.947,1.127c0.029,0.037,0.066,0.072,0.116,0.104l2.782,1.688 c0.049,0.029,0.114,0.051,0.185,0.07c0,0,0.012,0.006,0.019,0.006c0.067,0.016,0.138,0.021,0.21,0.021h0.004 c0.071,0,0.143-0.006,0.212-0.021h0.009c0.068-0.018,0.136-0.047,0.192-0.076l2.244-1.301 c0.023-0.012,0.042-0.031,0.059-0.055l-1.209-0.729H148.445z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M152.424,397.289c-0.026-0.02-0.051-0.037-0.071-0.057c-0.013-0.016-0.025-0.025-0.035-0.041 l-0.007-0.01l-0.007-0.01c0,0-0.003-0.01-0.009-0.014c-0.002-0.01-0.005-0.025-0.017-0.033 c-0.001-0.01-0.003-0.039-0.003-0.039l-0.003-0.029v-0.008l0.021-0.615l-0.227,0.129c-0.025,0.014-0.054,0.029-0.087,0.037 c-0.023,0.016-0.048,0.025-0.072,0.029c-0.011,0.008-0.025,0.008-0.038,0.014h-0.011c0,0-0.007,0-0.011,0.004 c-0.024,0-0.044,0.006-0.062,0.01c-0.021,0-0.04,0.006-0.058,0.006c-0.021,0-0.058,0-0.058,0c-0.009,0.004-0.021,0-0.021,0 h-0.007h-0.031c-0.025,0-0.045,0-0.071,0c-0.019-0.006-0.049-0.006-0.084-0.016c0,0-0.005,0-0.025-0.004 c0,0-0.009,0-0.022-0.006c-0.018,0-0.034-0.008-0.048-0.012c-0.045-0.02-0.087-0.037-0.125-0.057l-1.464-0.889l-0.016,0.543 c-0.008,0.084-0.067,0.174-0.186,0.246l-1.945,1.129c0.026,0.031,0.057,0.064,0.104,0.088l2.781,1.689 c0.051,0.029,0.116,0.051,0.179,0.07l0.028,0.004c0.061,0.02,0.13,0.027,0.203,0.027h0.006c0.07,0,0.145-0.008,0.212-0.027 l0.007-0.004c0.072-0.014,0.136-0.037,0.194-0.07l2.24-1.301c0.029-0.012,0.044-0.033,0.063-0.051l-1.204-0.734H152.424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M156.413,399.705c-0.029-0.021-0.053-0.039-0.068-0.059c-0.017-0.016-0.03-0.029-0.037-0.041 c-0.005,0-0.007-0.008-0.011-0.01l-0.004-0.006c-0.001-0.012-0.005-0.016-0.01-0.018c-0.003-0.01-0.007-0.023-0.015-0.041 c-0.001-0.006-0.003-0.031-0.003-0.031l-0.007-0.031v-0.004l0.023-0.629l-0.234,0.143c-0.029,0.014-0.058,0.027-0.088,0.035 c-0.023,0.01-0.045,0.02-0.072,0.023c-0.008,0.004-0.02,0.004-0.033,0.012h-0.017c0,0-0.005,0.006-0.011,0.008 c-0.025,0-0.04,0.004-0.061,0.004c-0.017,0.012-0.037,0.014-0.06,0.014c-0.015,0-0.038,0-0.055,0.006c-0.005,0-0.02,0-0.02,0 h-0.007h-0.033c-0.024-0.006-0.044-0.006-0.069-0.006c-0.021-0.002-0.045-0.014-0.08-0.018c0,0-0.013,0-0.023-0.002 c-0.006-0.006-0.024-0.006-0.024-0.006c-0.02-0.008-0.038-0.012-0.055-0.016c-0.043-0.012-0.088-0.033-0.121-0.055 l-1.468-0.887l-0.016,0.539c0,0.092-0.063,0.178-0.184,0.248l-1.946,1.129c0.027,0.031,0.062,0.066,0.108,0.098l2.784,1.682 c0.053,0.037,0.113,0.057,0.176,0.072c0.007,0.008,0.025,0.008,0.025,0.008c0.063,0.01,0.134,0.02,0.205,0.02h0.007 c0.071,0,0.141-0.01,0.212-0.02h0.009c0.067-0.023,0.136-0.043,0.19-0.082l2.244-1.297c0.027-0.016,0.042-0.031,0.06-0.055 l-1.205-0.727L156.413,399.705z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M160.396,402.107c-0.028-0.016-0.049-0.033-0.075-0.053c-0.013-0.008-0.023-0.021-0.031-0.037 c-0.005-0.01-0.005-0.01-0.012-0.014V402c-0.003-0.01-0.005-0.014-0.011-0.02c-0.006-0.01-0.011-0.02-0.015-0.035 c-0.001-0.006-0.008-0.035-0.008-0.035v-0.033v-0.004l0.017-0.619l-0.23,0.133c-0.023,0.012-0.055,0.027-0.082,0.047 c-0.025,0.004-0.051,0.012-0.074,0.023c-0.013,0.006-0.022,0.006-0.041,0.006l-0.003,0.004c-0.007,0-0.014,0-0.022,0.004 c-0.021,0.004-0.036,0.004-0.058,0.012c-0.02,0-0.038,0.004-0.062,0.004c-0.014,0.004-0.034,0.004-0.052,0.004h-0.024h-0.001 c-0.013,0-0.04,0-0.04,0c-0.017,0-0.042,0-0.061-0.004c-0.026-0.004-0.048-0.004-0.075-0.012c-0.011,0-0.017-0.004-0.04-0.008 c0,0-0.007-0.004-0.017-0.004c-0.016-0.006-0.036-0.012-0.05-0.018c-0.047-0.012-0.087-0.031-0.131-0.055l-1.459-0.887 l-0.016,0.541c-0.009,0.096-0.067,0.18-0.185,0.246l-1.947,1.129c0.025,0.033,0.055,0.064,0.102,0.096l2.784,1.688 c0.051,0.025,0.112,0.045,0.178,0.063c0.007,0.012,0.029,0.012,0.029,0.012c0.061,0.014,0.132,0.021,0.204,0.021h0.002 c0.076,0,0.146-0.008,0.221-0.021h0.001c0.071-0.023,0.135-0.049,0.194-0.074l2.238-1.303c0.032-0.02,0.044-0.035,0.066-0.051 l-1.21-0.732L160.396,402.107z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M168.364,406.938c-0.03-0.021-0.054-0.037-0.074-0.057c-0.011-0.014-0.023-0.025-0.037-0.041 l-0.005-0.008v-0.01c-0.007-0.01-0.013-0.016-0.015-0.018c-0.003-0.014-0.011-0.023-0.012-0.037 c-0.002-0.008-0.009-0.029-0.009-0.029l-0.003-0.039v-0.002l0.021-0.619l-0.229,0.131c-0.031,0.016-0.06,0.033-0.088,0.047 c-0.024,0.01-0.049,0.016-0.075,0.023c-0.009,0-0.029,0.002-0.029,0.002l-0.009,0.008l-0.021,0.002 c-0.02,0.008-0.038,0.008-0.06,0.01c-0.022,0.008-0.036,0.008-0.058,0.012c-0.022,0-0.036,0-0.063,0h-0.014h-0.009 c-0.007,0-0.032,0-0.032,0c-0.018,0-0.044,0-0.062-0.004c-0.027,0-0.053-0.008-0.085-0.01l-0.02-0.008 c-0.011-0.002-0.018-0.01-0.027-0.01c-0.017-0.002-0.032-0.002-0.052-0.01c-0.045-0.016-0.091-0.041-0.125-0.063l-1.463-0.885 l-0.02,0.543c-0.002,0.096-0.063,0.182-0.181,0.25l-1.948,1.125c0.031,0.033,0.056,0.064,0.105,0.098l2.784,1.686 c0.051,0.027,0.109,0.051,0.174,0.068c0.011,0,0.021,0.006,0.03,0.006c0.064,0.014,0.133,0.023,0.202,0.023h0.005 c0.074,0,0.145-0.01,0.216-0.023h0.009c0.069-0.023,0.136-0.047,0.192-0.074l2.24-1.301c0.028-0.018,0.044-0.037,0.064-0.055 l-1.211-0.727L168.364,406.938z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M164.382,404.523c-0.028-0.012-0.054-0.037-0.074-0.061c-0.013-0.008-0.024-0.021-0.037-0.037 c0,0-0.001-0.004-0.003-0.008l-0.006-0.006c-0.003-0.004-0.007-0.014-0.012-0.018c-0.005-0.012-0.011-0.02-0.013-0.035 c-0.004-0.012-0.011-0.037-0.011-0.037v-0.031l0.024-0.627l-0.234,0.137c-0.025,0.012-0.056,0.025-0.087,0.037 c-0.025,0.008-0.045,0.018-0.074,0.025c-0.012,0-0.024,0.008-0.035,0.012h-0.005c0,0-0.014,0-0.019,0.008 c-0.018,0-0.042,0.006-0.06,0.012c-0.02,0.004-0.04,0.004-0.057,0.004c-0.018,0-0.042,0.004-0.06,0.004h-0.023h-0.005 c-0.011,0-0.031,0-0.031,0c-0.023,0-0.045-0.004-0.062-0.004c-0.029,0-0.056-0.004-0.091-0.016c0,0-0.009,0-0.018-0.008 c-0.011,0-0.02-0.004-0.031-0.004c-0.016-0.008-0.035-0.012-0.049-0.016c-0.047-0.014-0.091-0.033-0.131-0.051l-1.457-0.885 l-0.018,0.533c-0.006,0.09-0.065,0.182-0.182,0.256l-1.952,1.121c0.031,0.039,0.06,0.068,0.108,0.1l2.782,1.682 c0.053,0.033,0.112,0.057,0.18,0.07c0.006,0,0.025,0.01,0.025,0.01c0.066,0.014,0.134,0.018,0.203,0.018h0.009 c0.067,0,0.138-0.004,0.214-0.023h0.007c0.065-0.018,0.134-0.041,0.192-0.078l2.239-1.299c0.03-0.014,0.043-0.029,0.065-0.047 l-1.209-0.738H164.382z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M159.643,405.723c-0.025-0.014-0.048-0.033-0.07-0.051c-0.013-0.01-0.026-0.031-0.032-0.043 c-0.004-0.004-0.006-0.01-0.009-0.014h-0.006c-0.001-0.01-0.003-0.016-0.009-0.023c-0.005-0.01-0.008-0.02-0.017-0.027 c-0.003-0.02-0.005-0.037-0.005-0.037c-0.002-0.012-0.002-0.031-0.002-0.031v-0.008l0.02-0.617l-0.233,0.131 c-0.026,0.014-0.052,0.029-0.084,0.037c-0.024,0.01-0.049,0.023-0.071,0.035l-0.043,0.004l-0.012,0.004 c0,0-0.003,0-0.029,0.006c0,0-0.016,0.002-0.038,0.002c-0.02,0.006-0.036,0.01-0.057,0.01c-0.021,0-0.04,0.006-0.058,0.006 h-0.025h-0.017h-0.018c-0.025-0.006-0.041-0.006-0.067-0.006c-0.021-0.004-0.052-0.01-0.087-0.012c0,0-0.007-0.006-0.02-0.006 c-0.009-0.004-0.019-0.004-0.029-0.008c-0.015,0-0.031-0.008-0.049-0.012c-0.045-0.02-0.088-0.039-0.127-0.061l-2.226-1.348 l-0.02,0.549c-0.005,0.088-0.067,0.18-0.187,0.248l-1.944,1.127c0.027,0.031,0.06,0.063,0.105,0.098l2.784,1.684 c0.047,0.029,0.112,0.051,0.175,0.072c0.011,0.002,0.017,0.002,0.027,0.002c0.064,0.016,0.132,0.023,0.204,0.023h0.005 c0.074,0,0.146-0.008,0.217-0.023h0.006c0.069-0.023,0.136-0.045,0.192-0.074l2.242-1.301 c0.029-0.014,0.043-0.041,0.069-0.061l-0.444-0.27L159.643,405.723z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M158.184,408.924c-0.027-0.021-0.049-0.043-0.073-0.063c-0.013-0.01-0.025-0.025-0.031-0.037 c-0.007-0.006-0.011-0.012-0.011-0.012v-0.008c-0.008-0.006-0.013-0.012-0.015-0.018c-0.003-0.014-0.007-0.025-0.016-0.033 c-0.002-0.01-0.004-0.035-0.004-0.035l-0.001-0.035v-0.004l0.021-0.689l-0.293,0.17c-0.029,0.014-0.056,0.027-0.085,0.035 c-0.021,0.016-0.047,0.025-0.071,0.035c-0.013,0-0.025,0.004-0.038,0.004l-0.011,0.006c0,0-0.005,0-0.011,0 c-0.023,0.002-0.04,0.008-0.06,0.012c-0.021,0-0.038,0.006-0.06,0.006c-0.02,0-0.038,0-0.063,0.004c0,0-0.009,0-0.015,0 h-0.009c-0.01,0-0.03,0-0.03,0c-0.025-0.004-0.063-0.004-0.063-0.004c-0.028-0.006-0.057-0.006-0.091-0.016l-0.017-0.002 c-0.012,0-0.019-0.006-0.029-0.01c-0.018,0-0.034-0.006-0.053-0.01c-0.042-0.014-0.085-0.039-0.125-0.057l-1.461-0.889 l-0.021,0.543c-0.002,0.082-0.062,0.172-0.179,0.242l-1.951,1.133c0.025,0.033,0.06,0.064,0.107,0.098l2.78,1.686 c0.051,0.027,0.116,0.051,0.178,0.064c0.011,0,0.029,0.014,0.029,0.014c0.065,0.016,0.13,0.018,0.2,0.018h0.01 c0.071,0,0.144-0.002,0.214-0.027l0.009-0.004c0.069-0.014,0.134-0.037,0.188-0.07l2.245-1.301 c0.028-0.014,0.041-0.031,0.062-0.051l-1.148-0.695H158.184z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M159.437,410.227c-0.004,0.09-0.063,0.184-0.183,0.252l-1.951,1.125 c0.026,0.039,0.06,0.068,0.104,0.098l3.461,2.09c0.051,0.037,0.114,0.057,0.175,0.074c0.008,0,0.018,0,0.025,0.002 c0.067,0.018,0.138,0.027,0.207,0.027h0.008c0.07-0.006,0.145-0.01,0.213-0.029h0.009c0.071-0.014,0.136-0.043,0.196-0.074 l2.241-1.295c0.028-0.021,0.041-0.035,0.06-0.055l-4.546-2.752L159.437,410.227z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M157.374,412.5c-0.025-0.02-0.055-0.035-0.071-0.059c-0.016-0.012-0.029-0.025-0.034-0.039 c-0.001-0.006-0.011-0.012-0.011-0.012l-0.002-0.008c-0.001-0.004-0.009-0.008-0.01-0.014 c-0.008-0.014-0.015-0.023-0.017-0.033c0-0.018-0.006-0.027-0.008-0.037v-0.033v-0.004l0.018-0.619l-0.23,0.131 c-0.025,0.016-0.052,0.029-0.087,0.043c-0.021,0.008-0.047,0.016-0.075,0.023c-0.009,0.006-0.03,0.01-0.03,0.01l-0.009,0.006 c-0.006,0-0.02,0-0.02,0c-0.021,0.01-0.038,0.01-0.059,0.014c-0.019,0-0.041,0-0.057,0.002 c-0.022,0.008-0.06,0.008-0.06,0.008c-0.004,0-0.017,0-0.017,0h-0.009h-0.035c-0.022,0-0.043,0-0.063-0.008 c-0.025-0.002-0.051-0.002-0.076-0.006c-0.009-0.006-0.029-0.01-0.029-0.01l-0.028-0.006c-0.018-0.004-0.034-0.01-0.048-0.018 c-0.051-0.016-0.089-0.033-0.127-0.059l-2.785-1.678l-0.004-0.008c-0.021-0.012-0.038-0.029-0.056-0.043l-0.017,0.541 c0,0.094-0.067,0.189-0.183,0.25l-1.92,1.115c0.002,0.006,0.002,0.021,0.011,0.031l0.001,0.004 c0.029,0.037,0.069,0.078,0.122,0.113l6.085,3.684c0.05,0.029,0.112,0.047,0.177,0.066c0.007,0.004,0.027,0.004,0.027,0.004 c0.063,0.02,0.13,0.025,0.205,0.025h0.004c0.07,0,0.148-0.006,0.213-0.025h0.008c0.072-0.02,0.137-0.041,0.192-0.074 l2.248-1.303c0.02-0.014,0.037-0.029,0.056-0.043l-3.188-1.934H157.374z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M152.533,414.227c-0.002,0.09-0.065,0.176-0.185,0.244l-1.947,1.129 c0.031,0.035,0.06,0.074,0.107,0.098l2.78,1.682c0.053,0.031,0.113,0.053,0.18,0.074l0.025,0.004 c0.064,0.02,0.134,0.025,0.201,0.025h0.008c0.074,0,0.147-0.01,0.219-0.025l0.005-0.004c0.067-0.014,0.136-0.043,0.192-0.074 l2.242-1.295c0.039-0.018,0.067-0.055,0.087-0.08l-3.893-2.355L152.533,414.227z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M153.694,418.287c0,0-0.014,0-0.02,0h-0.007c-0.013,0-0.022,0-0.033,0 c-0.02-0.006-0.047-0.006-0.063-0.01c-0.031,0-0.051-0.006-0.079-0.006c-0.008-0.004-0.017-0.008-0.039-0.012 c0,0-0.01,0-0.016-0.008c-0.017-0.004-0.037-0.004-0.055-0.008c-0.042-0.014-0.085-0.045-0.124-0.059l-2.782-1.686 l-0.003-0.006c-0.025-0.016-0.042-0.027-0.063-0.047l-0.02,0.563c-0.001,0.088-0.063,0.18-0.18,0.246l-1.95,1.125 c0.026,0.041,0.056,0.068,0.103,0.096l2.157,1.307c0.051,0.033,0.109,0.055,0.176,0.07l0.029,0.01 c0.065,0.008,0.134,0.02,0.201,0.02h0.009c0.075,0,0.145-0.012,0.214-0.025l0.007-0.004c0.071-0.016,0.138-0.037,0.194-0.076 l2.246-1.295c0.094-0.053,0.143-0.131,0.163-0.201h-0.007C153.734,418.281,153.716,418.281,153.694,418.287z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M150.319,416.297l-0.004-0.037v-0.01l0.022-0.615l-0.234,0.141c-0.023,0.012-0.055,0.027-0.085,0.037 c-0.023,0.01-0.047,0.018-0.071,0.021c-0.01,0.006-0.025,0.006-0.04,0.01h-0.009c0,0-0.005,0.006-0.011,0.01 c-0.025,0-0.041,0.006-0.06,0.006c-0.024,0.01-0.038,0.014-0.058,0.014c-0.019,0-0.04,0-0.06,0h-0.017h-0.011 c-0.011,0-0.029,0-0.029,0c-0.027,0-0.065,0-0.065,0c-0.025-0.004-0.051-0.014-0.085-0.02c0,0-0.009,0-0.029-0.01 c0,0-0.011,0-0.036-0.004c0,0-0.018-0.006-0.035-0.01c-0.045-0.014-0.088-0.033-0.128-0.055l-2.779-1.689l-0.009-0.006 c-0.027-0.014-0.045-0.029-0.063-0.045l-0.019,0.559c-0.005,0.084-0.063,0.174-0.184,0.246l-1.951,1.131 c0.032,0.033,0.062,0.066,0.108,0.098l2.78,1.684c0.049,0.027,0.117,0.053,0.19,0.068c0,0,0.005,0.002,0.015,0.01 c0.067,0.016,0.136,0.02,0.208,0.02h0.005c0.071,0,0.145-0.004,0.215-0.02c0.001-0.008,0.008-0.008,0.008-0.008 c0.071-0.018,0.14-0.043,0.196-0.076l2.241-1.299c0.044-0.023,0.075-0.057,0.104-0.084c-0.005-0.014-0.011-0.021-0.014-0.037 C150.327,416.316,150.319,416.297,150.319,416.297z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M146.334,413.842l0.021-0.617l-0.231,0.137c-0.033,0.012-0.055,0.023-0.086,0.037 c-0.025,0.014-0.05,0.02-0.072,0.027c-0.012,0.004-0.027,0.004-0.038,0.01l-0.004,0.006h-0.013 c-0.029,0.004-0.047,0.006-0.064,0.006c-0.021,0.008-0.04,0.008-0.06,0.012c-0.018,0-0.04,0-0.058,0h-0.024h-0.009 c-0.011,0-0.025,0-0.025,0c-0.026,0-0.047,0-0.067-0.004c-0.027,0-0.052-0.008-0.077-0.01c-0.011,0-0.019-0.004-0.033-0.004 c-0.009-0.006-0.015-0.012-0.025-0.012c-0.02-0.004-0.037-0.004-0.053-0.012c-0.045-0.02-0.09-0.039-0.125-0.061l-2.787-1.686 h-0.002c-0.023-0.014-0.044-0.029-0.063-0.049l-0.018,0.559c-0.002,0.09-0.063,0.18-0.182,0.248l-1.952,1.127 c0.029,0.033,0.058,0.068,0.107,0.1l2.781,1.684c0.055,0.027,0.114,0.051,0.177,0.07c0.013,0.006,0.02,0.006,0.031,0.006 c0.065,0.014,0.132,0.021,0.199,0.021h0.012c0.072,0,0.141-0.008,0.212-0.021h0.009c0.067-0.021,0.138-0.049,0.196-0.082 l2.242-1.295c0.045-0.027,0.076-0.063,0.104-0.096c-0.001-0.002-0.008-0.018-0.013-0.027c0-0.004-0.009-0.031-0.009-0.031 v-0.033V413.842z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M142.348,411.471v-0.035v-0.006l0.022-0.615l-0.23,0.133c-0.031,0.02-0.058,0.033-0.09,0.041 c-0.023,0.01-0.048,0.018-0.071,0.023c-0.013,0.006-0.024,0.012-0.033,0.012h-0.007c-0.004,0.004-0.022,0.004-0.022,0.004 c-0.018,0.002-0.038,0.01-0.058,0.01c-0.016,0.004-0.04,0.004-0.056,0.004c-0.019,0.004-0.038,0.014-0.058,0.014h-0.02h-0.009 c-0.009,0-0.031,0-0.031,0c-0.023-0.01-0.043-0.01-0.065-0.014c-0.025,0-0.051-0.004-0.075-0.012 c-0.011,0-0.021-0.002-0.029-0.002c-0.011-0.004-0.026-0.004-0.026-0.004c-0.02-0.012-0.039-0.012-0.052-0.018 c-0.047-0.01-0.088-0.029-0.13-0.059l-2.782-1.684l-0.008-0.006c-0.02-0.014-0.047-0.027-0.063-0.047l-0.014,0.559 c-0.011,0.088-0.069,0.178-0.188,0.246l-1.95,1.129c0.031,0.037,0.061,0.07,0.107,0.098l2.78,1.688 c0.056,0.029,0.116,0.051,0.18,0.068c0.01,0.002,0.018,0.002,0.027,0.002c0.063,0.021,0.136,0.027,0.205,0.027h0.004 c0.075,0,0.145-0.006,0.217-0.027h0.007c0.071-0.02,0.138-0.041,0.196-0.074l2.243-1.301c0.044-0.029,0.073-0.055,0.103-0.094 c-0.007-0.008-0.01-0.018-0.014-0.025C142.357,411.494,142.348,411.486,142.348,411.471z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M138.388,408.402l-0.235,0.131c-0.027,0.016-0.054,0.027-0.083,0.043 c-0.023,0.004-0.052,0.014-0.074,0.021c-0.015,0.012-0.021,0.012-0.04,0.016h-0.011c0,0-0.007,0-0.015,0.004 c-0.016,0.004-0.036,0.004-0.058,0.01c-0.016,0-0.038,0.006-0.054,0.01c-0.022,0-0.058,0-0.058,0c-0.007,0-0.023,0-0.023,0 h-0.005h-0.038c-0.014,0-0.036,0-0.06-0.004c-0.025-0.006-0.049-0.006-0.087-0.012c0,0-0.007-0.004-0.027-0.008 c0,0-0.007,0-0.016-0.004c-0.019-0.006-0.037-0.012-0.053-0.02c-0.043-0.014-0.085-0.037-0.124-0.057l-2.789-1.684 c-0.027-0.018-0.044-0.037-0.063-0.053l-0.023,0.563c0,0.09-0.062,0.182-0.178,0.244l-1.952,1.133 c0.033,0.031,0.06,0.068,0.105,0.092l2.786,1.684c0.047,0.027,0.109,0.055,0.174,0.074l0.032,0.006 c0.063,0.014,0.131,0.021,0.198,0.021h0.01c0.072,0,0.143-0.008,0.214-0.021l0.009-0.006c0.07-0.014,0.135-0.047,0.195-0.074 l2.24-1.295c0.043-0.029,0.08-0.061,0.105-0.094c-0.001-0.01-0.009-0.014-0.013-0.029c-0.003-0.014-0.005-0.025-0.007-0.035 l-0.003-0.033v-0.004L138.388,408.402z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M134.384,406.648c-0.006-0.008-0.006-0.037-0.006-0.037v-0.004l0.02-0.619l-0.227,0.133 c-0.028,0.023-0.058,0.031-0.089,0.047c-0.02,0.008-0.045,0.012-0.067,0.023c-0.013,0.004-0.027,0.004-0.04,0.008h-0.006 c-0.005,0.006-0.022,0.006-0.022,0.006c-0.016,0.004-0.038,0.004-0.055,0.01c-0.017,0.002-0.037,0.002-0.059,0.01 c-0.018,0-0.06,0-0.06,0h-0.02h-0.011h-0.029c-0.021,0-0.043,0-0.063-0.008c-0.027,0-0.054-0.002-0.088-0.008 c0,0-0.006-0.004-0.017-0.004c-0.011-0.006-0.031-0.01-0.031-0.01c-0.014-0.004-0.036-0.004-0.05-0.016 c-0.045-0.012-0.087-0.031-0.122-0.055l-2.786-1.684l-0.003-0.006c-0.026-0.014-0.056-0.037-0.071-0.053 c-0.018-0.02-0.027-0.031-0.042-0.045c0,0-0.001-0.002-0.004-0.01l-0.001-0.006c-0.003-0.002-0.013-0.012-0.014-0.018 c-0.007-0.01-0.011-0.025-0.015-0.039c-0.004-0.006-0.009-0.029-0.009-0.029c0-0.01,0-0.033,0-0.033v-0.006l0.02-0.631 l-0.245,0.143c-0.027,0.01-0.057,0.027-0.083,0.039c-0.024,0.006-0.049,0.014-0.075,0.021c-0.012,0-0.021,0.008-0.034,0.008 l-0.009,0.008c-0.004,0-0.016,0.004-0.016,0.004c-0.018,0-0.042,0.008-0.06,0.008c-0.02,0.008-0.057,0.008-0.057,0.008 c-0.02,0.006-0.038,0.006-0.062,0.006h-0.014h-0.011h-0.033c-0.021,0-0.044-0.006-0.063-0.006 c-0.025,0-0.051-0.008-0.075-0.008c-0.01-0.008-0.021-0.008-0.03-0.012l-0.027-0.008c-0.018-0.008-0.038-0.012-0.053-0.016 c-0.047-0.014-0.088-0.033-0.124-0.053l-2.785-1.686h-0.008c-0.027-0.023-0.047-0.043-0.069-0.063 c-0.014-0.008-0.025-0.021-0.036-0.037c-0.006-0.004-0.007-0.004-0.011-0.018h-0.003c0,0-0.006-0.016-0.009-0.02 c-0.007-0.014-0.009-0.02-0.012-0.035c-0.008-0.008-0.009-0.027-0.009-0.027l-0.002-0.039v-0.006l0.02-0.615l-0.232,0.133 c-0.023,0.014-0.054,0.033-0.083,0.043c-0.025,0.004-0.047,0.014-0.073,0.023c-0.011,0-0.018,0.004-0.034,0.008h-0.009 c0,0-0.011,0-0.019,0.006c-0.018,0-0.038,0.01-0.056,0.01c-0.02,0-0.056,0.004-0.056,0.004c-0.021,0-0.043,0.004-0.06,0.004 h-0.022h-0.009c-0.012,0-0.031,0-0.031,0c-0.018,0-0.045-0.004-0.065-0.004c-0.026,0-0.051-0.004-0.078-0.008 c-0.007-0.006-0.02-0.006-0.031-0.012l-0.027-0.004c-0.012-0.004-0.034-0.01-0.049-0.014 c-0.047-0.014-0.089-0.039-0.129-0.057l-2.784-1.688l-0.004-0.004c-0.03-0.016-0.05-0.033-0.072-0.057 c-0.013-0.01-0.022-0.023-0.035-0.037c0,0-0.003-0.004-0.009-0.012l-0.004-0.012c0,0-0.003-0.008-0.01-0.012 c-0.004-0.012-0.009-0.021-0.013-0.035c-0.002-0.01-0.005-0.033-0.005-0.033l-0.006-0.033v-0.004l0.022-0.629l-0.236,0.141 c-0.025,0.016-0.054,0.029-0.087,0.039c-0.02,0.01-0.047,0.018-0.067,0.023c-0.013,0.006-0.04,0.01-0.04,0.01h-0.006 c-0.008,0.004-0.018,0.004-0.018,0.004c-0.02,0.004-0.038,0.016-0.062,0.02c-0.015,0-0.035,0-0.058,0.002 c-0.017,0-0.035,0.008-0.06,0.008h-0.016h-0.013h-0.029c-0.023,0-0.043-0.008-0.062-0.008 c-0.027-0.002-0.049-0.006-0.076-0.006c-0.013-0.012-0.018-0.016-0.03-0.016c-0.012-0.004-0.025-0.004-0.025-0.004 c-0.017-0.01-0.037-0.01-0.057-0.016c-0.043-0.014-0.085-0.031-0.124-0.057l-2.78-1.678l-0.009-0.014 c-0.026-0.014-0.051-0.033-0.071-0.053c-0.015-0.014-0.027-0.023-0.04-0.045l-0.005-0.012h-0.001 c-0.003-0.01-0.011-0.012-0.011-0.021c-0.007-0.012-0.012-0.02-0.014-0.029c-0.004-0.016-0.014-0.037-0.014-0.037 l-0.001-0.035l0.001-0.006l0.024-0.617l-0.234,0.133c-0.028,0.018-0.054,0.029-0.087,0.037 c-0.024,0.016-0.046,0.025-0.071,0.029c-0.012,0.008-0.021,0.008-0.034,0.01h-0.008c-0.007,0.004-0.012,0.01-0.036,0.01 c0,0-0.022,0.006-0.042,0.008c-0.018,0-0.038,0.006-0.057,0.006c-0.016,0-0.04,0-0.06,0.004h-0.017H117.8h-0.032 c-0.018-0.004-0.04-0.004-0.063-0.004c-0.023-0.006-0.051-0.008-0.073-0.008c-0.009-0.006-0.035-0.012-0.035-0.012 c-0.009-0.004-0.016-0.004-0.025-0.006c-0.021,0-0.037-0.008-0.05-0.012c-0.048-0.014-0.089-0.037-0.127-0.063l-2.786-1.682 h-0.006c-0.021-0.018-0.045-0.037-0.063-0.055l-0.016,0.559c-0.005,0.09-0.067,0.178-0.185,0.248l-1.948,1.127 c0.03,0.033,0.06,0.07,0.106,0.1l18.73,11.342c0.051,0.029,0.113,0.049,0.176,0.066c0.009,0.004,0.027,0.004,0.027,0.004 c0.065,0.014,0.136,0.029,0.205,0.029h0.009c0.069,0,0.138-0.016,0.214-0.029l0.006-0.004c0.07-0.014,0.138-0.037,0.196-0.076 l2.24-1.301c0.046-0.016,0.075-0.051,0.102-0.088c-0.004-0.01-0.007-0.018-0.015-0.027 C134.386,406.672,134.384,406.648,134.384,406.648z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M114.475,393.922l-0.238,0.139c-0.026,0.016-0.051,0.029-0.081,0.037 c-0.023,0.01-0.047,0.02-0.072,0.025c-0.017,0.004-0.025,0.004-0.04,0.008l-0.014,0.006c0,0-0.003,0-0.012,0 c-0.018,0.004-0.036,0.008-0.058,0.014c-0.019,0-0.033,0-0.055,0.01c-0.021,0-0.042,0-0.068,0c0,0-0.003,0-0.017,0h-0.007 c-0.011,0-0.027,0-0.027,0c-0.025,0-0.044,0-0.091-0.01c0,0-0.027-0.006-0.05-0.01l-0.033-0.004 c-0.013-0.006-0.015-0.01-0.027-0.01c-0.017-0.004-0.037-0.004-0.049-0.014c-0.045-0.016-0.091-0.029-0.13-0.053l-2.848-1.729 l-0.021,0.551c0,0.084-0.063,0.178-0.182,0.242l-1.949,1.133c0.028,0.033,0.058,0.066,0.104,0.1l2.786,1.682 c0.049,0.029,0.109,0.053,0.183,0.072c0,0,0.009,0,0.017,0.004c0.065,0.014,0.134,0.023,0.207,0.023h0.008 c0.072,0,0.145-0.01,0.217-0.027h0.005c0.067-0.02,0.136-0.043,0.192-0.074l2.242-1.301c0.047-0.025,0.077-0.057,0.107-0.096 c-0.004-0.004-0.008-0.014-0.014-0.023c-0.005-0.01-0.009-0.033-0.009-0.033l-0.001-0.033v-0.008L114.475,393.922z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M108.839,391.291c-0.027-0.012-0.049-0.037-0.067-0.049c-0.016-0.014-0.025-0.031-0.036-0.047 l-0.009-0.01l-0.002-0.004c0-0.008-0.009-0.016-0.013-0.02c-0.005-0.012-0.009-0.023-0.017-0.029 c-0.003-0.014-0.003-0.029-0.005-0.043l-0.001-0.033v-0.004l0.02-0.688l-0.288,0.17c-0.027,0.018-0.055,0.027-0.085,0.043 c-0.024,0.008-0.047,0.01-0.073,0.021c-0.012,0.004-0.023,0.004-0.038,0.01h-0.003c-0.005,0.004-0.012,0.004-0.018,0.004 c-0.021,0.01-0.042,0.01-0.058,0.016c-0.024,0.004-0.04,0.004-0.056,0.01c-0.02,0-0.042,0-0.063,0h-0.023h-0.013h-0.021 c-0.023,0-0.045,0-0.067-0.006c-0.025,0-0.051-0.004-0.076-0.01l-0.033-0.01c-0.011-0.004-0.016-0.01-0.025-0.01 c-0.019-0.004-0.036-0.004-0.054-0.016c-0.044-0.01-0.087-0.029-0.122-0.053l-1.055-0.639l-0.021,0.551 c-0.004,0.088-0.065,0.176-0.179,0.248l-1.933,1.121c0,0,0,0.006,0.002,0.008l0.001,0.006c0.025,0.045,0.067,0.08,0.12,0.111 l2.784,1.684c0.053,0.031,0.115,0.059,0.174,0.072c0.013,0.006,0.031,0.006,0.031,0.006c0.065,0.012,0.134,0.02,0.206,0.02 h0.003c0.073,0,0.147-0.008,0.214-0.02h0.013c0.067-0.02,0.138-0.047,0.192-0.084l2.24-1.295 c0.031-0.014,0.045-0.041,0.067-0.061l-1.606-0.973H108.839z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M115.393,391.148c-0.027-0.016-0.053-0.033-0.073-0.059c-0.013-0.014-0.025-0.025-0.038-0.037 c0-0.004-0.005-0.008-0.005-0.008v-0.01c-0.007-0.006-0.011-0.008-0.013-0.02c-0.003-0.014-0.012-0.023-0.017-0.031 c-0.001-0.016-0.009-0.025-0.011-0.047v-0.029v-0.004l0.024-0.613l-0.235,0.137c-0.028,0.012-0.055,0.027-0.086,0.037 c-0.023,0.01-0.047,0.018-0.07,0.023c-0.015,0.002-0.035,0.01-0.035,0.01h-0.007c-0.006,0.004-0.016,0.004-0.021,0.004 c-0.02,0.004-0.037,0.01-0.058,0.014c-0.017,0-0.04,0-0.056,0.01c-0.019,0-0.042,0.004-0.06,0.004h-0.016h-0.013h-0.027 c-0.023,0-0.045-0.004-0.067-0.014c-0.026,0-0.051,0-0.086-0.01c0,0-0.009-0.004-0.03-0.008h-0.015 c-0.018-0.008-0.038-0.01-0.052-0.016c-0.047-0.014-0.089-0.031-0.129-0.055l-2.78-1.689l-0.009-0.004 c-0.027-0.014-0.051-0.033-0.067-0.051c-0.015-0.014-0.029-0.023-0.038-0.045c-0.001-0.004-0.003-0.008-0.005-0.012h-0.005 c-0.004-0.01-0.007-0.016-0.011-0.025c-0.006-0.006-0.015-0.018-0.015-0.029c-0.003-0.012-0.009-0.027-0.011-0.035v-0.033 V388.5l0.026-0.668l-0.278,0.158c-0.027,0.012-0.052,0.029-0.083,0.039c-0.021,0.008-0.047,0.018-0.072,0.021 c-0.013,0.006-0.023,0.006-0.036,0.008l-0.015,0.012c0,0-0.007,0-0.011,0c-0.02,0.004-0.04,0.006-0.061,0.014 c-0.015,0-0.033,0-0.057,0.004c-0.018,0-0.037,0-0.058,0h-0.018h-0.019h-0.025c-0.021,0-0.042,0-0.063,0 c-0.025-0.004-0.05-0.004-0.072-0.014l-0.035-0.004c-0.01,0-0.016-0.012-0.025-0.014c-0.022-0.006-0.037-0.006-0.053-0.01 c-0.045-0.014-0.087-0.033-0.125-0.057l-2.294-1.385l-0.018,0.58c-0.006,0.084-0.065,0.178-0.185,0.25l-1.865,1.078 c0.003,0.031,0.011,0.07,0.035,0.104l0.003,0.01c0.027,0.043,0.067,0.074,0.118,0.107l1.648,0.998 c0.049,0.029,0.114,0.057,0.177,0.074l0.031,0.004c0.064,0.012,0.132,0.027,0.2,0.027h0.009c0.073,0,0.147-0.016,0.216-0.027 l0.005-0.004c0.069-0.014,0.14-0.037,0.194-0.074l2.244-1.297c0.118-0.066,0.178-0.156,0.181-0.25l-0.029,0.805 c0,0.09-0.065,0.178-0.181,0.244l-1.922,1.119c0.009,0.002,0.006,0.016,0.009,0.027l0.004,0.004 c0.025,0.043,0.069,0.074,0.12,0.105l4.565,2.764c0.049,0.037,0.111,0.061,0.174,0.072l0.028,0.004 c0.066,0.014,0.133,0.025,0.205,0.025h0.004c0.078,0,0.146-0.012,0.216-0.025c0,0,0.001,0,0.007-0.004 c0.071-0.012,0.135-0.035,0.193-0.068l2.239-1.301c0.044-0.023,0.066-0.047,0.095-0.078l-1.205-0.729L115.393,391.148z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M106.5,385.764c-0.031-0.018-0.051-0.031-0.073-0.053c-0.013-0.016-0.029-0.033-0.036-0.045 c0,0,0-0.008-0.008-0.01v-0.006c-0.004-0.01-0.012-0.012-0.012-0.02c-0.003-0.008-0.012-0.025-0.019-0.035 c-0.003-0.014-0.005-0.035-0.005-0.035l-0.001-0.035l0.025-0.744l-0.36,0.207c-0.025,0.014-0.053,0.029-0.083,0.045 c-0.026,0.006-0.047,0.014-0.073,0.018c-0.009,0.01-0.023,0.01-0.038,0.016h-0.011c0,0-0.007,0-0.013,0.006 c-0.017,0.004-0.036,0.004-0.078,0.01c0,0-0.015,0.004-0.036,0.008c-0.021,0-0.038,0-0.058,0h-0.027h-0.006 c-0.005,0-0.046,0-0.046,0s-0.025,0-0.045-0.004c-0.028-0.004-0.049-0.004-0.075-0.01l-0.032-0.01 c-0.013,0-0.022-0.006-0.029-0.006c-0.017-0.01-0.036-0.01-0.052-0.014c-0.043-0.014-0.087-0.037-0.127-0.059l-0.093-0.053 l-0.02,0.557c-0.002,0.09-0.063,0.178-0.183,0.246l-1.941,1.125c0.027,0.043,0.063,0.08,0.118,0.111l1.575,0.949 c0.047,0.033,0.111,0.063,0.176,0.076c0.009,0,0.016,0.002,0.025,0.01c0.065,0.01,0.136,0.02,0.207,0.02h0.007 c0.071,0,0.145-0.008,0.212-0.027l0.009-0.002c0.07-0.014,0.136-0.043,0.192-0.076l2.244-1.297 c0.038-0.016,0.065-0.049,0.089-0.078l-1.289-0.779L106.5,385.764z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M102.167,383.166c-0.029-0.023-0.05-0.041-0.072-0.061c-0.018-0.012-0.029-0.023-0.034-0.037 c0,0-0.002-0.006-0.009-0.008l-0.002-0.012c-0.004-0.008-0.007-0.012-0.013-0.018c-0.003-0.012-0.011-0.025-0.016-0.031 c0-0.012-0.005-0.035-0.005-0.035l-0.002-0.037v-0.004l0.02-0.621l-0.236,0.133c-0.027,0.016-0.058,0.035-0.087,0.049 c-0.021,0.002-0.047,0.014-0.072,0.021c-0.014,0-0.035,0.008-0.035,0.008h-0.009c-0.003,0.006-0.012,0.006-0.02,0.006 c-0.014,0.008-0.039,0.008-0.054,0.01c-0.02,0-0.043,0.008-0.058,0.008c-0.02,0-0.058,0.006-0.058,0.006 c-0.009,0-0.018,0-0.018,0h-0.011h-0.032c-0.02,0-0.044-0.006-0.062-0.006c-0.025-0.008-0.049-0.008-0.072-0.01 c-0.015-0.006-0.033-0.008-0.033-0.008c-0.009-0.006-0.027-0.006-0.027-0.006c-0.018-0.008-0.033-0.008-0.054-0.016 c-0.043-0.014-0.088-0.035-0.123-0.063l-0.18-0.105l-0.022,0.561c0,0.09-0.063,0.182-0.181,0.246l-1.963,1.139 c0.013,0.01,0.02,0.023,0.043,0.039l3.168,1.92c0.053,0.033,0.117,0.055,0.18,0.074c0.009,0.002,0.019,0.006,0.029,0.006 c0.063,0.014,0.134,0.02,0.204,0.02l0.007,0.004c0.068-0.004,0.147-0.01,0.214-0.023l0.007-0.004 c0.073-0.02,0.134-0.043,0.19-0.076l2.242-1.295c0.038-0.023,0.056-0.045,0.081-0.072l-2.82-1.701H102.167z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M115.752,370.605c-0.227-0.143-0.595-0.143-0.828,0l-2.244,1.293 c-0.236,0.137-0.247,0.361-0.023,0.494l2.782,1.682c0.225,0.135,0.592,0.129,0.83,0l2.244-1.301 c0.231-0.133,0.243-0.355,0.02-0.486L115.752,370.605z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M119.654,372.967c-0.225-0.143-0.592-0.137-0.83,0l-2.238,1.295c-0.235,0.135-0.25,0.359-0.029,0.49 l2.788,1.689c0.223,0.137,0.593,0.137,0.83-0.004l2.236-1.301c0.236-0.133,0.249-0.357,0.028-0.486L119.654,372.967z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123.632,375.371c-0.221-0.133-0.592-0.133-0.825,0.004l-2.244,1.301 c-0.237,0.135-0.244,0.355-0.025,0.49l2.782,1.686c0.224,0.131,0.603,0.131,0.838,0l2.239-1.303 c0.231-0.133,0.239-0.354,0.018-0.49L123.632,375.371z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M127.658,377.813c-0.224-0.135-0.595-0.131-0.825,0l-2.244,1.295 c-0.235,0.141-0.248,0.359-0.025,0.49l2.782,1.693c0.221,0.129,0.593,0.129,0.835-0.014l2.241-1.297 c0.23-0.129,0.243-0.348,0.02-0.482L127.658,377.813z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M131.638,380.221c-0.219-0.135-0.594-0.135-0.828,0l-2.239,1.299 c-0.233,0.137-0.249,0.361-0.027,0.492l2.784,1.686c0.225,0.135,0.597,0.131,0.836,0l2.244-1.301 c0.229-0.137,0.241-0.357,0.016-0.486L131.638,380.221z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M135.624,382.633c-0.221-0.135-0.593-0.127-0.823,0l-2.244,1.297 c-0.238,0.139-0.248,0.361-0.025,0.494l2.782,1.686c0.225,0.135,0.595,0.135,0.832,0l2.247-1.297 c0.227-0.141,0.24-0.357,0.017-0.498L135.624,382.633z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M139.607,385.047c-0.221-0.143-0.594-0.135-0.827,0l-2.242,1.297 c-0.237,0.135-0.249,0.359-0.023,0.49l2.782,1.691c0.224,0.135,0.597,0.135,0.833-0.008l2.243-1.301 c0.232-0.131,0.245-0.354,0.019-0.484L139.607,385.047z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M143.595,387.457c-0.221-0.133-0.598-0.133-0.828,0l-2.244,1.305 c-0.236,0.131-0.242,0.352-0.021,0.49l2.781,1.68c0.222,0.137,0.594,0.137,0.833,0l2.241-1.301 c0.234-0.135,0.245-0.354,0.02-0.492L143.595,387.457z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147.579,389.869c-0.223-0.137-0.592-0.129-0.828,0l-2.243,1.297 c-0.237,0.145-0.248,0.363-0.023,0.496l2.78,1.682c0.225,0.139,0.595,0.139,0.832-0.004l2.244-1.295 c0.23-0.135,0.243-0.355,0.02-0.492L147.579,389.869z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M151.574,392.283c-0.223-0.129-0.597-0.129-0.83,0l-2.242,1.305 c-0.236,0.135-0.245,0.357-0.022,0.494l2.782,1.684c0.22,0.131,0.597,0.131,0.834-0.006l2.24-1.297 c0.232-0.137,0.241-0.355,0.021-0.49L151.574,392.283z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M155.558,394.695c-0.226-0.129-0.598-0.129-0.833,0l-2.24,1.301 c-0.237,0.135-0.248,0.359-0.023,0.492l2.782,1.684c0.223,0.139,0.597,0.139,0.831-0.002l2.242-1.295 c0.233-0.139,0.245-0.357,0.022-0.496L155.558,394.695z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M159.542,397.115c-0.224-0.141-0.595-0.141-0.827,0l-2.244,1.297 c-0.234,0.137-0.247,0.355-0.024,0.49l2.784,1.684c0.223,0.137,0.593,0.131,0.828-0.004l2.246-1.297 c0.23-0.135,0.243-0.354,0.018-0.486L159.542,397.115z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M163.52,399.521c-0.217-0.131-0.591-0.131-0.825,0l-2.242,1.293 c-0.236,0.146-0.247,0.365-0.026,0.496l2.782,1.689c0.225,0.129,0.6,0.129,0.836,0l2.242-1.305 c0.232-0.133,0.242-0.352,0.019-0.492L163.52,399.521z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M167.513,401.934c-0.225-0.137-0.596-0.131-0.83,0.006l-2.242,1.297 c-0.235,0.133-0.248,0.352-0.023,0.486l2.782,1.686c0.223,0.137,0.593,0.131,0.83,0l2.242-1.299 c0.234-0.137,0.247-0.355,0.022-0.492L167.513,401.934z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M171.497,404.348c-0.227-0.135-0.599-0.135-0.833,0l-2.242,1.293 c-0.237,0.143-0.247,0.361-0.021,0.494l2.778,1.689c0.223,0.133,0.598,0.133,0.834,0l2.242-1.307 c0.236-0.133,0.241-0.35,0.021-0.49L171.497,404.348z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.314,372.592c-0.227-0.137-0.591-0.137-0.825,0l-2.248,1.301 c-0.237,0.135-0.243,0.354-0.016,0.486l9.384,5.682c0.219,0.137,0.59,0.137,0.826,0l2.24-1.301 c0.238-0.137,0.245-0.354,0.024-0.49L112.314,372.592z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.924,379.01c-0.225-0.133-0.598-0.133-0.832,0l-2.244,1.305c-0.238,0.137-0.241,0.355-0.016,0.49 l2.78,1.682c0.224,0.135,0.593,0.135,0.829,0l2.244-1.301c0.234-0.133,0.243-0.352,0.022-0.482L122.924,379.01z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M126.904,381.42c-0.225-0.129-0.592-0.129-0.827,0l-2.244,1.303 c-0.237,0.143-0.245,0.355-0.021,0.492l2.782,1.684c0.225,0.135,0.597,0.141,0.829,0l2.247-1.299 c0.233-0.137,0.239-0.359,0.015-0.494L126.904,381.42z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M130.892,383.836c-0.229-0.133-0.594-0.131-0.828,0l-2.244,1.303c-0.235,0.135-0.244,0.35-0.02,0.488 l2.783,1.684c0.224,0.137,0.593,0.137,0.827,0l2.242-1.299c0.235-0.135,0.245-0.355,0.02-0.486L130.892,383.836z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M134.874,386.244c-0.225-0.129-0.592-0.129-0.833,0l-2.239,1.301 c-0.235,0.143-0.239,0.359-0.023,0.492l2.788,1.684c0.219,0.135,0.591,0.135,0.828,0l2.24-1.297 c0.237-0.135,0.245-0.354,0.022-0.494L134.874,386.244z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M138.854,388.664c-0.221-0.139-0.589-0.139-0.825,0l-2.24,1.297c-0.238,0.135-0.245,0.35-0.022,0.49 l2.782,1.682c0.225,0.139,0.594,0.139,0.83,0l2.24-1.293c0.237-0.143,0.243-0.357,0.022-0.492L138.854,388.664z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M142.839,391.072c-0.221-0.135-0.597-0.135-0.83,0l-2.238,1.295c-0.237,0.141-0.241,0.359-0.02,0.492 l2.784,1.684c0.221,0.139,0.589,0.139,0.826,0l2.244-1.301c0.234-0.131,0.243-0.35,0.02-0.486L142.839,391.072z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M146.838,393.49c-0.225-0.135-0.6-0.135-0.832,0l-2.24,1.301c-0.237,0.129-0.245,0.355-0.022,0.486 l2.782,1.688c0.223,0.133,0.593,0.133,0.83,0l2.244-1.301c0.238-0.137,0.245-0.359,0.021-0.49L146.838,393.49z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150.82,395.896c-0.227-0.131-0.594-0.131-0.829,0.006l-2.244,1.303 c-0.234,0.131-0.247,0.352-0.02,0.48l2.781,1.689c0.227,0.137,0.594,0.137,0.828,0l2.24-1.301 c0.237-0.133,0.248-0.355,0.024-0.492L150.82,395.896z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M154.806,398.314c-0.227-0.139-0.597-0.139-0.832,0l-2.244,1.295 c-0.23,0.139-0.241,0.359-0.017,0.496l2.784,1.682c0.219,0.137,0.591,0.137,0.825-0.002l2.244-1.297 c0.24-0.131,0.245-0.355,0.019-0.488L154.806,398.314z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M158.788,400.723c-0.227-0.133-0.594-0.133-0.829,0l-2.248,1.305 c-0.233,0.131-0.241,0.35-0.018,0.488l2.784,1.688c0.221,0.133,0.592,0.133,0.83,0l2.238-1.303 c0.238-0.139,0.249-0.357,0.026-0.49L158.788,400.723z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162.771,403.141c-0.223-0.135-0.593-0.135-0.826,0l-2.244,1.295 c-0.235,0.141-0.243,0.355-0.02,0.494l2.782,1.682c0.227,0.141,0.595,0.141,0.83-0.004l2.239-1.299 c0.237-0.133,0.245-0.354,0.021-0.49L162.771,403.141z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M166.753,405.545c-0.219-0.131-0.592-0.131-0.83,0l-2.24,1.305c-0.236,0.135-0.239,0.352-0.02,0.49 l2.784,1.686c0.221,0.131,0.592,0.131,0.829,0l2.24-1.301c0.238-0.135,0.245-0.355,0.02-0.492L166.753,405.545z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.854,374.594c-0.223-0.137-0.6-0.137-0.834,0.004l-2.238,1.301 c-0.238,0.131-0.247,0.35-0.024,0.484l3.007,1.822c0.224,0.139,0.594,0.139,0.828-0.006l2.244-1.295 c0.235-0.141,0.245-0.355,0.019-0.488L108.854,374.594z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.999,377.105c-0.225-0.131-0.595-0.131-0.832,0l-2.242,1.301 c-0.233,0.135-0.243,0.354-0.02,0.486l3.007,1.82c0.227,0.141,0.598,0.141,0.832,0l2.239-1.299 c0.236-0.137,0.248-0.35,0.024-0.488L112.999,377.105z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.4,376.596c-0.227-0.141-0.593-0.135-0.83,0l-5.658,3.273c-0.235,0.137-0.243,0.361-0.022,0.492 l2.108,1.271c0.224,0.137,0.592,0.137,0.826,0l5.659-3.273c0.238-0.137,0.248-0.357,0.025-0.484L105.4,376.596z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.708,378.596c-0.221-0.135-0.594-0.129-0.83,0l-2.238,1.303 c-0.233,0.133-0.249,0.355-0.025,0.492l3.009,1.818c0.225,0.129,0.602,0.129,0.833,0l2.24-1.297 c0.235-0.139,0.247-0.359,0.021-0.492L108.708,378.596z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.405,382.176c-0.222-0.143-0.595-0.143-0.832,0l-2.241,1.293 c-0.235,0.139-0.245,0.359-0.021,0.494l2.78,1.686c0.229,0.133,0.598,0.129,0.832-0.008l2.24-1.295 c0.238-0.137,0.252-0.354,0.028-0.49L121.405,382.176z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.385,379.732c-0.227-0.135-0.6-0.135-0.835,0.008l-3.433,1.982l-0.825,0.482l-1.419,0.816 c-0.233,0.141-0.247,0.361-0.018,0.492l5.5,3.334c0.225,0.143,0.596,0.133,0.834-0.004l2.242-1.297 c0.232-0.127,0.244-0.355,0.02-0.486l-2.32-1.406l3.013-1.74c0.234-0.141,0.245-0.361,0.025-0.494L117.385,379.732z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.389,384.582c-0.223-0.133-0.592-0.133-0.83,0l-2.248,1.299c-0.227,0.141-0.241,0.357-0.016,0.49 l2.782,1.686c0.223,0.135,0.594,0.135,0.828,0l2.242-1.301c0.235-0.133,0.247-0.352,0.027-0.488L125.389,384.582z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M129.374,386.994c-0.219-0.135-0.598-0.135-0.832,0.004l-2.239,1.297 c-0.235,0.135-0.244,0.355-0.023,0.49l2.78,1.684c0.225,0.135,0.6,0.135,0.834,0l2.242-1.297 c0.232-0.139,0.247-0.359,0.02-0.492L129.374,386.994z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.356,389.406c-0.223-0.135-0.598-0.135-0.834,0l-2.242,1.297 c-0.229,0.143-0.239,0.361-0.019,0.492l2.785,1.688c0.222,0.135,0.594,0.135,0.83,0l2.236-1.305 c0.237-0.133,0.25-0.35,0.029-0.49L133.356,389.406z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M137.34,391.816c-0.221-0.135-0.595-0.135-0.832,0.006l-2.239,1.299 c-0.234,0.133-0.243,0.355-0.025,0.486l2.788,1.689c0.217,0.131,0.598,0.125,0.828-0.006l2.244-1.293 c0.234-0.143,0.241-0.361,0.026-0.492L137.34,391.816z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M141.326,394.229c-0.225-0.135-0.597-0.135-0.834,0l-2.24,1.299c-0.235,0.137-0.242,0.357-0.021,0.5 l2.784,1.678c0.223,0.137,0.594,0.133,0.829,0l2.242-1.299c0.233-0.137,0.248-0.357,0.023-0.496L141.326,394.229z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.322,396.646c-0.224-0.141-0.598-0.129-0.835,0l-2.244,1.301 c-0.231,0.131-0.241,0.355-0.014,0.492l2.783,1.684c0.221,0.137,0.594,0.137,0.826,0l2.242-1.299 c0.237-0.133,0.249-0.357,0.024-0.492L145.322,396.646z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M149.303,399.057c-0.221-0.131-0.593-0.131-0.83,0.004l-2.243,1.301 c-0.234,0.131-0.245,0.35-0.021,0.486l2.78,1.691c0.225,0.129,0.6,0.129,0.83,0l2.246-1.303 c0.236-0.141,0.241-0.359,0.017-0.49L149.303,399.057z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153.288,401.471c-0.222-0.137-0.592-0.131-0.832,0.004l-2.241,1.295 c-0.234,0.143-0.245,0.357-0.02,0.492l2.78,1.684c0.224,0.143,0.597,0.137,0.831-0.006l2.24-1.295 c0.236-0.131,0.247-0.35,0.028-0.492L153.288,401.471z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M157.272,403.883c-0.222-0.135-0.597-0.135-0.834,0l-2.244,1.303 c-0.229,0.131-0.239,0.354-0.016,0.49l2.784,1.684c0.219,0.133,0.594,0.133,0.827,0l2.242-1.301 c0.236-0.137,0.245-0.354,0.025-0.492L157.272,403.883z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161.312,406.324c-0.223-0.129-0.594-0.129-0.832,0.008l-2.24,1.301 c-0.232,0.135-0.243,0.354-0.022,0.488l6.083,3.682c0.223,0.135,0.6,0.135,0.832,0l2.242-1.293 c0.237-0.143,0.244-0.367,0.022-0.498L161.312,406.324z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.651,385.781c-0.221-0.131-0.598-0.131-0.828,0l-2.243,1.297c-0.235,0.139-0.244,0.359-0.023,0.5 l2.779,1.686c0.227,0.129,0.599,0.129,0.836,0l2.242-1.307c0.231-0.137,0.245-0.355,0.018-0.49L120.651,385.781z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.637,388.201c-0.221-0.145-0.592-0.131-0.827,0l-2.242,1.295c-0.237,0.135-0.25,0.357-0.023,0.49 l2.78,1.686c0.225,0.139,0.594,0.135,0.83-0.006l2.246-1.297c0.232-0.131,0.245-0.354,0.019-0.49L124.637,388.201z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.623,390.604c-0.227-0.129-0.598-0.129-0.832,0l-2.244,1.307c-0.233,0.135-0.246,0.354-0.02,0.49 l2.78,1.684c0.223,0.133,0.6,0.133,0.834,0l2.242-1.301c0.235-0.135,0.239-0.354,0.02-0.484L128.623,390.604z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M132.606,393.023c-0.221-0.139-0.6-0.139-0.828,0l-2.241,1.295c-0.235,0.143-0.248,0.361-0.028,0.492 l2.782,1.684c0.228,0.143,0.6,0.143,0.835,0l2.246-1.293c0.232-0.139,0.239-0.363,0.018-0.5L132.606,393.023z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M136.586,395.436c-0.222-0.139-0.594-0.135-0.825,0l-2.246,1.297 c-0.233,0.135-0.247,0.354-0.023,0.49l2.786,1.689c0.223,0.129,0.596,0.125,0.833-0.01l2.24-1.297 c0.229-0.133,0.241-0.354,0.019-0.486L136.586,395.436z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M140.583,397.85c-0.223-0.131-0.597-0.131-0.832,0l-2.239,1.299 c-0.234,0.137-0.247,0.359-0.025,0.494l2.786,1.688c0.219,0.133,0.598,0.133,0.832-0.006l2.244-1.303 c0.229-0.131,0.239-0.352,0.019-0.49L140.583,397.85z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M144.563,400.26c-0.219-0.137-0.593-0.137-0.828,0.004l-2.239,1.299 c-0.238,0.133-0.25,0.357-0.026,0.488l2.787,1.686c0.223,0.135,0.593,0.127,0.83,0l2.239-1.303 c0.235-0.133,0.248-0.354,0.025-0.488L144.563,400.26z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M148.55,402.672c-0.222-0.129-0.598-0.129-0.828,0l-2.242,1.295 c-0.235,0.143-0.248,0.369-0.022,0.496l2.78,1.689c0.225,0.129,0.595,0.129,0.831-0.004l2.246-1.301 c0.226-0.129,0.244-0.35,0.018-0.492L148.55,402.672z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M152.533,405.088c-0.221-0.139-0.598-0.139-0.829,0l-2.24,1.293 c-0.238,0.137-0.248,0.361-0.025,0.494l2.78,1.686c0.228,0.139,0.598,0.139,0.835-0.008l2.242-1.293 c0.233-0.133,0.247-0.359,0.019-0.492L152.533,405.088z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M156.518,407.494c-0.225-0.135-0.59-0.131-0.827,0.006l-2.242,1.299 c-0.237,0.135-0.25,0.352-0.024,0.492l2.78,1.686c0.225,0.133,0.596,0.129,0.829-0.006l2.245-1.301 c0.233-0.137,0.244-0.35,0.019-0.492L156.518,407.494z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.502,409.91c-0.225-0.135-0.596-0.135-0.831,0l-2.243,1.295 c-0.232,0.145-0.243,0.365-0.022,0.496l3.461,2.09c0.22,0.135,0.595,0.135,0.832,0l2.241-1.295 c0.231-0.135,0.242-0.359,0.02-0.494L160.502,409.91z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.292,380.574c-0.225-0.131-0.589-0.131-0.827,0l-2.242,1.307 c-0.236,0.131-0.245,0.352-0.019,0.482l3.005,1.824c0.225,0.135,0.594,0.135,0.828,0l2.246-1.299 c0.23-0.137,0.241-0.359,0.015-0.492L105.292,380.574z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.625,383.176c-0.221-0.139-0.597-0.139-0.834,0l-2.238,1.297 c-0.234,0.135-0.247,0.359-0.017,0.49l3.671,2.23c0.217,0.131,0.592,0.131,0.826,0l2.24-1.309 c0.237-0.131,0.246-0.352,0.025-0.49L109.625,383.176z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.539,386.146c-0.223-0.135-0.596-0.129-0.832,0.006l-2.242,1.295 c-0.234,0.135-0.245,0.354-0.02,0.492l2.784,1.678c0.221,0.143,0.593,0.143,0.826,0l2.24-1.297 c0.237-0.135,0.25-0.357,0.027-0.488L114.539,386.146z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.521,388.561c-0.221-0.141-0.595-0.137-0.83,0l-2.248,1.295 c-0.229,0.135-0.239,0.357-0.017,0.498l2.786,1.682c0.218,0.131,0.593,0.131,0.827-0.004l2.24-1.295 c0.234-0.137,0.245-0.361,0.026-0.49L118.521,388.561z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.507,390.969c-0.223-0.129-0.594-0.129-0.832,0.004l-2.24,1.299 c-0.234,0.133-0.247,0.355-0.022,0.49l2.78,1.684c0.227,0.137,0.598,0.137,0.834,0l2.24-1.297 c0.237-0.141,0.247-0.355,0.021-0.494L122.507,390.969z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M126.491,393.385c-0.221-0.143-0.602-0.143-0.837,0.004l-2.238,1.293 c-0.236,0.135-0.241,0.354-0.019,0.492l2.782,1.686c0.225,0.135,0.595,0.129,0.825-0.004l2.248-1.297 c0.236-0.141,0.248-0.355,0.021-0.49L126.491,393.385z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M130.473,395.793c-0.223-0.133-0.595-0.133-0.827,0.006l-2.246,1.295 c-0.231,0.139-0.243,0.359-0.02,0.488l2.785,1.689c0.223,0.133,0.596,0.133,0.83,0l2.242-1.301 c0.232-0.133,0.243-0.355,0.021-0.49L130.473,395.793z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M134.46,398.205c-0.225-0.133-0.599-0.133-0.836,0.006l-2.242,1.297 c-0.23,0.129-0.243,0.354-0.019,0.486l2.782,1.688c0.227,0.129,0.595,0.129,0.826,0l2.246-1.297 c0.236-0.145,0.247-0.363,0.023-0.494L134.46,398.205z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M138.455,400.625c-0.225-0.137-0.6-0.137-0.837,0l-2.24,1.299c-0.234,0.131-0.245,0.355-0.018,0.496 l2.786,1.68c0.223,0.137,0.594,0.137,0.823,0l2.244-1.297c0.237-0.139,0.249-0.357,0.025-0.49L138.455,400.625z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M142.433,403.037c-0.221-0.137-0.592-0.137-0.83,0l-2.241,1.299 c-0.233,0.137-0.246,0.357-0.023,0.488l2.782,1.686c0.223,0.139,0.604,0.139,0.833,0l2.24-1.297 c0.238-0.135,0.248-0.361,0.023-0.494L142.433,403.037z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M146.422,405.445c-0.225-0.137-0.596-0.129-0.833,0.01l-2.24,1.297 c-0.236,0.129-0.247,0.35-0.021,0.486l2.78,1.686c0.225,0.135,0.598,0.129,0.832,0l2.241-1.297 c0.235-0.143,0.25-0.361,0.025-0.492L146.422,405.445z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150.405,407.857c-0.223-0.133-0.6-0.133-0.836,0l-2.24,1.299c-0.233,0.141-0.241,0.361-0.02,0.494 l2.784,1.68c0.221,0.141,0.594,0.141,0.826,0l2.243-1.295c0.235-0.135,0.244-0.355,0.029-0.492L150.405,407.857z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M154.445,410.307c-0.225-0.137-0.596-0.131-0.831,0l-2.24,1.299 c-0.236,0.137-0.247,0.357-0.024,0.494l6.085,3.684c0.221,0.133,0.598,0.133,0.826-0.004l2.248-1.303 c0.233-0.133,0.241-0.354,0.018-0.49L154.445,410.307z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M98.532,380.568c-0.221-0.133-0.596-0.133-0.831,0.006l-5.684,3.291 c-0.234,0.135-0.25,0.35-0.021,0.49l2.106,1.275c0.222,0.139,0.594,0.127,0.828-0.004l5.686-3.291 c0.235-0.131,0.249-0.352,0.022-0.492L98.532,380.568z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M101.763,382.521c-0.23-0.135-0.596-0.133-0.832,0.006l-2.246,1.295 c-0.23,0.135-0.247,0.354-0.022,0.492l3.173,1.92c0.225,0.137,0.604,0.137,0.831,0l2.242-1.295 c0.238-0.141,0.248-0.357,0.021-0.494L101.763,382.521z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.155,385.184c-0.223-0.137-0.598-0.137-0.836,0l-2.24,1.295 c-0.232,0.141-0.241,0.361-0.018,0.496l1.575,0.949c0.223,0.135,0.598,0.135,0.829,0l2.244-1.297 c0.238-0.137,0.245-0.359,0.021-0.488L106.155,385.184z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.064,386.945c-0.225-0.135-0.596-0.135-0.83,0l-2.244,1.299c-0.232,0.139-0.244,0.357-0.022,0.49 l1.648,0.998c0.225,0.137,0.6,0.137,0.832,0l2.244-1.297c0.236-0.139,0.243-0.359,0.02-0.496L109.064,386.945z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.969,388.701c-0.223-0.129-0.595-0.129-0.832,0.004L108.895,390 c-0.231,0.141-0.243,0.361-0.021,0.49l4.565,2.764c0.221,0.137,0.592,0.137,0.827,0.004l2.239-1.301 c0.238-0.135,0.249-0.35,0.028-0.496L111.969,388.701z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.734,392.195c-0.226-0.137-0.596-0.137-0.833,0.006l-2.238,1.293 c-0.236,0.131-0.249,0.354-0.022,0.492l2.782,1.684c0.221,0.133,0.593,0.133,0.828,0l2.241-1.301 c0.237-0.141,0.248-0.359,0.023-0.492L117.734,392.195z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.719,394.604c-0.223-0.137-0.602-0.137-0.836,0.004l-2.242,1.295 c-0.231,0.137-0.241,0.357-0.018,0.494l2.782,1.682c0.223,0.137,0.594,0.137,0.829-0.004l2.241-1.297 c0.234-0.135,0.249-0.355,0.026-0.49L121.719,394.604z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.701,397.016c-0.221-0.137-0.593-0.137-0.83,0.008l-2.24,1.293 c-0.236,0.135-0.245,0.363-0.023,0.492l2.782,1.684c0.223,0.133,0.598,0.133,0.834,0l2.242-1.295 c0.234-0.141,0.241-0.361,0.019-0.498L125.701,397.016z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M129.685,399.426c-0.219-0.129-0.597-0.129-0.83,0.006l-2.243,1.295 c-0.233,0.141-0.243,0.355-0.02,0.49l2.782,1.689c0.225,0.137,0.595,0.131,0.826,0l2.244-1.305 c0.235-0.135,0.25-0.352,0.024-0.494L129.685,399.426z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.681,401.848c-0.223-0.137-0.598-0.137-0.833,0l-2.242,1.299 c-0.235,0.135-0.241,0.359-0.017,0.494l2.781,1.678c0.221,0.143,0.596,0.143,0.828,0l2.244-1.295 c0.234-0.135,0.243-0.359,0.02-0.494L133.681,401.848z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M137.663,404.26c-0.225-0.141-0.595-0.131-0.831,0l-2.242,1.299c-0.232,0.137-0.245,0.35-0.021,0.49 l2.782,1.686c0.221,0.135,0.594,0.135,0.826,0l2.242-1.307c0.237-0.129,0.249-0.35,0.023-0.49L137.663,404.26z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M141.65,406.672c-0.224-0.137-0.598-0.137-0.835,0l-2.242,1.301 c-0.232,0.135-0.239,0.357-0.018,0.492l2.786,1.678c0.223,0.141,0.594,0.137,0.826,0l2.241-1.295 c0.237-0.137,0.249-0.361,0.025-0.49L141.65,406.672z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.633,409.08c-0.221-0.135-0.597-0.135-0.833,0l-2.244,1.301c-0.228,0.135-0.239,0.355-0.02,0.498 l2.782,1.678c0.223,0.135,0.596,0.135,0.833,0l2.239-1.295c0.237-0.141,0.248-0.363,0.025-0.498L145.633,409.08z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M149.62,411.494c-0.227-0.135-0.599-0.131-0.834,0.004l-2.24,1.297 c-0.235,0.135-0.247,0.354-0.021,0.484l2.778,1.691c0.227,0.133,0.598,0.133,0.833,0l2.239-1.303 c0.237-0.133,0.248-0.354,0.023-0.488L149.62,411.494z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153.601,413.908c-0.222-0.141-0.599-0.141-0.838,0.004l-2.239,1.297 c-0.231,0.131-0.24,0.352-0.016,0.488l2.78,1.682c0.223,0.135,0.594,0.135,0.831,0l2.242-1.295 c0.236-0.141,0.245-0.359,0.024-0.494L153.601,413.908z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.615,385.299c-0.221-0.131-0.592-0.131-0.827,0l-2.242,1.307 c-0.235,0.135-0.246,0.355-0.025,0.492l2.784,1.682c0.221,0.133,0.593,0.133,0.831-0.002l2.24-1.299 c0.234-0.135,0.245-0.355,0.023-0.488L99.615,385.299z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103.597,387.713c-0.221-0.131-0.594-0.131-0.829,0l-2.241,1.301 c-0.236,0.137-0.245,0.357-0.022,0.492l2.78,1.686c0.223,0.133,0.598,0.133,0.833,0l2.246-1.303 c0.23-0.133,0.238-0.359,0.017-0.49L103.597,387.713z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.623,390.152c-0.223-0.137-0.594-0.137-0.828,0l-2.243,1.293 c-0.238,0.143-0.246,0.365-0.025,0.496l2.784,1.684c0.221,0.133,0.596,0.133,0.832-0.006l2.24-1.295 c0.234-0.129,0.243-0.354,0.021-0.488L107.623,390.152z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.607,392.561c-0.221-0.131-0.598-0.131-0.832,0l-2.24,1.295 c-0.237,0.143-0.247,0.361-0.024,0.502l2.786,1.682c0.219,0.133,0.592,0.133,0.828-0.002l2.242-1.301 c0.234-0.137,0.241-0.355,0.022-0.492L111.607,392.561z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M115.589,394.975c-0.221-0.141-0.593-0.137-0.823,0.004l-2.244,1.295 c-0.237,0.137-0.249,0.355-0.025,0.492l18.73,11.342c0.225,0.133,0.596,0.133,0.834-0.01l2.24-1.301 c0.236-0.129,0.244-0.35,0.022-0.484L115.589,394.975z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M135.521,407.035c-0.224-0.135-0.597-0.135-0.829,0.006l-2.242,1.295 c-0.238,0.135-0.249,0.363-0.026,0.492l2.786,1.684c0.221,0.139,0.597,0.139,0.832,0l2.24-1.295 c0.234-0.141,0.243-0.363,0.02-0.49L135.521,407.035z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M139.504,409.449c-0.223-0.137-0.595-0.129-0.825,0l-2.246,1.297 c-0.232,0.141-0.247,0.359-0.023,0.496l2.78,1.688c0.227,0.133,0.598,0.133,0.836-0.004l2.243-1.301 c0.229-0.131,0.243-0.35,0.018-0.492L139.504,409.449z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M143.49,411.865c-0.227-0.137-0.598-0.137-0.832,0l-2.24,1.295c-0.236,0.135-0.249,0.357-0.024,0.496 l2.781,1.684c0.226,0.137,0.596,0.137,0.835-0.006l2.242-1.295c0.23-0.135,0.245-0.359,0.022-0.49L143.49,411.865z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147.476,414.273c-0.225-0.129-0.598-0.129-0.828,0.004l-2.244,1.303 c-0.237,0.137-0.247,0.354-0.023,0.488l2.78,1.684c0.225,0.137,0.6,0.137,0.838-0.006l2.241-1.299 c0.234-0.131,0.242-0.35,0.017-0.49L147.476,414.273z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M151.456,416.688c-0.223-0.143-0.596-0.133-0.83,0l-2.24,1.295c-0.239,0.135-0.249,0.359-0.022,0.494 l2.157,1.307c0.223,0.135,0.595,0.135,0.83-0.006l2.246-1.295c0.229-0.137,0.239-0.354,0.018-0.49L151.456,416.688z"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M184.559,349.018l-64.193-38.598c-0.915-0.559-1.694-0.109-1.74,0.984l-2.093,52.108 c-0.045,1.102,0.658,2.43,1.575,2.984l64.191,38.6c0.912,0.545,1.689,0.109,1.734-0.992l2.097-52.109 C186.177,350.898,185.471,349.568,184.559,349.018z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.2241,
    y1: 381.501,
    x2: 151.2241,
    y2: 349.8948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#0852F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#1C33D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9768,
    style: {
      stopColor: "#3C03AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E00A7"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M182.644,350.389l-60.655-36.474c-1.085-0.646-2.012-0.124-2.059,1.177l-1.99,46.487 c-0.056,1.305,0.787,2.887,1.872,3.539l60.656,36.475c1.081,0.658,2.003,0.121,2.058-1.176l1.983-46.482 C184.565,352.625,183.727,351.045,182.644,350.389z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDCE9",
    d: "M188.869,349.801c-0.013-0.066-0.023-0.127-0.04-0.199c-0.002-0.02-0.011-0.037-0.015-0.063 c-0.005-0.006-0.009-0.018-0.01-0.031c-0.006-0.029-0.053-0.191-0.073-0.25c-0.016-0.043-0.034-0.1-0.057-0.15l-0.002-0.006 c0,0-0.037-0.098-0.058-0.143c-0.021-0.051-0.106-0.227-0.123-0.271c0,0-0.01-0.004-0.01-0.006c0,0-0.007-0.01-0.007-0.016 c-0.027-0.045-0.145-0.245-0.174-0.293c-0.013-0.024-0.029-0.043-0.044-0.058c-0.003-0.016-0.014-0.023-0.025-0.04 c-0.01-0.02-0.023-0.039-0.036-0.059c-0.043-0.06-0.175-0.214-0.192-0.241c-0.025-0.026-0.038-0.037-0.058-0.057 c-0.02-0.023-0.04-0.053-0.06-0.075c-0.047-0.044-0.1-0.087-0.145-0.131c-0.031-0.032-0.061-0.061-0.098-0.09 c-0.1-0.084-0.199-0.16-0.31-0.22l-64.19-38.604c-0.076-0.051-0.281-0.138-0.303-0.147c-0.022-0.01-0.386-0.091-0.399-0.091 c-0.042,0-0.18,0.011-0.217,0.016c0,0-0.009,0-0.021,0.004h-0.01c-0.022,0.009-0.045,0.009-0.06,0.013 c-0.033,0.016-0.063,0.031-0.093,0.04c-0.029,0.009-0.057,0.021-0.085,0.036c-0.005,0.006-0.005,0.011-0.013,0.011 l-2.776,1.622c0.078-0.052,0.161-0.078,0.251-0.098c0,0,0.006-0.006,0.012-0.006c0.082-0.014,0.177-0.018,0.271-0.014 l0.027,0.003c0.086,0.011,0.177,0.029,0.271,0.057c0.023,0.01,0.265,0.104,0.368,0.176l64.193,38.598 c0.105,0.064,0.21,0.141,0.308,0.225c0.035,0.027,0.062,0.059,0.094,0.088c0.071,0.064,0.143,0.127,0.205,0.203 c0.022,0.018,0.038,0.043,0.055,0.059c0.083,0.1,0.161,0.201,0.235,0.307c0.009,0.008,0.015,0.02,0.024,0.025 c0.08,0.117,0.156,0.25,0.225,0.375l0.001,0.01c0.069,0.131,0.134,0.266,0.188,0.402l0.002,0.01 c0.049,0.135,0.094,0.271,0.132,0.404c0,0.016,0.007,0.025,0.009,0.039c0.026,0.127,0.052,0.248,0.067,0.379 c0.005,0.02,0.009,0.039,0.01,0.057c0.015,0.141,0.022,0.271,0.015,0.395l-2.097,52.109c-0.02,0.543-0.227,0.928-0.533,1.109 l2.777-1.615c0.308-0.182,0.509-0.57,0.538-1.113l2.092-52.102c0.005-0.111-0.014-0.379-0.014-0.379 C188.891,349.965,188.876,349.842,188.869,349.801z"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M78.538,633.305c-3.698-1.264-8.126-9.66-9.199-14.611c-2.353-10.832,10.268-66.84,8.903-79.121 c-0.323-2.926,1.642-31.115,0.364-33.107c-5.586-8.703-23.888-6.242-28.34-3.92c0,0,5.409,33.678,6.422,44.145 c0.759,7.867-2.32,27.34-0.999,45.027c1.324,17.686,2.028,27.313-0.753,31.238c0,0,4.825,4.096,9.147,8.104 c3.065,2.838,9.557,13.078,13.792,8.859C79.123,638.674,80.206,633.879,78.538,633.305z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M89.313,632.934c-6.675,0.865-11.964,0.047-11.964,0.047s-1.13,7.406-8.458,2.492 c-6.874-4.613-8.906-13.824-12.801-15.125c-0.051,0.02-5.9,3.273-2.452,12.803c2.557,7.08,3.358,13.996,3.248,13.67 c0,0-0.511,1.627,1.202,0.492l-1.484-16.605c0,0,6.764,3.578,11.343,8.484c1.656,1.771,6.133,6.99,8.513,6.533 c10.037-1.92,13.709-10.525,13.967-11.09C90.783,633.844,90.14,632.828,89.313,632.934z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M109.499,647.643c-3.697-1.264-8.946-9.393-10.021-14.344c-1.358-6.25,7.594-58.32,5.847-74.027 c-0.325-2.924,3.841-45.102,2.561-47.094c-5.584-8.703-27.595,0.771-32.046,3.096c0,0,9.976,35.555,10.988,46.021 c0.76,7.867-2.321,27.34-1.001,45.027c1.321,17.686,2.028,27.313-0.752,31.238c0,0,4.824,4.096,9.147,8.104 c3.065,2.838,8.193,11.99,12.427,7.771C107.896,652.195,111.167,648.215,109.499,647.643z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M119.453,647.541c-8.267,1.225-9.955,0.102-9.955,0.102s-3.141,7.352-10.467,2.436 c-6.877-4.615-8.909-13.826-12.802-15.125c-0.053,0.02-5.899,3.275-2.456,12.803c2.562,7.08,3.361,13.998,3.25,13.672 c0,0-0.511,1.625,1.2,0.492l-1.48-16.605c0,0,6.764,3.578,11.342,8.482c1.654,1.77,4.379,6.934,6.792,6.701 c10.061-0.969,15.431-10.693,15.689-11.256C120.921,648.451,120.278,647.418,119.453,647.541z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.73,
    y1: 443.8916,
    x2: 80.73,
    y2: 552.1133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0367,
    style: {
      stopColor: "#080B9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1344,
    style: {
      stopColor: "#0524BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2422,
    style: {
      stopColor: "#0339D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3622,
    style: {
      stopColor: "#0249E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#0154F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6755,
    style: {
      stopColor: "#005BFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M58.681,432.549c-0.183,1.76-8.262,15.191-11.006,28.354c-2.082,9.99-4.505,14.037-5.557,71.344 l77.198,14.658c0.793-72.008-16.081-95.502-17.958-107.795C100.4,432.846,59.857,421.154,58.681,432.549z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6782,
    y1: 443.8906,
    x2: 80.6782,
    y2: 552.1133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0367,
    style: {
      stopColor: "#080B9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1344,
    style: {
      stopColor: "#0524BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2422,
    style: {
      stopColor: "#0339D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3622,
    style: {
      stopColor: "#0249E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#0154F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6755,
    style: {
      stopColor: "#005BFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M107.189,530.727c-3.494-2.059-7.469-3.846-11.67-5.365c-1.743-0.633-3.554-1.209-5.381-1.74 c-0.479-0.145-0.982-0.297-1.461-0.432c-3.353-0.902-6.784-1.633-10.182-2.156c-9.509-1.504-18.846-1.457-25.913,0.479 c-2.418,0.674-4.444,1.516-6.014,2.533c-0.279,0.156-0.535,0.334-0.794,0.527c-1.281,0.916-2.223,1.941-2.842,3.051 c-0.683,1.207-0.957,2.494-0.865,3.879c0.057,0.855,0.252,1.752,0.627,2.676c0.325,0.814,0.783,1.656,1.378,2.516 c1.916,2.842,5.292,5.797,10.092,8.6c15.507,9.107,39.978,13.24,54.61,9.217c7.326-2.008,10.8-5.684,10.516-9.975 C119.003,540.229,114.955,535.283,107.189,530.727z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M76.766,361.963c-13.817-4.328-22.66,12.955-19.677,23.025c5.742,19.367,1.186,48.727,1.186,48.727 c4.821,5.682,32.89,18.857,43.742,8.346c0,0-3.904-22.541,0.818-34.609c2.532-6.475,7.767-15.576,6.311-22.807 C106.696,372.479,88.962,365.787,76.766,361.963z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M102.012,385.615c-1.413-3.447-5.266-5.252-8.787-4.035c-0.043,0.016-0.087,0.031-0.132,0.045 c-3.884,1.326-5.885,5.607-4.33,9.406c0,0,9.22,23.816,14.203,31.932c1.691,2.76,12.551-4.631,10.88-8.174 C110.554,407.811,102.012,385.615,102.012,385.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M156.345,410.176c-10.063,2.996-31.528,1.51-45.704,3.475c-4.224,0.588-9.157,3.615-8.407,7.461 l0.027,0.141c0.75,3.846,5.231,4.602,9.492,4.428c8.772-0.359,39.371-8.357,43.362-8.164 C155.115,417.516,158.061,409.662,156.345,410.176z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M172.236,410.896c-1.12-0.656-2.253-0.893-3.525-1.1c-0.943-0.15-1.879-0.396-2.844-0.354 c-1.774,0.076-12.045,0.971-12.817,1.521c-1.073,0.762-1.53,6.395-0.743,6.611c3.045,0.85,3.378,0.393,8.15,0.482 c1.075,0.021,2.246-0.16,3.328-0.229c2.397-0.148,4.733-1.162,7.085-1.207C173.896,416.572,174.114,411.99,172.236,410.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M162.169,406.9c-0.738,0.139-1.494,0.227-2.197,0.49c-0.674,0.258-3.556,2.143-5.603,3.557 c0.542,0.605,1.408,2.424,2.191,2.211c1.302-0.355,2.641-0.732,3.696-1.57c1.111-0.885,1.789-2.41,4.986-3.361 c0.613-0.18,1.239-0.455,1.594-0.988c0.353-0.533,0.309-1.363-0.231-1.707C165.153,406.068,163.692,406.607,162.169,406.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M98.461,377.342c-2.181-0.984-4.612-1.057-6.98-0.16c-0.388,0.143-0.76,0.314-1.113,0.506 c-3.908,2.121-5.695,6.873-4.083,11.047c1.957,5.074,7.96,20.236,7.96,20.236c7.813,1.363,17.211-5.518,17.211-5.518l-6.549-19.27 C104.061,381.951,100.638,378.324,98.461,377.342z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.832,
    y1: 377.3301,
    x2: 44.8997,
    y2: 338.1459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M84.691,313.475c-12.874-6.072-23.212,2-25.833,5.459c-1.197,1.577-0.235,3.983-2.523,6.058 c-2.604,2.359-3.886,7.936-2.088,12.166c3.116,7.326,0.718,13.86,1.051,17.315c0.893,9.229,4.426,12.287,3.288,24.389 c-1.301,13.82-2.258,22.016,2.026,24.492c8.394,4.85,14.344,2.996,20.206-1.467c4.272-3.254,0.605-18.449,5.414-23.955 c3.891-4.461,10.177-1.168,13.041-8.928c1.146-3.104,3.122-31.26-4.511-44.966C92.738,320.406,88.452,315.248,84.691,313.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.2573,
    y1: 376.1904,
    x2: 178.1899,
    y2: 376.1904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_9_)",
    points: "123.257,361.143 178.179,393.553 178.19,391.242 123.269,358.828  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "149.816,362.459 162.418,358.447 150.752,345.484  "
  })))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3158",
    d: "M314.021,291.334c0,0,2.375,5.197-8.819,5.197c-7.337,0-24.111-17.146-24.111-17.146 s-2.913,3.273-1.593,5.533c1.787,3.055,4.089,3.344,6.44,3.65c3.191,0.416,0.764,2.658,3.762,5.244 c5.584,4.82,8.555,6.891,15.993,7.387c8.055,0.537,14.76-4.934,10.806-8.371C315.769,292.192,315.854,292.44,314.021,291.334z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M311.543,289.489c-10.789-7.264-14.278-15.99-14.278-15.99l-13.933,0.909c0,0,0.049,1.924-1.535,3.942 c-2.125,2.705-2.707,6.393,0.698,8.006c1.616,0.783,3.583,0.42,5.259,1.135c2.855,1.215,0.333,2.457,2.534,4.531 c5.231,4.945,9.978,7.939,17.489,7.27c2.931-0.268,8.591-1.721,8.167-5.879C315.803,292.034,312.57,290.178,311.543,289.489z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.7427,
    y1: 152.8818,
    x2: 266.7427,
    y2: 250.4389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8125C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F766FC"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M266.402,131.875c-2.3-5.008-30.672,9.799-30.872,13.458c-0.105,1.876,31.521,62.271,32.485,63.551 c0.158,13.771,10.66,62.069,14.089,65.913c8.705,4.13,15.852-1.363,15.852-1.363s-6.569-59.858-7.69-69.48 C287.965,184.241,269.019,137.58,266.402,131.875z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M263.529,65.813c-2.354-3.129-6.842-3.576-9.824-1.041c-0.033,0.029-0.067,0.058-0.101,0.087 c-2.715,2.292-3.887,6.737-1.751,9.579c0,0,17.086,24.808,24.068,29.839c3.033,2.185,7.603-8.406,6.17-11.141 C277.868,85.091,263.529,65.813,263.529,65.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M276.498,94.344l-0.116,0.074c-3.16,2-5.637,4.041-3.275,7.355c7.931,11.114,26.651,28.376,31.169,37.317 c0.77,1.524,4.284-5.666,4.284-5.666c-2.752-2.641-20.966-33.973-26.469-40.288C279.417,90.071,279.655,92.341,276.498,94.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M315.904,132.979c-3.366-1.813-6.657-0.689-8.424-2.34c-4.037-3.771-6.741,0.196-6.273,2.654 c0.899,4.721,2.257,4.556,3.069,5.797c0.602,0.923,3.721,1.813,2.579,4.658c-0.888,2.21,4.519-0.288,6.511-1.055 c2.22-0.855,3.289-1.912,3.782-3.979C317.773,136.103,317.004,133.571,315.904,132.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M302.686,132.158c0.12,2.146-1.236,5.208-1.236,5.853c0.002,0.672,0.178,1.324,0.297,1.984 c0.248,1.358,0.261,2.75,0.274,4.137c0.475,0.328,1.847-0.687,1.886-2.052c0.083-2.998,0.871-4.054,1.268-5.276 c0.378-1.162,0.265-2.396,0.146-3.592C305.251,132.489,303.388,132.4,302.686,132.158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005DFF",
    d: "M248.841,59.658c-3.679,2.226-5.213,10.915-0.014,16.443l13.811,14.376c0,0,10.227-4.344,12.922-11.415 c0,0-8.021-12.801-11.493-16.795C261.209,58.978,255.648,55.544,248.841,59.658z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3158",
    d: "M152.54,174.526c0,0-3.409-3.063-7.509-1.366c-2.286,0.946-3.794,3.498-4.263,5.544 c-1.242,5.399-0.464,9.546-3.054,14.463c-2.371,4.49-1.272,9.792,1.799,14.13c2.423,3.413,7.374,6.056,12.004,5.996 c3.626-0.047,4.431-2.681,2.813-4.044C141.058,198.095,144.623,183.621,152.54,174.526z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M152.841,174.459c-2.684-2.162-7.843-1.149-9.75,2.748c-1.003,2.048-0.604,3.73-0.675,5.728 c-0.159,4.499-1.554,7.937-2.028,9.071c-2.166,5.191-2.899,11.48,2.343,15.878c4.116,3.448,13.109,5.514,11.64,1.063 c-0.855-2.587-3.239-4.956-1.548-14.699c1.456-8.396,7.616-13.108,7.616-13.108C155.023,179.458,156.4,177.326,152.841,174.459z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.645,
    y1: 152.8823,
    x2: 203.645,
    y2: 250.438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8125C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F766FC"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M215.862,142.933c0,0-6.747,24.179-9.667,32.456c-17.261-3.73-50.384,0.083-51.299,1.426 c-3.99,5.836-4.23,8.99-1.738,16.046c1.787,0.106,57.84,7.21,62.791,5.343c12.875-4.856,39.801-52.24,39.801-52.24 S229.904,139.233,215.862,142.933z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.3848,
    y1: 105.373,
    x2: 272.5737,
    y2: 105.373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0367,
    style: {
      stopColor: "#080B9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1344,
    style: {
      stopColor: "#0524BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2422,
    style: {
      stopColor: "#0339D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3622,
    style: {
      stopColor: "#0249E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#0154F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6755,
    style: {
      stopColor: "#005BFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M263.188,98.806c11.18-6.666,1.15-16.923-0.695-26.33c-1.917-9.766-2.205-13.492-15.914-12.873 c-11.549,0.524-28.281,1.871-31.396,14.054c-1.731,6.775,2.884,24.342,3.631,31.219c1.56,14.353-4.581,31.811-6.429,41.299 c21.615,12.029,55.77-0.572,60.189-6.084C268.981,127.63,256.493,102.797,263.188,98.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.582,
    y1: 130.9868,
    x2: 257.1533,
    y2: 76.9112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_13_)",
    points: "227.885,117.195 271.517,142.88 360.85,90.702 317.226,65.083  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.6768,
    y1: 121.0254,
    x2: 255.7514,
    y2: 78.9402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_14_)",
    points: "271.517,142.88 317.171,116.215 317.171,65.115 227.958,117.195  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.9448,
    y1: 127.666,
    x2: 329.6953,
    y2: 127.666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_15_)",
    points: "249.945,144.042 261.76,150.974 329.695,111.296 317.885,104.357  "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE494",
    points: "317.229,65.088 360.844,90.699 381.084,68.014 335.963,43.284  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE494",
    points: "214.672,105.542 227.885,117.195 317.229,65.088 306.617,51.839  "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1344_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M337.999,83.228l-20.117-11.614c-3.275-1.893-7.368,0.471-7.368,4.251v23.744 c0,5.474,2.918,10.531,7.658,13.267l20.119,11.615c3.275,1.891,7.368-0.473,7.368-4.253V96.495 C345.658,91.021,342.738,85.964,337.999,83.228z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1345_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1364_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M337.143,85.155l-18.12-10.457c-1.281-0.741-2.805-0.74-4.081-0.002 c-1.278,0.737-2.043,2.059-2.043,3.536v21.354c0,4.597,2.474,8.879,6.453,11.178l18.119,10.461 c0.64,0.37,1.341,0.553,2.042,0.553c0.7,0,1.401-0.185,2.043-0.553c1.277-0.738,2.041-2.061,2.041-3.536V96.333 C343.598,91.739,341.125,87.456,337.143,85.155z M342.697,117.69c0,1.149-0.596,2.179-1.594,2.755 c-0.997,0.575-2.189,0.576-3.18,0.001l-18.12-10.46c-3.703-2.139-6.001-6.124-6.001-10.4V78.232 c0-1.151,0.592-2.182,1.591-2.755c0.997-0.576,2.189-0.574,3.18,0l18.118,10.458c3.703,2.141,6.005,6.125,6.005,10.398V117.69 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1360_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M328.545,80.194c-4.12-2.382-8.026-2.749-10.995-1.035c-3,1.731-4.651,5.354-4.651,10.201 c0,9.748,6.817,21.617,15.194,26.453c2.415,1.396,4.755,2.097,6.875,2.097c1.5,0,2.895-0.353,4.124-1.064 c3-1.732,4.651-5.354,4.651-10.2C343.743,96.897,336.926,85.03,328.545,80.194z M338.641,116.066 c-2.677,1.55-6.266,1.18-10.095-1.033c-8.131-4.694-14.743-16.211-14.743-25.673c0-4.511,1.491-7.857,4.199-9.42 c1.089-0.63,2.329-0.942,3.676-0.942c1.961,0,4.145,0.664,6.416,1.976c8.132,4.694,14.747,16.211,14.747,25.672 C342.84,111.156,341.348,114.5,338.641,116.066z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1356_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M328.545,88.86c-2.148-1.24-4.191-1.424-5.748-0.522c-1.583,0.914-2.453,2.802-2.453,5.322 c0,4.968,3.479,11.02,7.749,13.485c1.249,0.721,2.461,1.086,3.565,1.086c0.793,0,1.531-0.187,2.184-0.563 c1.583-0.914,2.453-2.803,2.453-5.322C336.295,97.376,332.817,91.325,328.545,88.86z M333.395,106.886 c-1.28,0.737-2.996,0.551-4.85-0.519c-4.024-2.325-7.298-8.023-7.298-12.707c0-2.185,0.711-3.795,1.998-4.54 c0.514-0.295,1.098-0.442,1.735-0.442c0.95,0,2.008,0.321,3.113,0.96c4.025,2.324,7.299,8.024,7.299,12.707 C335.392,104.53,334.682,106.141,333.395,106.886z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "327.358,98.469 329.138,99.497 329.138,97.454 327.358,96.425  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1353_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "314.9,105.337 315.357,106.116 341.814,90.454 341.357,89.678  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1351_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.856,
    y: 97.486,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 406.3153 431.4529)",
    fill: "#FFFFFF",
    width: 52.755,
    height: 0.903
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1349_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.869,
    y: 80.583,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1347_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.793,
    y: 97.552,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 563.6559 347.0368)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.903
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1319_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.9785,
    y1: 116.7295,
    x2: 325.1226,
    y2: 116.7295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M317.463,101.905l-20.117-11.615c-3.275-1.89-7.368,0.474-7.368,4.254v23.744 c0,5.472,2.918,10.529,7.66,13.266l20.117,11.614c3.275,1.891,7.367-0.473,7.367-4.254v-23.742 C325.123,109.699,322.203,104.643,317.463,101.905z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1321_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1339_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M316.608,103.835l-18.12-10.459c-1.279-0.742-2.806-0.738-4.082-0.002 c-1.278,0.739-2.043,2.059-2.043,3.536v21.357c0,4.594,2.474,8.879,6.454,11.176l18.118,10.462 c0.64,0.369,1.341,0.554,2.042,0.554c0.701,0,1.401-0.185,2.042-0.554c1.278-0.738,2.043-2.061,2.043-3.535v-21.358 C323.064,110.417,320.59,106.133,316.608,103.835z M322.161,136.369c0,1.147-0.596,2.179-1.591,2.755 c-0.999,0.573-2.191,0.574-3.183,0l-18.12-10.46c-3.703-2.139-6-6.124-6-10.398V96.91c0-1.151,0.592-2.181,1.591-2.755 c0.997-0.577,2.191-0.573,3.181,0l18.118,10.46c3.703,2.139,6.004,6.125,6.004,10.396V136.369z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1335_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M308.011,98.871c-4.122-2.379-8.027-2.746-10.996-1.035c-2.999,1.732-4.651,5.354-4.651,10.2 c0,9.748,6.817,21.618,15.196,26.456c2.412,1.394,4.752,2.095,6.873,2.095c1.5,0,2.895-0.353,4.124-1.062 c3-1.733,4.651-5.354,4.651-10.2C323.207,115.577,316.39,103.708,308.011,98.871z M318.105,134.744 c-2.677,1.55-6.266,1.182-10.094-1.032c-8.132-4.695-14.744-16.212-14.744-25.676c0-4.509,1.491-7.855,4.199-9.419 c1.089-0.628,2.329-0.941,3.676-0.941c1.962,0,4.145,0.664,6.418,1.974c8.13,4.694,14.745,16.21,14.745,25.674 C322.305,129.834,320.813,133.18,318.105,134.744z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1331_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M308.011,107.538c-2.15-1.238-4.19-1.425-5.75-0.52c-1.582,0.913-2.452,2.802-2.452,5.319 c0,4.968,3.478,11.02,7.75,13.487c1.247,0.721,2.459,1.084,3.563,1.084c0.793,0,1.532-0.185,2.185-0.564 c1.582-0.911,2.452-2.802,2.452-5.319C315.76,116.056,312.282,110.003,308.011,107.538z M312.859,125.563 c-1.279,0.739-2.996,0.551-4.848-0.519c-4.026-2.324-7.299-8.023-7.299-12.708c0-2.184,0.711-3.795,1.998-4.54 c0.515-0.295,1.099-0.442,1.736-0.442c0.949,0,2.007,0.323,3.115,0.963c4.024,2.324,7.297,8.024,7.297,12.707 C314.857,123.207,314.146,124.82,312.859,125.563z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "306.822,117.146 308.604,118.176 308.604,116.132 306.822,115.102  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1328_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.372,
    y: 101.202,
    transform: "matrix(-0.5067 -0.8621 0.8621 -0.5067 363.3074 441.0207)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.745
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1326_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.322,
    y: 116.167,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 359.3753 441.5908)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1324_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.333,
    y: 99.261,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1322_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.258,
    y: 116.231,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 515.9996 371.6214)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1369_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.3599,
    y1: 129.9819,
    x2: 300.5054,
    y2: 129.9819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M292.846,115.158l-20.119-11.616c-3.274-1.889-7.368,0.473-7.368,4.255v23.742 c0,5.472,2.92,10.531,7.659,13.266l20.119,11.616c3.273,1.891,7.368-0.473,7.368-4.254v-23.742 C300.505,122.952,297.585,117.893,292.846,115.158z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1370_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1371_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1389_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M291.989,117.088l-18.118-10.462c-1.281-0.739-2.805-0.737-4.081,0 c-1.28,0.738-2.043,2.059-2.043,3.537v21.356c0,4.595,2.472,8.877,6.453,11.176l18.117,10.461 c0.643,0.37,1.344,0.553,2.043,0.553c0.701,0,1.403-0.185,2.042-0.553c1.278-0.739,2.042-2.061,2.042-3.535v-21.357 C298.445,123.67,295.973,119.387,291.989,117.088z M297.542,149.621c0,1.148-0.595,2.178-1.592,2.754 c-0.999,0.575-2.189,0.577-3.183,0.002l-18.117-10.462c-3.703-2.139-6.002-6.123-6.002-10.396v-21.356 c0-1.151,0.593-2.181,1.592-2.757c0.995-0.577,2.189-0.573,3.179,0l18.12,10.46c3.703,2.141,6.003,6.124,6.003,10.398V149.621 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1385_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M283.393,112.124c-4.122-2.382-8.025-2.746-10.995-1.035c-2.999,1.731-4.65,5.354-4.65,10.201 c0,9.748,6.817,21.616,15.193,26.453c2.413,1.394,4.754,2.097,6.874,2.097c1.502,0,2.895-0.353,4.125-1.062 c3-1.733,4.651-5.356,4.651-10.203C298.59,128.828,291.773,116.961,283.393,112.124z M293.488,147.995 c-2.677,1.551-6.266,1.181-10.095-1.03c-8.131-4.698-14.744-16.215-14.744-25.676c0-4.511,1.492-7.855,4.2-9.421 c1.089-0.627,2.328-0.939,3.676-0.939c1.961,0,4.145,0.661,6.416,1.974c8.131,4.694,14.747,16.211,14.747,25.672 C297.687,143.086,296.196,146.433,293.488,147.995z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1381_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M283.393,120.79c-2.148-1.236-4.191-1.424-5.748-0.521c-1.584,0.914-2.453,2.802-2.453,5.32 c0,4.97,3.477,11.021,7.748,13.488c1.25,0.72,2.462,1.084,3.565,1.084c0.794,0,1.532-0.187,2.184-0.563 c1.583-0.914,2.45-2.802,2.45-5.319C291.14,129.306,287.665,123.254,283.393,120.79z M288.243,138.816 c-1.279,0.739-2.998,0.551-4.85-0.518c-4.025-2.324-7.297-8.026-7.297-12.709c0-2.182,0.708-3.793,1.997-4.539 c0.515-0.297,1.097-0.442,1.735-0.442c0.948,0,2.007,0.322,3.113,0.96c4.026,2.323,7.298,8.025,7.298,12.709 C290.238,136.46,289.529,138.073,288.243,138.816z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "282.203,130.399 283.985,131.427 283.985,129.384 282.203,128.354  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1378_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.754,
    y: 114.454,
    transform: "matrix(-0.5071 -0.8619 0.8619 -0.5071 314.9358 439.7504)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1376_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.705,
    y: 129.419,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 311.0258 440.0617)",
    fill: "#FFFFFF",
    width: 52.752,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1374_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.716,
    y: 112.514,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.839
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1372_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.639,
    y: 129.483,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 463.4305 384.0449)",
    fill: "#FFFFFF",
    width: 35.059,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1394_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.9023,
    y1: 143.7305,
    x2: 276.0469,
    y2: 143.7305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5218,
    style: {
      stopColor: "#0430C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M268.387,128.906l-20.117-11.614c-3.275-1.891-7.368,0.471-7.368,4.254v23.741 c0,5.474,2.918,10.531,7.658,13.267l20.118,11.614c3.276,1.893,7.369-0.47,7.369-4.253v-23.742 C276.047,136.699,273.126,131.643,268.387,128.906z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1395_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1396_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1414_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M267.531,130.836l-18.119-10.46c-1.281-0.739-2.806-0.739-4.082-0.001 c-1.278,0.737-2.042,2.059-2.042,3.536v21.356c0,4.595,2.472,8.88,6.452,11.178l18.12,10.459 c0.64,0.372,1.341,0.553,2.042,0.553c0.699,0,1.401-0.185,2.041-0.553c1.279-0.738,2.042-2.061,2.042-3.536v-21.356 C273.985,137.417,271.513,133.136,267.531,130.836z M273.085,163.368c0,1.149-0.596,2.179-1.594,2.755 c-0.999,0.576-2.189,0.576-3.181,0.001l-18.119-10.46c-3.703-2.139-6.001-6.123-6.001-10.398v-21.356 c0-1.149,0.592-2.181,1.592-2.755c0.997-0.576,2.189-0.572,3.179,0l18.119,10.458c3.703,2.141,6.005,6.127,6.005,10.398 V163.368z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1410_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M258.933,125.872c-4.119-2.381-8.025-2.746-10.994-1.035c-3,1.731-4.651,5.355-4.651,10.201 c0,9.749,6.817,21.617,15.194,26.453c2.413,1.396,4.754,2.099,6.875,2.099c1.501,0,2.894-0.355,4.124-1.064 c2.999-1.733,4.65-5.356,4.65-10.202C274.13,142.577,267.313,130.709,258.933,125.872z M269.028,161.744 c-2.677,1.552-6.266,1.18-10.096-1.031c-8.13-4.696-14.743-16.213-14.743-25.675c0-4.512,1.492-7.855,4.2-9.42 c1.089-0.628,2.329-0.942,3.675-0.942c1.961,0,4.145,0.664,6.416,1.976c8.13,4.694,14.747,16.211,14.747,25.672 C273.228,156.836,271.736,160.18,269.028,161.744z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1406_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M258.933,134.539c-2.148-1.238-4.19-1.424-5.748-0.522c-1.582,0.914-2.452,2.802-2.452,5.322 c0,4.97,3.478,11.02,7.749,13.486c1.249,0.72,2.461,1.084,3.565,1.084c0.793,0,1.531-0.187,2.184-0.564 c1.583-0.914,2.453-2.802,2.453-5.32C266.683,143.054,263.205,137.004,258.933,134.539z M263.783,152.566 c-1.28,0.737-2.996,0.549-4.851-0.521c-4.023-2.323-7.297-8.023-7.297-12.707c0-2.183,0.71-3.795,1.998-4.54 c0.514-0.295,1.098-0.442,1.734-0.442c0.948,0,2.007,0.322,3.114,0.962c4.025,2.324,7.299,8.024,7.299,12.708 C265.78,150.208,265.069,151.82,263.783,152.566z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "257.746,144.148 259.525,145.175 259.525,143.132 257.746,142.104  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1403_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "245.288,151.018 245.745,151.794 272.202,136.134 271.746,135.356  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1401_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.245,
    y: 143.165,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 262.4807 439.4141)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.903
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1399_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.257,
    y: 126.261,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1397_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.181,
    y: 143.232,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 410.9189 397.4695)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.901
  })))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE494",
    points: "271.258,182.394 360.844,130.041 360.844,90.699 271.519,142.876  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.0874,
    y1: 130.228,
    x2: 302.2613,
    y2: 100.5661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_19_)",
    points: "271.519,142.88 281.883,141.619 373.83,87.915 361.957,90.057  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.7437,
    y1: 149.7944,
    x2: 271.5186,
    y2: 149.7944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_20_)",
    points: "227.744,154.947 271.258,182.394 271.519,142.876 227.885,117.195  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.5913,
    y1: 151.0049,
    x2: 208.1756,
    y2: 109.2899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_21_)",
    points: "202.267,117.422 246.927,144.734 271.499,142.873 227.885,117.26  "
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M225.947,78.2c-0.043,0.01-0.087,0.018-0.13,0.025c-3.85,0.71-6.337,4.471-5.4,8.274 c0,0,5.893,23.292,9.461,31.647c1.215,2.838,12.313,5.985,12.534,2.253c0.511-8.589-7.932-37.506-7.932-37.506 C233.627,79.443,229.442,77.545,225.947,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M242.249,116.635c-1.076-3.922-4.225-3.292-7.771-2.106l-0.128,0.043c-3.549,1.183-5.159-0.435-4.47,3.574 c1.421,8.254,14.207,42.166,14.517,45.968c0,0,7.793,1.817,7.099,0.256C247.416,155.221,245.856,129.804,242.249,116.635z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M254.84,171.231c-2.929-0.912-3.118-2.2-3.453-3.25c-0.451-1.414,2.007-4.055-1.087-7.731 c-1.611-1.917-5.231-0.208-6.019,3.188c-0.547,2.354-2.787,4.254-3.507,8.007c-0.235,1.229,1.242,3.424,3.662,4.59 c1.913,0.92,3.407,0.761,5.475-0.42C251.762,174.553,257.113,171.939,254.84,171.231z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M254.256,164.05c-0.36-0.537-3.202-2.439-4.299-4.282c-0.452,0.533-1.958,1.498-1.613,2.132 c0.571,1.051,1.164,2.135,2.128,2.922c1.015,0.826,2.26,1.33,4.004,3.786c0.796,1.118,2.507,1.31,2.72,0.81 c-0.763-1.16-1.53-2.326-2.081-3.575C254.849,165.239,254.63,164.611,254.256,164.05z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#005DFF",
    d: "M224.923,71.224c-7.699,1.996-8.337,9.158-7.592,13.452c0.904,5.214,5.762,19.519,5.762,19.519 c7.183,2.374,17.012-2.81,17.012-2.81l-2.423-19.789C236.677,74.077,234.417,68.764,224.923,71.224z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.9404,
    y1: 47.0669,
    x2: 272.1689,
    y2: 47.0669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    style: {
      stopColor: "#FF8460"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M264.234,50.03c2.773-5.188-1.133-8.368-0.801-11.636c0.438-4.336-0.305-7.553-2.3-11.473 c-1.28-2.514-5.503,0.365-7.475,2.385c-1.973,2.019-3.144,4.687-3.967,7.387c-2.51,8.218-4.033,21.136-1.296,24.316 c7.555,8.776,23.803,8.809,23.774,3.868C272.139,59.952,260.087,57.78,264.234,50.03z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M247.266,62.116c-0.056-0.073-0.112-0.142-0.173-0.207c-0.345-0.404-0.791-0.785-1.327-1.144 c-1.564-1.035-3.645-1.659-5.772-1.833c-0.758-0.068-1.526-0.076-2.279-0.027c-0.107,0.009-0.219,0.021-0.328,0.033 c-0.41,0.038-0.815,0.089-1.208,0.163c-0.944,0.176-1.838,0.446-2.628,0.828c-1.752,0.841-2.68,2.043-2.767,3.3 c-0.086,1.253,0.67,2.569,2.292,3.642c3.239,2.148,8.713,2.523,12.216,0.835c1.083-0.517,1.851-1.173,2.292-1.888 c0.138-0.216,0.243-0.434,0.319-0.654c0.089-0.25,0.138-0.504,0.154-0.752c0.029-0.404-0.027-0.805-0.172-1.205 C247.752,62.837,247.547,62.471,247.266,62.116z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M232.674,35.599l-1.892,27.631l17.225,0.423c0,0-5.138-16.842,0.21-26.267 C250.353,33.623,232.674,35.599,232.674,35.599z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB2B2",
    d: "M244.91,21.291c-11.553,4.923-11.655,15.892-8.865,26.698c2.336,9.044,11.477,12.894,15.038,12.116 c5.066-1.107,8.907-15.375,9.471-23.707c0.122-1.796-0.342-7.14-0.678-8.271C258.883,24.779,253.082,17.809,244.91,21.291z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.1006,
    y1: 44.9795,
    x2: 261.2251,
    y2: 44.9795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    style: {
      stopColor: "#FF8460"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M233.962,16.76c-3.514,1.78-7.44,6.783-9.262,10.276c-6.867,13.186-14.6,21.196-14.6,36.616 c0,7.257,7.616,11.857,21.226,11.897c7.734,0.02-1.131-16.831,1.664-26.183c2.271-7.592,8.392,1.58,14.603-13.532 c1.158-2.824,5.851-3.295,8.428-3.897c4.879-1.134,6.897-7.146,3.557-10.878C256.838,17.996,245.999,10.664,233.962,16.76z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 869.4014,
    y1: 35.5039,
    x2: 946.9857,
    y2: 422.5341,
    gradientTransform: "matrix(1 0 0.1222 1 -313.7968 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1763,
    style: {
      stopColor: "#0152F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5048,
    style: {
      stopColor: "#0435CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    style: {
      stopColor: "#080696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#09008F"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M672.414,133.274c-0.066-0.642-0.116-1.276-0.209-1.921c-0.023-0.173-0.062-0.35-0.088-0.523 c-0.037-0.234-0.08-0.47-0.12-0.705c-0.174-1.008-0.374-2.025-0.607-3.038c-0.028-0.124-0.051-0.241-0.078-0.357 c-0.265-1.103-0.573-2.203-0.906-3.303c-0.077-0.255-0.158-0.509-0.24-0.763c-0.091-0.289-0.171-0.573-0.267-0.858 c-0.18-0.535-0.389-1.07-0.583-1.604c-0.147-0.401-0.284-0.803-0.442-1.206c-0.37-0.96-0.771-1.912-1.191-2.865 c-0.088-0.2-0.165-0.403-0.256-0.6c-0.014-0.027-0.023-0.058-0.035-0.085c-0.488-1.073-1.018-2.137-1.566-3.194 c-0.158-0.31-0.329-0.611-0.493-0.917c-0.243-0.451-0.474-0.908-0.727-1.354c-0.202-0.357-0.42-0.704-0.626-1.053 c-0.181-0.308-0.359-0.612-0.544-0.915c-0.613-1.015-1.247-2.012-1.909-2.992c-0.025-0.035-0.047-0.069-0.068-0.102 c-0.005-0.009-0.013-0.014-0.016-0.023c-0.688-1.012-1.411-1.996-2.147-2.965c-0.221-0.292-0.45-0.576-0.673-0.862 c-0.307-0.386-0.598-0.781-0.91-1.162c-0.221-0.266-0.454-0.517-0.677-0.783c-0.347-0.41-0.697-0.816-1.055-1.217 c-0.502-0.567-1.013-1.114-1.53-1.66c-0.363-0.382-0.726-0.761-1.097-1.13c-0.166-0.167-0.324-0.344-0.49-0.51 c-0.364-0.355-0.743-0.68-1.112-1.024c-0.393-0.365-0.782-0.732-1.18-1.084c-0.57-0.5-1.153-0.975-1.738-1.446 c-0.384-0.312-0.761-0.635-1.148-0.93c-0.655-0.502-1.323-0.964-1.991-1.428c-0.333-0.232-0.662-0.48-0.999-0.701 c-1.012-0.663-2.036-1.289-3.075-1.856L502.485,10.037c-8.872-4.853-16.957-5.221-22.646-1.692 c-2.252,1.397-8.929,5.702-8.929,5.702c5.739-3.454,13.776-3.163,22.648,1.691L632.69,91.833l0.465-0.277l-0.465,0.277 c1.039,0.573,2.063,1.196,3.076,1.857c0.338,0.22,0.665,0.471,1,0.702c0.667,0.462,1.334,0.926,1.99,1.426 c0.389,0.297,0.768,0.624,1.152,0.932c0.58,0.473,1.162,0.946,1.731,1.446c0.4,0.35,0.788,0.723,1.181,1.086 c0.542,0.503,1.079,1.006,1.605,1.533c0.37,0.366,0.73,0.75,1.093,1.129c0.52,0.546,1.03,1.096,1.533,1.662 c0.356,0.403,0.706,0.805,1.053,1.218c0.539,0.636,1.068,1.281,1.586,1.941c0.226,0.288,0.454,0.567,0.676,0.861 c0.742,0.979,1.467,1.969,2.159,2.988c0.026,0.039,0.05,0.075,0.073,0.111c0.663,0.977,1.294,1.973,1.906,2.981 c0.186,0.306,0.364,0.612,0.546,0.917c0.468,0.795,0.916,1.599,1.353,2.409c0.165,0.306,0.333,0.609,0.493,0.917 c0.561,1.084,1.1,2.175,1.6,3.277c0.093,0.203,0.17,0.407,0.261,0.612c0.418,0.948,0.819,1.9,1.189,2.856 c0.155,0.398,0.293,0.805,0.439,1.207c0.3,0.819,0.592,1.639,0.853,2.461c0.08,0.253,0.162,0.506,0.236,0.758 c0.334,1.102,0.645,2.208,0.907,3.308c0.029,0.116,0.052,0.232,0.076,0.346c0.236,1.022,0.437,2.033,0.609,3.046 c0.042,0.238,0.084,0.474,0.12,0.708c0.13,0.82,0.216,1.636,0.3,2.453c0.039,0.38,0.094,0.768,0.126,1.151 c0.088,1.161,0.14,2.313,0.131,3.448L661.26,541.58c-0.001,0.535-0.018,1.059-0.047,1.576c-0.007,0.16-0.019,0.32-0.027,0.479 c-0.023,0.355-0.05,0.707-0.082,1.055c-0.015,0.178-0.034,0.355-0.054,0.531c-0.037,0.332-0.078,0.662-0.125,0.986 c-0.024,0.162-0.042,0.322-0.069,0.479c-0.01,0.072-0.019,0.146-0.03,0.217c-0.019,0.121-0.049,0.234-0.07,0.355 c-0.079,0.432-0.161,0.861-0.256,1.277c-0.044,0.188-0.089,0.377-0.133,0.559c-0.105,0.428-0.224,0.848-0.349,1.26 c-0.041,0.131-0.074,0.271-0.117,0.4c-0.173,0.531-0.357,1.043-0.558,1.539c-0.046,0.111-0.095,0.217-0.141,0.324 c-0.162,0.387-0.335,0.77-0.517,1.137c-0.035,0.066-0.06,0.141-0.096,0.205c-0.066,0.135-0.142,0.256-0.21,0.387 c-0.079,0.145-0.155,0.287-0.232,0.428c-0.133,0.23-0.268,0.449-0.406,0.668c-0.076,0.125-0.15,0.25-0.228,0.367 c-0.175,0.268-0.359,0.523-0.545,0.773c-0.047,0.066-0.091,0.133-0.141,0.195c-0.227,0.299-0.457,0.588-0.697,0.863 c-0.01,0.008-0.019,0.02-0.028,0.027c-0.37,0.42-0.754,0.807-1.152,1.184c-0.098,0.088-0.194,0.174-0.29,0.26 c-0.414,0.365-0.834,0.715-1.28,1.031l-0.001,0.002c-0.321,0.229-0.648,0.443-0.986,0.645l8.929-5.699 c0.333-0.201,0.657-0.416,0.975-0.641c0.006-0.004,0.014-0.01,0.014-0.01c0.443-0.314,0.868-0.666,1.278-1.029 c0.094-0.086,0.192-0.172,0.286-0.26c0.4-0.373,0.791-0.766,1.156-1.182c0.007-0.012,0.011-0.018,0.02-0.023 c0.241-0.281,0.478-0.566,0.707-0.869c0.049-0.061,0.09-0.127,0.14-0.195c0.187-0.248,0.369-0.506,0.544-0.773 c0.079-0.115,0.151-0.24,0.227-0.361c0.14-0.221,0.276-0.443,0.407-0.674c0.078-0.139,0.155-0.283,0.232-0.426 c0.065-0.123,0.13-0.252,0.193-0.381c0.04-0.07,0.076-0.143,0.112-0.215c0.183-0.367,0.354-0.748,0.517-1.135 c0.047-0.104,0.097-0.209,0.141-0.32c0.2-0.5,0.386-1.016,0.557-1.541c0.044-0.133,0.078-0.271,0.118-0.4 c0.125-0.412,0.244-0.834,0.349-1.26c0.046-0.184,0.09-0.373,0.132-0.559c0.096-0.42,0.18-0.846,0.257-1.277 c0.021-0.119,0.044-0.232,0.063-0.354c0.011-0.074,0.026-0.143,0.039-0.221c0.025-0.154,0.045-0.318,0.068-0.479 c0.046-0.326,0.088-0.652,0.126-0.99c0.017-0.172,0.036-0.348,0.053-0.525c0.033-0.348,0.059-0.699,0.08-1.057 c0.01-0.158,0.023-0.316,0.031-0.48c0.022-0.518,0.042-1.037,0.043-1.572h0.002l2.485-397.998 c0.008-1.137-0.042-2.286-0.133-3.449C672.51,134.05,672.454,133.66,672.414,133.274z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.3301,
    y1: 76.9116,
    x2: 544.5286,
    y2: 264.3658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M658.689,142.793l-2.478,398c-0.047,7.365-2.519,12.822-6.967,15.373 c-4.569,2.604-10.87,1.982-17.714-1.766l-139.143-76.104c-7.532-4.119-14.873-11.662-20.131-20.689 c-4.99-8.578-7.705-17.658-7.654-25.559l2.478-397.997c0.063-7.366,2.533-12.842,6.986-15.374 c4.565-2.623,10.848-1.999,17.71,1.748l139.125,76.102c7.531,4.122,14.873,11.666,20.135,20.708 c3.519,6.046,5.892,12.325,6.993,18.265C658.481,138.014,658.707,140.457,658.689,142.793z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 720.3115,
    y1: 287.418,
    x2: 960.333,
    y2: 287.418,
    gradientTransform: "matrix(1 0 0.1222 1 -313.7968 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0118,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1232,
    style: {
      stopColor: "#1867DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2282,
    style: {
      stopColor: "#2D30C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#390DAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4162,
    style: {
      stopColor: "#4705AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5267,
    style: {
      stopColor: "#5F12B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#8527C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8272,
    style: {
      stopColor: "#BB45E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M632.695,91.825L493.555,15.738c-17.278-9.452-31.39-1.606-31.512,17.535l-2.482,397.979 c-0.139,19.139,13.769,42.305,31.047,51.76l139.141,76.082c16.819,9.205,30.636,2.018,31.468-15.996 c0.027-0.5,2.524-399.515,2.524-399.515C663.865,124.464,649.957,101.277,632.695,91.825z M658.704,142.798l-2.496,397.999 c-0.014,1.643-0.146,3.174-0.417,4.619c-0.829,5.029-3.083,8.773-6.55,10.756c-4.569,2.604-10.854,1.979-17.714-1.768 l-139.124-76.104c-7.55-4.121-14.874-11.664-20.131-20.689c-4.991-8.578-7.724-17.656-7.674-25.574l2.496-397.982 c0.044-7.384,2.516-12.842,6.968-15.374c4.567-2.623,10.85-1.998,17.711,1.747l139.126,76.104 c7.548,4.121,14.873,11.664,20.134,20.708C656.02,125.802,658.753,134.88,658.704,142.798z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 488.9854,
    y1: 46.4028,
    x2: 622.6174,
    y2: 426.8825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M506.469,53.13l-20.12-11.614c-3.274-1.891-7.367,0.473-7.367,4.253v23.742 c0,5.474,2.92,10.531,7.66,13.268l20.118,11.614c3.273,1.892,7.368-0.471,7.368-4.252V66.397 C514.128,60.923,511.208,55.867,506.469,53.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.1953,
    y1: 35.4404,
    x2: 653.8298,
    y2: 415.9268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M549.862,76.858l-20.116-11.614c-3.276-1.893-7.371,0.471-7.371,4.252V93.24 c0,5.473,2.921,10.53,7.66,13.267l20.119,11.615c3.275,1.89,7.368-0.474,7.368-4.254V90.126 C557.522,84.652,554.603,79.595,549.862,76.858z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.4072,
    y1: 24.48,
    x2: 685.0374,
    y2: 404.954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M593.257,100.587l-20.116-11.616c-3.275-1.89-7.368,0.473-7.368,4.254v23.743 c0,5.472,2.918,10.531,7.658,13.266l20.118,11.616c3.275,1.889,7.368-0.475,7.368-4.256v-23.742 C600.917,108.382,597.996,103.323,593.257,100.587z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 582.6191,
    y1: 13.519,
    x2: 716.2491,
    y2: 393.9925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M636.654,124.314l-20.12-11.616c-3.274-1.889-7.367,0.473-7.367,4.256v23.742 c0,5.472,2.92,10.53,7.659,13.265l20.117,11.617c3.275,1.89,7.367-0.474,7.367-4.254v-23.743 C644.311,132.109,641.393,127.05,636.654,124.314z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.7676,
    y1: 52.8018,
    x2: 604.3997,
    y2: 433.2814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M506.469,111.401l-20.12-11.615c-3.274-1.892-7.367,0.473-7.367,4.254v23.742 c0,5.474,2.92,10.53,7.66,13.268l20.118,11.614c3.273,1.893,7.368-0.472,7.368-4.254v-23.741 C514.128,119.195,511.208,114.138,506.469,111.401z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 501.9775,
    y1: 41.8403,
    x2: 635.6096,
    y2: 422.32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M549.862,135.13l-20.116-11.614c-3.276-1.893-7.371,0.471-7.371,4.251v23.744 c0,5.474,2.921,10.53,7.66,13.267l20.119,11.614c3.275,1.891,7.368-0.473,7.368-4.255v-23.741 C557.522,142.923,554.603,137.867,549.862,135.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.1895,
    y1: 30.8799,
    x2: 666.819,
    y2: 411.3522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M593.257,158.857l-20.116-11.616c-3.275-1.889-7.368,0.475-7.368,4.255v23.742 c0,5.472,2.918,10.53,7.658,13.265l20.118,11.616c3.275,1.89,7.368-0.473,7.368-4.253v-23.744 C600.917,166.651,597.996,161.594,593.257,158.857z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 564.4004,
    y1: 19.918,
    x2: 698.0305,
    y2: 400.392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M636.654,182.585l-20.12-11.615c-3.274-1.89-7.367,0.474-7.367,4.254v23.742 c0,5.474,2.92,10.531,7.659,13.268l20.117,11.614c3.275,1.893,7.367-0.471,7.367-4.251v-23.744 C644.311,190.378,641.393,185.322,636.654,182.585z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.5469,
    y1: 59.1978,
    x2: 586.1816,
    y2: 439.6848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M506.469,169.672l-20.12-11.614c-3.274-1.893-7.367,0.471-7.367,4.251v23.744 c0,5.474,2.92,10.531,7.66,13.268l20.118,11.614c3.273,1.891,7.368-0.473,7.368-4.253V182.94 C514.128,177.466,511.208,172.409,506.469,169.672z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.7598,
    y1: 48.2407,
    x2: 617.3897,
    y2: 428.7142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M549.862,193.401l-20.116-11.616c-3.276-1.891-7.371,0.473-7.371,4.254v23.743 c0,5.472,2.921,10.529,7.66,13.267l20.119,11.616c3.275,1.888,7.368-0.475,7.368-4.256v-23.742 C557.522,201.195,554.603,196.136,549.862,193.401z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 514.9717,
    y1: 37.2783,
    x2: 648.6018,
    y2: 417.7523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M593.257,217.128l-20.116-11.616c-3.275-1.89-7.368,0.473-7.368,4.256v23.742 c0,5.472,2.918,10.529,7.658,13.266l20.118,11.615c3.275,1.892,7.368-0.471,7.368-4.253v-23.744 C600.917,224.92,597.996,219.864,593.257,217.128z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 546.1807,
    y1: 26.313,
    x2: 679.8127,
    y2: 406.7926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M636.654,240.855l-20.12-11.614c-3.274-1.893-7.367,0.473-7.367,4.254v23.741 c0,5.474,2.92,10.531,7.659,13.268l20.117,11.615c3.275,1.892,7.367-0.472,7.367-4.254v-23.742 C644.311,248.65,641.393,243.592,636.654,240.855z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.3291,
    y1: 65.5972,
    x2: 567.9614,
    y2: 446.0774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M506.469,227.943l-20.12-11.616c-3.274-1.891-7.367,0.473-7.367,4.254v23.744 c0,5.472,2.92,10.53,7.66,13.265l20.118,11.617c3.273,1.888,7.368-0.475,7.368-4.256v-23.742 C514.128,235.737,511.208,230.679,506.469,227.943z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.541,
    y1: 54.6396,
    x2: 599.171,
    y2: 435.1131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M549.862,251.671l-20.116-11.617c-3.276-1.888-7.371,0.474-7.371,4.256v23.742 c0,5.471,2.921,10.531,7.66,13.265l20.119,11.616c3.275,1.89,7.368-0.473,7.368-4.254v-23.743 C557.522,259.464,554.603,254.405,549.862,251.671z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.75,
    y1: 43.6689,
    x2: 630.3847,
    y2: 424.1559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M593.257,275.398l-20.116-11.614c-3.275-1.891-7.368,0.47-7.368,4.253v23.741 c0,5.475,2.918,10.531,7.658,13.269l20.118,11.615c3.275,1.892,7.368-0.472,7.368-4.253v-23.743 C600.917,283.192,597.996,278.135,593.257,275.398z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.9609,
    y1: 32.7109,
    x2: 661.5934,
    y2: 413.1917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M636.654,299.127l-20.12-11.615c-3.274-1.892-7.367,0.471-7.367,4.252v23.745 c0,5.473,2.92,10.529,7.659,13.267l20.117,11.614c3.275,1.891,7.367-0.473,7.367-4.254v-23.742 C644.311,306.92,641.393,301.864,636.654,299.127z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.1123,
    y1: 72.0005,
    x2: 549.7418,
    y2: 452.4728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M506.469,286.213l-20.12-11.616c-3.274-1.889-7.367,0.475-7.367,4.256v23.741 c0,5.473,2.92,10.531,7.66,13.268l20.118,11.614c3.273,1.891,7.368-0.473,7.368-4.254v-23.744 C514.128,294.007,511.208,288.95,506.469,286.213z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.3213,
    y1: 61.0332,
    x2: 580.9536,
    y2: 441.5134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M549.862,309.94l-20.116-11.614c-3.276-1.89-7.371,0.473-7.371,4.254v23.742 c0,5.474,2.921,10.53,7.66,13.267l20.119,11.617c3.275,1.891,7.368-0.473,7.368-4.253v-23.745 C557.522,317.735,554.603,312.677,549.862,309.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.5342,
    y1: 50.0757,
    x2: 612.1643,
    y2: 430.5497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M593.257,333.669l-20.116-11.615c-3.275-1.891-7.368,0.472-7.368,4.253v23.744 c0,5.473,2.918,10.529,7.658,13.266l20.118,11.615c3.275,1.891,7.368-0.473,7.368-4.254v-23.741 C600.917,341.463,597.996,336.407,593.257,333.669z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.7451,
    y1: 39.1138,
    x2: 643.3752,
    y2: 419.5878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M636.654,357.398l-20.12-11.616c-3.274-1.891-7.367,0.473-7.367,4.252v23.744 c0,5.473,2.92,10.531,7.659,13.266l20.117,11.617c3.275,1.887,7.367-0.475,7.367-4.256v-23.742 C644.311,365.191,641.393,360.133,636.654,357.398z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.8916,
    y1: 78.394,
    x2: 531.5239,
    y2: 458.8743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M506.469,344.485l-20.12-11.616c-3.274-1.891-7.367,0.473-7.367,4.255v23.742 c0,5.473,2.92,10.529,7.66,13.266l20.118,11.615c3.273,1.893,7.368-0.473,7.368-4.254V357.75 C514.128,352.275,511.208,347.219,506.469,344.485z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.1006,
    y1: 67.4272,
    x2: 562.7349,
    y2: 447.9131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M549.862,368.211l-20.116-11.613c-3.276-1.893-7.371,0.471-7.371,4.254v23.74 c0,5.475,2.921,10.531,7.66,13.27l20.119,11.613c3.275,1.893,7.368-0.473,7.368-4.254v-23.742 C557.522,376.006,554.603,370.949,549.862,368.211z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.3154,
    y1: 56.4756,
    x2: 593.9454,
    y2: 436.9491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M593.257,391.939l-20.116-11.613c-3.275-1.893-7.368,0.473-7.368,4.252v23.744 c0,5.475,2.918,10.531,7.658,13.264l20.118,11.617c3.275,1.891,7.368-0.473,7.368-4.254v-23.742 C600.917,399.734,597.996,394.678,593.257,391.939z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.5293,
    y1: 45.521,
    x2: 625.1567,
    y2: 425.9872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F2F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE0ED"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M636.654,415.668l-20.12-11.615c-3.274-1.891-7.367,0.475-7.367,4.254v23.742 c0,5.473,2.92,10.531,7.659,13.268l20.117,11.613c3.275,1.891,7.367-0.473,7.367-4.252v-23.744 C644.311,423.461,641.393,418.404,636.654,415.668z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.2236,
    y1: 302.4121,
    x2: 644.3115,
    y2: 302.4121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M636.657,132.232c-5.26-9.043-12.604-16.586-20.134-20.707L477.397,35.422 c-6.86-3.745-13.142-4.37-17.709-1.748c-4.452,2.532-6.923,8.008-6.986,15.374l-2.478,397.999 c-0.051,7.9,2.663,16.979,7.652,25.559c5.26,9.023,12.603,16.568,20.134,20.689l139.142,76.102 c6.842,3.748,13.145,4.371,17.712,1.766c4.452-2.549,6.924-8.006,6.967-15.373l2.479-397.999c0.02-2.334-0.21-4.78-0.66-7.294 C642.551,144.557,640.179,138.278,636.657,132.232z M638.121,555.766c-0.036,5.988-1.848,10.313-5.102,12.178 c-1.27,0.723-2.785,1.09-4.499,1.09c-2.815,0-6.13-1-9.584-2.891l-139.145-76.105c-6.96-3.809-13.779-10.844-18.705-19.303 c-4.658-8.002-7.196-16.408-7.15-23.664l2.478-397.999c0.051-6,1.867-10.328,5.11-12.172c1.286-0.739,2.803-1.111,4.517-1.111 c2.802,0,6.114,1,9.58,2.892l139.12,76.102c6.964,3.81,13.783,10.851,18.708,19.317c3.251,5.584,5.517,11.487,6.553,17.074 c0.41,2.299,0.614,4.523,0.598,6.587L638.121,555.766z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#010080",
    d: "M615.608,143.948c-5.262-9.043-12.604-16.586-20.135-20.707L456.349,47.137 c-6.859-3.744-13.144-4.37-17.709-1.747c-4.453,2.532-6.924,8.007-6.984,15.374l-2.48,397.998 c-0.052,7.902,2.664,16.982,7.654,25.559c5.258,9.025,12.602,16.568,20.131,20.691l139.144,76.102 c6.844,3.746,13.144,4.371,17.712,1.766c4.451-2.551,6.923-8.008,6.967-15.375l2.481-397.999c0.018-2.334-0.211-4.779-0.66-7.293 C621.503,156.272,619.13,149.994,615.608,143.948z M617.073,567.484c-0.037,5.986-1.85,10.311-5.102,12.174 c-1.27,0.723-2.784,1.092-4.5,1.092c-2.814,0-6.13-1-9.584-2.893l-139.146-76.105c-6.959-3.807-13.777-10.844-18.704-19.301 c-4.658-8.004-7.196-16.408-7.15-23.666l2.479-397.998c0.051-6.001,1.866-10.328,5.109-12.172c1.287-0.74,2.804-1.111,4.517-1.111 c2.802,0,6.115,1,9.582,2.893l139.119,76.1c6.964,3.811,13.782,10.852,18.707,19.318c3.251,5.584,5.517,11.488,6.552,17.074 c0.412,2.3,0.615,4.523,0.599,6.588L617.073,567.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.1182,
    y1: 148.7334,
    x2: 683.0137,
    y2: 505.629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M593.948,156.996c-5.258-9.042-12.604-16.585-20.134-20.706L434.689,60.186 c-6.859-3.746-13.144-4.37-17.709-1.749c-4.453,2.534-6.924,8.008-6.986,15.375l-2.479,397.997 c-0.052,7.902,2.664,16.98,7.654,25.561c5.258,9.023,12.603,16.566,20.131,20.688l139.144,76.104 c6.843,3.748,13.144,4.371,17.712,1.768c4.45-2.551,6.923-8.008,6.968-15.375l2.48-398c0.016-2.336-0.211-4.779-0.66-7.293 C599.845,169.321,597.471,163.042,593.948,156.996z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.1172,
    y1: 76.7349,
    x2: 755.0162,
    y2: 433.6339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M416.98,58.437c-4.453,2.534-6.924,8.008-6.986,15.375l-0.563,90.436 c25.399-25.398,50.799-50.798,76.198-76.198l-50.94-27.864C427.83,56.439,421.546,55.815,416.98,58.437z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.7559,
    y1: 91.0942,
    x2: 740.6517,
    y2: 447.9901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M409.193,202.333l-0.262,42.222c42.761-42.762,85.523-85.524,128.285-128.286l-27.122-14.837 L409.193,202.333z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.1729,
    y1: 402.9482,
    x2: 557.6371,
    y2: 601.2062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0118,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1232,
    style: {
      stopColor: "#1867DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2282,
    style: {
      stopColor: "#2D30C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#390DAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4162,
    style: {
      stopColor: "#4705AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5267,
    style: {
      stopColor: "#5F12B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6655,
    style: {
      stopColor: "#8527C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8272,
    style: {
      stopColor: "#BB45E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M412.275,428.404c-1.5-0.822-2.991-1.754-4.472-2.77l-0.288,46.174 c-0.052,7.902,2.664,16.98,7.654,25.561c5.258,9.023,12.603,16.566,20.131,20.688l139.144,76.104 c6.843,3.748,13.144,4.371,17.712,1.768c4.45-2.551,6.923-8.008,6.968-15.375l0.312-49.873c-0.586-0.287-1.166-0.545-1.757-0.869 L412.275,428.404z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.209,
    y1: 153.6318,
    x2: 678.1154,
    y2: 510.5383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M407.886,412.67l-0.264,41.992l193.492-193.49l0.261-41.992 c-7.299,7.299-14.596,14.596-21.895,21.895C522.282,298.273,465.083,355.471,407.886,412.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.5371,
    y1: 183.3135,
    x2: 648.4333,
    y2: 540.2097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "url(#SVGID_57_)",
    d: "M415.17,497.369c5.258,9.023,12.603,16.566,20.131,20.688l139.144,76.104 c6.843,3.748,13.144,4.371,17.712,1.768c4.45-2.551,6.923-8.008,6.968-15.375l1.753-281.297L411.115,489.018 C412.231,491.816,413.569,494.617,415.17,497.369z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.4517,
    y1: 210.4097,
    x2: 621.3427,
    y2: 567.3007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "url(#SVGID_58_)",
    d: "M574.444,594.16c6.843,3.748,13.144,4.371,17.712,1.768 c4.45-2.551,6.923-8.008,6.968-15.375l0.923-147.955c-37.74,37.865-75.437,75.773-113.117,113.697L574.444,594.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2129_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.0869,
    y1: 106.5938,
    x2: 456.2305,
    y2: 106.5938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M448.573,91.77l-20.118-11.616c-3.274-1.889-7.368,0.475-7.368,4.256v23.742 c0,5.473,2.921,10.53,7.66,13.265l20.118,11.616c3.273,1.89,7.365-0.473,7.365-4.254v-23.743 C456.23,99.564,453.314,94.507,448.573,91.77z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1912_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1981_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4188_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.717,93.7l-18.118-10.46c-1.281-0.741-2.808-0.739-4.081-0.001 c-1.279,0.737-2.043,2.059-2.043,3.536v21.356c0,4.595,2.472,8.877,6.451,11.176l18.118,10.461 c0.641,0.37,1.342,0.553,2.043,0.553c0.702,0,1.401-0.185,2.043-0.553c1.278-0.74,2.041-2.061,2.041-3.536v-21.357 C454.171,100.281,451.699,95.999,447.717,93.7z M453.27,126.233c0,1.148-0.596,2.18-1.591,2.754 c-0.999,0.575-2.189,0.576-3.183,0.002l-18.117-10.462c-3.704-2.138-6.002-6.123-6.002-10.396V86.775 c0-1.151,0.592-2.18,1.59-2.755c0.996-0.576,2.19-0.575,3.181,0l18.117,10.458c3.704,2.141,6.005,6.124,6.005,10.398V126.233z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2836_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,88.736c-4.122-2.382-8.025-2.746-10.993-1.035c-3.001,1.731-4.651,5.354-4.651,10.201 c0,9.747,6.816,21.615,15.193,26.453c2.412,1.396,4.753,2.098,6.873,2.098c1.501,0,2.896-0.354,4.125-1.062 c2.999-1.733,4.651-5.356,4.651-10.203C454.317,105.44,447.501,93.574,439.119,88.736z M449.215,124.607 c-2.677,1.551-6.268,1.182-10.096-1.03c-8.13-4.696-14.742-16.215-14.742-25.675c0-4.512,1.491-7.855,4.2-9.422 c1.086-0.626,2.327-0.94,3.675-0.94c1.961,0,4.145,0.663,6.416,1.975c8.131,4.695,14.747,16.211,14.747,25.672 C453.415,119.699,451.922,123.044,449.215,124.607z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2099_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,97.402c-2.147-1.236-4.189-1.425-5.749-0.52c-1.581,0.913-2.452,2.801-2.452,5.318 c0,4.97,3.479,11.022,7.75,13.489c1.249,0.719,2.46,1.083,3.563,1.083c0.796,0,1.531-0.187,2.187-0.563 c1.582-0.914,2.45-2.802,2.45-5.319C446.868,105.918,443.392,99.866,439.119,97.402z M443.969,115.428 c-1.279,0.739-2.997,0.551-4.85-0.518c-4.025-2.324-7.298-8.026-7.298-12.709c0-2.182,0.71-3.793,1.997-4.539 c0.516-0.297,1.099-0.442,1.735-0.442c0.949,0,2.008,0.323,3.114,0.96c4.025,2.324,7.298,8.026,7.298,12.71 C445.966,113.072,445.257,114.686,443.969,115.428z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.932,107.011 439.712,108.041 439.712,105.996 437.932,104.967  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2050_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.481,
    y: 91.067,
    transform: "matrix(-0.5086 -0.861 0.861 -0.5086 570.5202 538.4967)",
    fill: "#FFFFFF",
    width: 0.901,
    height: 30.743
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1985_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.432,
    y: 106.03,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 564.4311 540.197)",
    fill: "#FFFFFF",
    width: 52.752,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1984_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.441,
    y: 89.126,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.839
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1983_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.366,
    y: 106.096,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 765.7188 418.2623)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_212_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M491.969,115.497l-20.12-11.614c-3.274-1.89-7.367,0.474-7.367,4.254v23.742 c0,5.473,2.92,10.531,7.66,13.268l20.118,11.614c3.273,1.893,7.368-0.471,7.368-4.252v-23.743 C499.628,123.291,496.708,118.234,491.969,115.497z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_213_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_244_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_288_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M491.11,117.427l-18.118-10.459c-1.28-0.74-2.805-0.74-4.081,0c-1.279,0.738-2.043,2.057-2.043,3.534 v21.357c0,4.594,2.473,8.879,6.453,11.177l18.117,10.46c0.642,0.372,1.344,0.555,2.043,0.555c0.701,0,1.402-0.185,2.043-0.555 c1.277-0.737,2.043-2.061,2.043-3.536v-21.354C497.567,124.009,495.095,119.728,491.11,117.427z M496.665,149.96 c0,1.148-0.596,2.181-1.593,2.757c-0.998,0.574-2.189,0.574-3.183,0.001l-18.117-10.461c-3.703-2.139-6.001-6.123-6.001-10.398 v-21.357c0-1.149,0.593-2.181,1.592-2.755c0.993-0.577,2.189-0.573,3.179,0l18.118,10.46c3.702,2.14,6.005,6.124,6.005,10.398 V149.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_258_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,112.463c-4.121-2.38-8.026-2.746-10.995-1.033c-2.999,1.729-4.651,5.354-4.651,10.201 c0,9.747,6.816,21.616,15.195,26.453c2.412,1.394,4.752,2.097,6.872,2.097c1.501,0,2.895-0.355,4.126-1.063 c2.997-1.733,4.65-5.356,4.65-10.201C497.712,129.167,490.895,117.301,482.515,112.463z M492.61,148.336 c-2.677,1.551-6.266,1.182-10.096-1.032c-8.131-4.695-14.743-16.212-14.743-25.673c0-4.512,1.491-7.857,4.2-9.421 c1.087-0.629,2.326-0.941,3.675-0.941c1.96,0,4.146,0.661,6.417,1.974c8.13,4.694,14.746,16.21,14.746,25.673 C496.81,143.428,495.317,146.772,492.61,148.336z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_254_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,121.13c-2.148-1.238-4.191-1.425-5.751-0.52c-1.58,0.912-2.449,2.802-2.449,5.319 c0,4.97,3.476,11.02,7.749,13.487c1.248,0.72,2.46,1.085,3.565,1.085c0.793,0,1.53-0.188,2.184-0.565 c1.582-0.913,2.45-2.802,2.45-5.319C490.263,129.647,486.786,123.595,482.515,121.13z M487.362,139.157 c-1.276,0.738-2.995,0.551-4.848-0.52c-4.025-2.323-7.3-8.024-7.3-12.708c0-2.182,0.712-3.795,1.999-4.538 c0.514-0.298,1.097-0.443,1.735-0.443c0.948,0,2.007,0.321,3.114,0.961c4.025,2.324,7.297,8.023,7.297,12.707 C489.36,136.799,488.651,138.413,487.362,139.157z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.325,130.74 483.107,131.768 483.107,129.724 481.325,128.695  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_251_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.877,
    y: 114.795,
    transform: "matrix(-0.5075 -0.8616 0.8616 -0.5075 614.9725 611.8187)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_249_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.826,
    y: 129.759,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 608.7806 613.3778)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_247_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.839,
    y: 112.853,
    fill: "#FFFFFF",
    width: 0.899,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_245_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.762,
    y: 129.822,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 834.8309 484.236)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_314_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.876,
    y1: 154.0498,
    x2: 543.0225,
    y2: 154.0498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5218,
    style: {
      stopColor: "#0430C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M535.362,139.227l-20.116-11.614c-3.275-1.893-7.37,0.471-7.37,4.251v23.744 c0,5.474,2.92,10.53,7.66,13.267l20.119,11.614c3.275,1.891,7.367-0.473,7.367-4.253v-23.742 C543.022,147.02,540.103,141.963,535.362,139.227z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_317_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.507,141.155l-18.119-10.458c-1.282-0.741-2.806-0.739-4.082-0.001 c-1.278,0.737-2.042,2.059-2.042,3.536v21.354c0,4.597,2.473,8.879,6.452,11.178l18.12,10.461 c0.639,0.37,1.34,0.552,2.039,0.552c0.702,0,1.403-0.185,2.043-0.552c1.279-0.738,2.043-2.061,2.043-3.536v-21.356 C540.961,147.738,538.489,143.455,534.507,141.155z M540.06,173.689c0,1.149-0.595,2.178-1.592,2.755 c-1,0.574-2.189,0.576-3.183,0.001l-18.118-10.46c-3.703-2.139-6-6.125-6-10.4v-21.354c0-1.151,0.593-2.182,1.59-2.755 c0.996-0.576,2.189-0.575,3.179,0l18.12,10.458c3.703,2.141,6.004,6.124,6.004,10.398V173.689z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_369_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,136.192c-4.12-2.381-8.025-2.747-10.995-1.035c-3,1.731-4.65,5.354-4.65,10.201 c0,9.748,6.817,21.618,15.194,26.453c2.412,1.395,4.754,2.097,6.875,2.097c1.5,0,2.892-0.353,4.122-1.063 c2.999-1.733,4.65-5.354,4.65-10.201C541.105,152.896,534.289,141.029,525.909,136.192z M536.005,172.065 c-2.678,1.549-6.267,1.18-10.096-1.033c-8.132-4.694-14.742-16.211-14.742-25.674c0-4.512,1.489-7.857,4.198-9.419 c1.09-0.631,2.329-0.942,3.676-0.942c1.962,0,4.145,0.663,6.417,1.975c8.131,4.695,14.745,16.211,14.745,25.672 C540.203,167.155,538.711,170.499,536.005,172.065z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_365_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,144.859c-2.148-1.24-4.19-1.424-5.747-0.522c-1.585,0.914-2.454,2.802-2.454,5.322 c0,4.968,3.479,11.02,7.75,13.484c1.248,0.722,2.461,1.086,3.564,1.086c0.793,0,1.532-0.188,2.185-0.564 c1.583-0.914,2.452-2.802,2.452-5.321C533.659,153.374,530.181,147.325,525.909,144.859z M530.759,162.884 c-1.279,0.738-2.996,0.551-4.85-0.518c-4.026-2.326-7.298-8.024-7.298-12.707c0-2.185,0.711-3.795,1.998-4.541 c0.514-0.296,1.099-0.442,1.733-0.442c0.948,0,2.008,0.321,3.115,0.961c4.024,2.324,7.299,8.023,7.299,12.708 C532.757,160.528,532.046,162.14,530.759,162.884z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.722,154.467 526.501,155.495 526.501,153.452 524.722,152.422  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_362_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "512.264,161.336 512.721,162.115 539.178,146.452 538.722,145.677  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_360_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.22,
    y: 153.485,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 653.1409 686.5547)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.903
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_336_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.233,
    y: 136.582,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.158,
    y: 153.551,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 903.9604 550.198)",
    fill: "#FFFFFF",
    width: 35.056,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_562_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.2725,
    y1: 177.7783,
    x2: 586.417,
    y2: 177.7783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_61_)",
    d: "M578.757,162.956l-20.116-11.616c-3.274-1.891-7.368,0.473-7.368,4.253v23.744 c0,5.472,2.92,10.529,7.658,13.266l20.118,11.616c3.275,1.888,7.368-0.475,7.368-4.256v-23.742 C586.417,170.749,583.496,165.69,578.757,162.956z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_563_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_564_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_583_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.902,164.883l-18.12-10.459c-1.281-0.739-2.806-0.737-4.082-0.002 c-1.276,0.74-2.043,2.06-2.043,3.537v21.357c0,4.594,2.475,8.879,6.453,11.176l18.119,10.462 c0.64,0.369,1.342,0.555,2.043,0.555c0.699,0,1.401-0.186,2.042-0.555c1.278-0.738,2.043-2.06,2.043-3.537v-21.357 C584.357,171.465,581.884,167.182,577.902,164.883z M583.455,197.416c0,1.149-0.596,2.181-1.591,2.757 c-0.999,0.573-2.192,0.576-3.184,0.001l-18.12-10.461c-3.702-2.139-6-6.125-6-10.398v-21.357c0-1.151,0.593-2.181,1.592-2.755 c0.996-0.576,2.19-0.573,3.18,0l18.118,10.46c3.703,2.139,6.005,6.125,6.005,10.396V197.416z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_579_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,159.919c-4.119-2.379-8.025-2.746-10.994-1.035c-2.999,1.733-4.651,5.354-4.651,10.2 c0,9.748,6.817,21.618,15.195,26.456c2.413,1.394,4.754,2.096,6.874,2.096c1.5,0,2.895-0.352,4.124-1.063 c2.999-1.732,4.651-5.354,4.651-10.2C584.502,176.625,577.685,164.757,569.303,159.919z M579.4,195.792 c-2.679,1.551-6.267,1.179-10.098-1.032c-8.13-4.696-14.742-16.212-14.742-25.676c0-4.509,1.493-7.855,4.199-9.419 c1.09-0.629,2.33-0.941,3.676-0.941c1.961,0,4.146,0.664,6.417,1.974c8.133,4.694,14.745,16.21,14.745,25.674 C583.598,190.882,582.106,194.228,579.4,195.792z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_575_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,168.586c-2.147-1.238-4.19-1.424-5.747-0.52c-1.583,0.913-2.452,2.802-2.452,5.32 c0,4.969,3.478,11.02,7.749,13.487c1.248,0.721,2.46,1.083,3.564,1.083c0.793,0,1.531-0.185,2.184-0.564 c1.583-0.911,2.452-2.802,2.452-5.319C577.053,177.104,573.575,171.052,569.303,168.586z M574.153,186.612 c-1.279,0.739-2.996,0.551-4.851-0.519c-4.023-2.324-7.297-8.023-7.297-12.707c0-2.183,0.711-3.795,1.997-4.541 c0.516-0.296,1.099-0.442,1.737-0.442c0.948,0,2.006,0.323,3.112,0.96c4.024,2.326,7.298,8.026,7.298,12.709 C576.15,184.255,575.44,185.869,574.153,186.612z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "568.116,178.195 569.896,179.224 569.896,177.179 568.116,176.151  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_572_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "555.659,185.064 556.115,185.841 582.573,170.18 582.116,169.404  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_570_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.616,
    y: 177.215,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 697.5164 759.7303)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_567_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.627,
    y: 160.309,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_565_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.551,
    y: 177.279,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 973.0566 616.1846)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_695_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.0869,
    y1: 164.8652,
    x2: 456.2305,
    y2: 164.8652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M448.573,150.042l-20.118-11.616c-3.274-1.89-7.368,0.473-7.368,4.253v23.744 c0,5.472,2.921,10.529,7.66,13.266l20.118,11.616c3.273,1.891,7.365-0.473,7.365-4.254v-23.744 C456.23,157.833,453.314,152.776,448.573,150.042z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_696_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_697_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_716_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.717,151.97l-18.118-10.46c-1.281-0.74-2.808-0.737-4.081,0c-1.279,0.738-2.043,2.059-2.043,3.534 v21.358c0,4.593,2.472,8.878,6.451,11.176l18.118,10.461c0.641,0.37,1.342,0.553,2.043,0.553c0.702,0,1.401-0.185,2.043-0.553 c1.278-0.739,2.041-2.061,2.041-3.538v-21.354C454.171,158.551,451.699,154.27,447.717,151.97z M453.27,184.502 c0,1.149-0.596,2.181-1.591,2.757c-0.999,0.575-2.189,0.575-3.183,0.002l-18.117-10.461c-3.704-2.139-6.002-6.123-6.002-10.397 v-21.358c0-1.149,0.592-2.18,1.59-2.755c0.996-0.576,2.19-0.573,3.181,0l18.117,10.46c3.704,2.141,6.005,6.125,6.005,10.398 V184.502z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,147.005c-4.122-2.38-8.025-2.746-10.993-1.033c-3.001,1.731-4.651,5.354-4.651,10.2 c0,9.749,6.816,21.616,15.193,26.454c2.412,1.394,4.753,2.097,6.873,2.097c1.501,0,2.896-0.354,4.125-1.064 c2.999-1.732,4.651-5.354,4.651-10.2C454.317,163.71,447.501,151.845,439.119,147.005z M449.215,182.878 c-2.677,1.551-6.268,1.182-10.096-1.031c-8.13-4.696-14.742-16.212-14.742-25.674c0-4.511,1.491-7.856,4.2-9.42 c1.086-0.628,2.327-0.941,3.675-0.941c1.961,0,4.145,0.664,6.416,1.974c8.131,4.694,14.747,16.21,14.747,25.674 C453.415,177.97,451.922,181.314,449.215,182.878z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_708_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,155.672c-2.147-1.237-4.189-1.424-5.749-0.52c-1.581,0.913-2.452,2.802-2.452,5.319 c0,4.969,3.479,11.02,7.75,13.487c1.249,0.721,2.46,1.085,3.563,1.085c0.796,0,1.531-0.187,2.187-0.565 c1.582-0.912,2.45-2.802,2.45-5.32C446.868,164.19,443.392,158.138,439.119,155.672z M443.969,173.7 c-1.279,0.738-2.997,0.551-4.85-0.519c-4.025-2.324-7.298-8.026-7.298-12.709c0-2.182,0.71-3.795,1.997-4.538 c0.516-0.298,1.099-0.443,1.735-0.443c0.949,0,2.008,0.321,3.114,0.961c4.025,2.324,7.298,8.024,7.298,12.707 C445.966,171.343,445.257,172.955,443.969,173.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.932,165.283 439.712,166.31 439.712,164.268 437.932,163.238  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_705_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.481,
    y: 149.338,
    transform: "matrix(-0.5083 -0.8612 0.8612 -0.5083 520.2203 626.4269)",
    fill: "#FFFFFF",
    width: 0.901,
    height: 30.743
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.431,
    y: 164.3,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 513.8541 627.4213)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_700_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.441,
    y: 147.396,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_698_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.366,
    y: 164.366,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 736.5797 526.9995)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_652_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.4814,
    y1: 188.5923,
    x2: 499.6279,
    y2: 188.5923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M491.969,173.769l-20.12-11.614c-3.274-1.893-7.367,0.471-7.367,4.253v23.742 c0,5.474,2.92,10.53,7.66,13.268l20.118,11.614c3.273,1.891,7.368-0.473,7.368-4.253v-23.742 C499.628,181.563,496.708,176.505,491.969,173.769z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_657_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_658_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_690_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M491.11,175.696l-18.118-10.457c-1.28-0.74-2.805-0.74-4.081-0.002 c-1.279,0.738-2.043,2.059-2.043,3.537v21.356c0,4.595,2.473,8.88,6.453,11.178l18.117,10.459 c0.642,0.37,1.344,0.553,2.043,0.553c0.701,0,1.402-0.185,2.043-0.553c1.277-0.738,2.043-2.061,2.043-3.536v-21.357 C497.567,182.28,495.095,177.997,491.11,175.696z M496.665,208.231c0,1.149-0.596,2.178-1.593,2.755 c-0.998,0.575-2.189,0.576-3.183,0.001l-18.117-10.46c-3.703-2.139-6.001-6.124-6.001-10.398v-21.356 c0-1.151,0.593-2.182,1.592-2.755c0.993-0.577,2.189-0.572,3.179,0l18.118,10.458c3.702,2.141,6.005,6.126,6.005,10.398 V208.231z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_686_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,170.734c-4.121-2.381-8.026-2.748-10.995-1.035c-2.999,1.73-4.651,5.354-4.651,10.2 c0,9.75,6.816,21.618,15.195,26.453c2.412,1.396,4.752,2.097,6.872,2.097c1.501,0,2.895-0.353,4.126-1.064 c2.997-1.732,4.65-5.354,4.65-10.2C497.712,187.438,490.895,175.572,482.515,170.734z M492.61,206.607 c-2.677,1.552-6.266,1.18-10.096-1.033c-8.131-4.695-14.743-16.211-14.743-25.674c0-4.511,1.491-7.855,4.2-9.419 c1.087-0.629,2.326-0.942,3.675-0.942c1.96,0,4.146,0.664,6.417,1.976c8.13,4.694,14.746,16.211,14.746,25.672 C496.81,201.697,495.317,205.042,492.61,206.607z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_679_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,179.402c-2.148-1.238-4.191-1.425-5.751-0.522c-1.58,0.914-2.449,2.802-2.449,5.321 c0,4.971,3.476,11.021,7.749,13.487c1.248,0.72,2.46,1.084,3.565,1.084c0.793,0,1.53-0.187,2.184-0.564 c1.582-0.914,2.45-2.802,2.45-5.319C490.263,187.917,486.786,181.867,482.515,179.402z M487.362,197.427 c-1.276,0.739-2.995,0.551-4.848-0.519c-4.025-2.324-7.3-8.023-7.3-12.708c0-2.182,0.712-3.795,1.999-4.54 c0.514-0.296,1.097-0.442,1.735-0.442c0.948,0,2.007,0.322,3.114,0.962c4.025,2.324,7.297,8.023,7.297,12.708 C489.36,195.071,488.651,196.682,487.362,197.427z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.325,189.01 483.107,190.038 483.107,187.994 481.325,186.967  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_673_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "468.87,195.878 469.327,196.657 495.784,180.995 495.327,180.219  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_671_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.826,
    y: 188.029,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 558.209 700.5992)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_665_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.839,
    y: 171.124,
    fill: "#FFFFFF",
    width: 0.899,
    height: 34.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_659_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.761,
    y: 188.094,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 805.6905 592.9767)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_626_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.876,
    y1: 212.3213,
    x2: 543.0225,
    y2: 212.3213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5218,
    style: {
      stopColor: "#0430C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M535.362,197.498l-20.116-11.616c-3.275-1.89-7.37,0.473-7.37,4.254v23.743 c0,5.472,2.92,10.531,7.66,13.266l20.119,11.616c3.275,1.891,7.367-0.473,7.367-4.255v-23.742 C543.022,205.291,540.103,200.232,535.362,197.498z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_627_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_628_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_646_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.507,199.426l-18.119-10.46c-1.282-0.74-2.806-0.737-4.082-0.002 c-1.278,0.739-2.042,2.06-2.042,3.536v21.356c0,4.596,2.473,8.879,6.452,11.178l18.12,10.46 c0.639,0.371,1.34,0.555,2.039,0.555c0.702,0,1.403-0.185,2.043-0.555c1.279-0.738,2.043-2.059,2.043-3.535v-21.358 C540.961,206.009,538.489,201.726,534.507,199.426z M540.06,231.96c0,1.149-0.595,2.179-1.592,2.755 c-1,0.575-2.189,0.576-3.183,0l-18.118-10.459c-3.703-2.139-6-6.123-6-10.398V192.5c0-1.151,0.593-2.181,1.59-2.755 c0.996-0.576,2.189-0.573,3.179,0l18.12,10.46c3.703,2.138,6.004,6.125,6.004,10.396V231.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_642_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,194.463c-4.12-2.382-8.025-2.748-10.995-1.037c-3,1.732-4.65,5.356-4.65,10.201 c0,9.749,6.817,21.617,15.194,26.455c2.412,1.394,4.754,2.097,6.875,2.097c1.5,0,2.892-0.353,4.122-1.064 c2.999-1.732,4.65-5.354,4.65-10.201C541.105,211.167,534.289,199.299,525.909,194.463z M536.005,230.334 c-2.678,1.552-6.267,1.18-10.096-1.031c-8.132-4.696-14.742-16.213-14.742-25.675c0-4.509,1.489-7.855,4.198-9.419 c1.09-0.629,2.329-0.941,3.676-0.941c1.962,0,4.145,0.664,6.417,1.976c8.131,4.692,14.745,16.211,14.745,25.672 C540.203,225.426,538.711,228.77,536.005,230.334z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_638_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,203.128c-2.148-1.237-4.19-1.424-5.747-0.52c-1.585,0.913-2.454,2.802-2.454,5.319 c0,4.97,3.479,11.022,7.75,13.487c1.248,0.721,2.461,1.084,3.564,1.084c0.793,0,1.532-0.185,2.185-0.562 c1.583-0.914,2.452-2.802,2.452-5.322C533.659,211.646,530.181,205.594,525.909,203.128z M530.759,221.156 c-1.279,0.737-2.996,0.548-4.85-0.521c-4.026-2.323-7.298-8.023-7.298-12.707c0-2.182,0.711-3.793,1.998-4.54 c0.514-0.295,1.099-0.442,1.733-0.442c0.948,0,2.008,0.323,3.115,0.962c4.024,2.324,7.299,8.024,7.299,12.707 C532.757,218.798,532.046,220.411,530.759,221.156z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.722,212.737 526.501,213.766 526.501,211.722 524.722,210.694  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_635_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "512.264,219.608 512.721,220.384 539.178,204.724 538.722,203.946  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_633_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.22,
    y: 211.757,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 602.571 773.7766)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_631_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.233,
    y: 194.851,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_629_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.158,
    y: 211.822,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 874.8109 658.9465)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_588_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M578.757,221.225l-20.116-11.616c-3.274-1.889-7.368,0.473-7.368,4.255v23.741 c0,5.472,2.92,10.531,7.658,13.266l20.118,11.616c3.275,1.89,7.368-0.473,7.368-4.254V234.49 C586.417,229.019,583.496,223.961,578.757,221.225z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_589_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_590_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_621_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.902,223.155l-18.12-10.46c-1.281-0.741-2.806-0.74-4.082-0.002s-2.043,2.059-2.043,3.536v21.356 c0,4.596,2.475,8.877,6.453,11.177l18.119,10.461c0.64,0.37,1.342,0.553,2.043,0.553c0.699,0,1.401-0.185,2.042-0.553 c1.278-0.739,2.043-2.061,2.043-3.536v-21.356C584.357,229.736,581.884,225.453,577.902,223.155z M583.455,255.687 c0,1.149-0.596,2.18-1.591,2.755c-0.999,0.575-2.192,0.577-3.184,0.002l-18.12-10.461c-3.702-2.139-6-6.123-6-10.397v-21.356 c0-1.151,0.593-2.18,1.592-2.754c0.996-0.577,2.19-0.575,3.18,0l18.118,10.458c3.703,2.14,6.005,6.124,6.005,10.397V255.687z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_614_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,218.191c-4.119-2.382-8.025-2.746-10.994-1.036c-2.999,1.731-4.651,5.354-4.651,10.201 c0,9.748,6.817,21.615,15.195,26.453c2.413,1.394,4.754,2.097,6.874,2.097c1.5,0,2.895-0.353,4.124-1.062 c2.999-1.733,4.651-5.356,4.651-10.202C584.502,234.895,577.685,223.028,569.303,218.191z M579.4,254.061 c-2.679,1.552-6.267,1.182-10.098-1.029c-8.13-4.696-14.742-16.214-14.742-25.675c0-4.511,1.493-7.855,4.199-9.421 c1.09-0.627,2.33-0.94,3.676-0.94c1.961,0,4.146,0.663,6.417,1.976c8.133,4.694,14.745,16.211,14.745,25.672 C583.598,249.153,582.106,252.499,579.4,254.061z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_607_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,226.856c-2.147-1.236-4.19-1.424-5.747-0.519c-1.583,0.913-2.452,2.8-2.452,5.318 c0,4.97,3.478,11.021,7.749,13.488c1.248,0.72,2.46,1.084,3.564,1.084c0.793,0,1.531-0.187,2.184-0.563 c1.583-0.914,2.452-2.802,2.452-5.32C577.053,235.373,573.575,229.321,569.303,226.856z M574.153,244.883 c-1.279,0.739-2.996,0.551-4.851-0.519c-4.023-2.324-7.297-8.025-7.297-12.709c0-2.182,0.711-3.794,1.997-4.539 c0.516-0.297,1.099-0.442,1.737-0.442c0.948,0,2.006,0.322,3.112,0.96c4.024,2.324,7.298,8.026,7.298,12.709 C576.15,242.527,575.44,244.14,574.153,244.883z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "568.116,236.466 569.896,237.496 569.896,235.451 568.116,234.421  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_601_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.666,
    y: 220.521,
    transform: "matrix(-0.507 -0.862 0.862 -0.507 654.3115 846.0414)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.745
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_596_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.616,
    y: 235.485,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 646.9534 846.9514)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_594_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.627,
    y: 218.581,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.839
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_591_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.551,
    y: 235.551,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 943.9271 724.9164)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_796_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.0869,
    y1: 223.1353,
    x2: 456.2305,
    y2: 223.1353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_65_)",
    d: "M448.573,208.311l-20.118-11.615c-3.274-1.891-7.368,0.471-7.368,4.254v23.741 c0,5.475,2.921,10.531,7.66,13.268l20.118,11.614c3.273,1.892,7.365-0.471,7.365-4.254v-23.742 C456.23,216.104,453.314,211.048,448.573,208.311z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_797_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_798_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_816_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.717,210.241l-18.118-10.46c-1.281-0.739-2.808-0.739-4.081-0.001 c-1.279,0.737-2.043,2.059-2.043,3.536v21.356c0,4.595,2.472,8.879,6.451,11.178l18.118,10.46 c0.641,0.372,1.342,0.553,2.043,0.553c0.702,0,1.401-0.185,2.043-0.553c1.278-0.738,2.041-2.061,2.041-3.537v-21.356 C454.171,216.822,451.699,212.541,447.717,210.241z M453.27,242.773c0,1.149-0.596,2.181-1.591,2.755 c-0.999,0.577-2.189,0.577-3.183,0.002l-18.117-10.46c-3.704-2.138-6.002-6.122-6.002-10.398v-21.356 c0-1.148,0.592-2.18,1.59-2.754c0.996-0.577,2.19-0.573,3.181,0l18.117,10.458c3.704,2.142,6.005,6.126,6.005,10.398V242.773z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_812_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,205.277c-4.122-2.382-8.025-2.746-10.993-1.036c-3.001,1.734-4.651,5.356-4.651,10.202 c0,9.749,6.816,21.617,15.193,26.453c2.412,1.396,4.753,2.099,6.873,2.099c1.501,0,2.896-0.355,4.125-1.064 c2.999-1.732,4.651-5.356,4.651-10.202C454.317,221.982,447.501,210.114,439.119,205.277z M449.215,241.149 c-2.677,1.552-6.268,1.182-10.096-1.032c-8.13-4.696-14.742-16.212-14.742-25.675c0-4.512,1.491-7.856,4.2-9.42 c1.086-0.628,2.327-0.941,3.675-0.941c1.961,0,4.145,0.663,6.416,1.975c8.131,4.694,14.747,16.211,14.747,25.672 C453.415,236.241,451.922,239.585,449.215,241.149z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_808_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,213.944c-2.147-1.238-4.189-1.424-5.749-0.521c-1.581,0.912-2.452,2.801-2.452,5.321 c0,4.969,3.479,11.019,7.75,13.485c1.249,0.72,2.46,1.086,3.563,1.086c0.796,0,1.531-0.188,2.187-0.565 c1.582-0.914,2.45-2.802,2.45-5.32C446.868,222.459,443.392,216.409,439.119,213.944z M443.969,231.971 c-1.279,0.738-2.997,0.549-4.85-0.52c-4.025-2.324-7.298-8.024-7.298-12.707c0-2.183,0.71-3.796,1.997-4.541 c0.516-0.295,1.099-0.442,1.735-0.442c0.949,0,2.008,0.322,3.114,0.962c4.025,2.324,7.298,8.024,7.298,12.708 C445.966,229.613,445.257,231.226,443.969,231.971z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.932,223.554 439.712,224.582 439.712,222.537 437.932,221.51  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_805_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.481,
    y: 207.609,
    transform: "matrix(-0.5083 -0.8612 0.8612 -0.5083 470.0402 714.3193)",
    fill: "#FFFFFF",
    width: 0.901,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_803_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.431,
    y: 222.571,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 463.287 714.6439)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_801_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.441,
    y: 205.667,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_799_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.366,
    y: 222.637,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 707.454 635.728)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_771_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M491.969,232.04l-20.12-11.614c-3.274-1.893-7.367,0.472-7.367,4.252v23.744 c0,5.473,2.92,10.53,7.66,13.267l20.118,11.614c3.273,1.891,7.368-0.473,7.368-4.254v-23.744 C499.628,239.833,496.708,234.777,491.969,232.04z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_772_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_773_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_791_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M491.11,233.968l-18.118-10.458c-1.28-0.741-2.805-0.74-4.081-0.004 c-1.279,0.74-2.043,2.06-2.043,3.539v21.354c0,4.597,2.473,8.879,6.453,11.177l18.117,10.46 c0.642,0.372,1.344,0.554,2.043,0.554c0.701,0,1.402-0.185,2.043-0.554c1.277-0.738,2.043-2.059,2.043-3.534v-21.356 C497.567,240.551,495.095,236.268,491.11,233.968z M496.665,266.502c0,1.149-0.596,2.178-1.593,2.755 c-0.998,0.574-2.189,0.576-3.183,0.001l-18.117-10.461c-3.703-2.138-6.001-6.122-6.001-10.398v-21.354 c0-1.151,0.593-2.183,1.592-2.757c0.993-0.575,2.189-0.573,3.179,0l18.118,10.46c3.702,2.14,6.005,6.124,6.005,10.398V266.502z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_787_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,229.006c-4.121-2.382-8.026-2.748-10.995-1.035c-2.999,1.731-4.651,5.354-4.651,10.2 c0,9.747,6.816,21.615,15.195,26.453c2.412,1.396,4.752,2.097,6.872,2.097c1.501,0,2.895-0.354,4.126-1.064 c2.997-1.733,4.65-5.354,4.65-10.201C497.712,245.709,490.895,233.842,482.515,229.006z M492.61,264.878 c-2.677,1.549-6.266,1.18-10.096-1.034c-8.131-4.693-14.743-16.212-14.743-25.673c0-4.511,1.491-7.857,4.2-9.419 c1.087-0.63,2.326-0.942,3.675-0.942c1.96,0,4.146,0.664,6.417,1.976c8.13,4.694,14.746,16.21,14.746,25.671 C496.81,259.968,495.317,263.313,492.61,264.878z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_783_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,237.671c-2.148-1.238-4.191-1.425-5.751-0.521c-1.58,0.914-2.449,2.802-2.449,5.32 c0,4.97,3.476,11.022,7.749,13.487c1.248,0.721,2.46,1.085,3.565,1.085c0.793,0,1.53-0.187,2.184-0.563 c1.582-0.914,2.45-2.802,2.45-5.322C490.263,246.188,486.786,240.136,482.515,237.671z M487.362,255.698 c-1.276,0.738-2.995,0.551-4.848-0.52c-4.025-2.324-7.3-8.024-7.3-12.708c0-2.182,0.712-3.794,1.999-4.539 c0.514-0.297,1.097-0.442,1.735-0.442c0.948,0,2.007,0.321,3.114,0.961c4.025,2.323,7.297,8.023,7.297,12.707 C489.36,253.34,488.651,254.954,487.362,255.698z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.325,247.281 483.107,248.309 483.107,246.264 481.325,245.236  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_780_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.877,
    y: 231.336,
    transform: "matrix(-0.5078 -0.8615 0.8615 -0.5078 514.7064 787.5003)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_778_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.826,
    y: 246.3,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 507.6415 787.8214)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_776_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.839,
    y: 229.394,
    fill: "#FFFFFF",
    width: 0.899,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_774_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.761,
    y: 246.363,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 776.5557 701.708)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_746_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.876,
    y1: 270.5913,
    x2: 543.0225,
    y2: 270.5913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_66_)",
    d: "M535.362,255.767l-20.116-11.614c-3.275-1.891-7.37,0.473-7.37,4.253v23.744 c0,5.472,2.92,10.529,7.66,13.265l20.119,11.614c3.275,1.892,7.367-0.473,7.367-4.252v-23.743 C543.022,263.561,540.103,258.504,535.362,255.767z"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_747_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_748_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_766_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.507,257.698l-18.119-10.46c-1.282-0.741-2.806-0.739-4.082-0.001 c-1.278,0.739-2.042,2.059-2.042,3.536v21.356c0,4.594,2.473,8.877,6.452,11.177l18.12,10.46 c0.639,0.37,1.34,0.554,2.039,0.554c0.702,0,1.403-0.184,2.043-0.554c1.279-0.738,2.043-2.061,2.043-3.537v-21.355 C540.961,264.278,538.489,259.996,534.507,257.698z M540.06,290.229c0,1.15-0.595,2.181-1.592,2.758 c-1,0.572-2.189,0.574-3.183,0l-18.118-10.462c-3.703-2.137-6-6.123-6-10.396v-21.356c0-1.151,0.593-2.18,1.59-2.755 c0.996-0.577,2.189-0.575,3.179,0l18.12,10.459c3.703,2.139,6.004,6.123,6.004,10.397V290.229z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_762_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,252.733c-4.12-2.38-8.025-2.746-10.995-1.035c-3,1.731-4.65,5.354-4.65,10.201 c0,9.747,6.817,21.617,15.194,26.454c2.412,1.395,4.754,2.096,6.875,2.096c1.5,0,2.892-0.354,4.122-1.063 c2.999-1.732,4.65-5.354,4.65-10.2C541.105,269.438,534.289,257.57,525.909,252.733z M536.005,288.606 c-2.678,1.549-6.267,1.18-10.096-1.032c-8.132-4.696-14.742-16.213-14.742-25.675c0-4.51,1.489-7.855,4.198-9.419 c1.09-0.629,2.329-0.941,3.676-0.941c1.962,0,4.145,0.662,6.417,1.974c8.131,4.695,14.745,16.211,14.745,25.674 C540.203,283.695,538.711,287.041,536.005,288.606z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_758_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,261.399c-2.148-1.237-4.19-1.423-5.747-0.52c-1.585,0.913-2.454,2.803-2.454,5.318 c0,4.97,3.479,11.021,7.75,13.489c1.248,0.721,2.461,1.083,3.564,1.083c0.793,0,1.532-0.187,2.185-0.563 c1.583-0.914,2.452-2.802,2.452-5.319C533.659,269.915,530.181,263.865,525.909,261.399z M530.759,279.426 c-1.279,0.738-2.996,0.551-4.85-0.519c-4.026-2.324-7.298-8.024-7.298-12.709c0-2.182,0.711-3.793,1.998-4.539 c0.514-0.295,1.099-0.442,1.733-0.442c0.948,0,2.008,0.323,3.115,0.961c4.024,2.323,7.299,8.025,7.299,12.709 C532.757,277.069,532.046,278.682,530.759,279.426z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.722,271.008 526.501,272.038 526.501,269.993 524.722,268.963  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_755_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "512.264,277.877 512.721,278.654 539.178,262.993 538.722,262.217  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_753_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.22,
    y: 270.028,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 552.0007 860.9992)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_751_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.233,
    y: 253.123,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_749_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.158,
    y: 270.092,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 845.6582 767.6917)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_721_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.2725,
    y1: 294.3193,
    x2: 586.417,
    y2: 294.3193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_67_)",
    d: "M578.757,279.496l-20.116-11.617c-3.274-1.89-7.368,0.474-7.368,4.254v23.743 c0,5.473,2.92,10.53,7.658,13.266l20.118,11.614c3.275,1.893,7.368-0.471,7.368-4.252v-23.744 C586.417,287.288,583.496,282.231,578.757,279.496z"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_722_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_723_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_741_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.902,281.425l-18.12-10.46c-1.281-0.74-2.806-0.738-4.082,0c-1.276,0.738-2.043,2.059-2.043,3.534 v21.358c0,4.593,2.475,8.878,6.453,11.176l18.119,10.461c0.64,0.37,1.342,0.554,2.043,0.554c0.699,0,1.401-0.186,2.042-0.554 c1.278-0.739,2.043-2.061,2.043-3.538v-21.355C584.357,288.006,581.884,283.725,577.902,281.425z M583.455,313.957 c0,1.149-0.596,2.181-1.591,2.757c-0.999,0.575-2.192,0.575-3.184,0.002l-18.12-10.461c-3.702-2.139-6-6.123-6-10.397v-21.358 c0-1.149,0.593-2.18,1.592-2.755c0.996-0.576,2.19-0.573,3.18,0l18.118,10.459c3.703,2.141,6.005,6.125,6.005,10.398V313.957z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_737_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,276.46c-4.119-2.38-8.025-2.746-10.994-1.033c-2.999,1.731-4.651,5.354-4.651,10.2 c0,9.748,6.817,21.616,15.195,26.453c2.413,1.394,4.754,2.097,6.874,2.097c1.5,0,2.895-0.354,4.124-1.063 c2.999-1.732,4.651-5.354,4.651-10.201C584.502,293.166,577.685,281.299,569.303,276.46z M579.4,312.333 c-2.679,1.552-6.267,1.182-10.098-1.03c-8.13-4.697-14.742-16.213-14.742-25.675c0-4.511,1.493-7.856,4.199-9.42 c1.09-0.628,2.33-0.941,3.676-0.941c1.961,0,4.146,0.663,6.417,1.974c8.133,4.694,14.745,16.211,14.745,25.674 C583.598,307.424,582.106,310.769,579.4,312.333z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_733_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,285.127c-2.147-1.238-4.19-1.425-5.747-0.52c-1.583,0.913-2.452,2.802-2.452,5.319 c0,4.97,3.478,11.021,7.749,13.487c1.248,0.722,2.46,1.086,3.564,1.086c0.793,0,1.531-0.187,2.184-0.565 c1.583-0.912,2.452-2.803,2.452-5.32C577.053,293.644,573.575,287.593,569.303,285.127z M574.153,303.155 c-1.279,0.737-2.996,0.55-4.851-0.52c-4.023-2.323-7.297-8.026-7.297-12.709c0-2.182,0.711-3.795,1.997-4.538 c0.516-0.297,1.099-0.441,1.737-0.441c0.948,0,2.006,0.321,3.112,0.96c4.024,2.323,7.298,8.023,7.298,12.707 C576.15,300.798,575.44,302.41,574.153,303.155z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "568.116,294.737 569.896,295.765 569.896,293.723 568.116,292.693  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_730_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.666,
    y: 278.792,
    transform: "matrix(-0.5067 -0.8621 0.8621 -0.5067 603.9079 933.8641)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.745
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_728_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.616,
    y: 293.755,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 596.3787 934.1747)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_726_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.627,
    y: 276.852,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_724_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.551,
    y: 293.82,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 914.7869 833.6536)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_994_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.0869,
    y1: 281.4058,
    x2: 456.2305,
    y2: 281.4058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_68_)",
    d: "M448.573,266.582l-20.118-11.614c-3.274-1.892-7.368,0.472-7.368,4.252v23.743 c0,5.474,2.921,10.531,7.66,13.269l20.118,11.613c3.273,1.891,7.365-0.474,7.365-4.253V279.85 C456.23,274.376,453.314,269.318,448.573,266.582z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_995_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_996_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1014_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.717,268.511l-18.118-10.458c-1.281-0.742-2.808-0.74-4.081-0.002 c-1.279,0.738-2.043,2.059-2.043,3.536v21.355c0,4.596,2.472,8.879,6.451,11.178l18.118,10.461 c0.641,0.37,1.342,0.553,2.043,0.553c0.702,0,1.401-0.186,2.043-0.553c1.278-0.739,2.041-2.062,2.041-3.537v-21.357 C454.171,275.094,451.699,270.811,447.717,268.511z M453.27,301.044c0,1.149-0.596,2.179-1.591,2.755 c-0.999,0.575-2.189,0.576-3.183,0.002l-18.117-10.46c-3.704-2.139-6.002-6.124-6.002-10.399v-21.355 c0-1.151,0.592-2.182,1.59-2.755c0.996-0.576,2.19-0.574,3.181,0l18.117,10.459c3.704,2.14,6.005,6.124,6.005,10.397V301.044z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1010_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,263.548c-4.122-2.382-8.025-2.746-10.993-1.035c-3.001,1.731-4.651,5.354-4.651,10.2 c0,9.748,6.816,21.617,15.193,26.454c2.412,1.396,4.753,2.096,6.873,2.096c1.501,0,2.896-0.354,4.125-1.063 c2.999-1.732,4.651-5.354,4.651-10.201C454.317,280.252,447.501,268.386,439.119,263.548z M449.215,299.42 c-2.677,1.55-6.268,1.18-10.096-1.033c-8.13-4.695-14.742-16.211-14.742-25.674c0-4.511,1.491-7.856,4.2-9.419 c1.086-0.631,2.327-0.943,3.675-0.943c1.961,0,4.145,0.663,6.416,1.976c8.131,4.694,14.747,16.211,14.747,25.671 C453.415,294.51,451.922,297.855,449.215,299.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1006_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,272.215c-2.147-1.239-4.189-1.425-5.749-0.521c-1.581,0.913-2.452,2.802-2.452,5.321 c0,4.968,3.479,11.021,7.75,13.485c1.249,0.722,2.46,1.085,3.563,1.085c0.796,0,1.531-0.187,2.187-0.563 c1.582-0.913,2.45-2.802,2.45-5.32C446.868,280.73,443.392,274.681,439.119,272.215z M443.969,290.241 c-1.279,0.737-2.997,0.55-4.85-0.52c-4.025-2.325-7.298-8.023-7.298-12.707c0-2.184,0.71-3.795,1.997-4.541 c0.516-0.295,1.099-0.442,1.735-0.442c0.949,0,2.008,0.321,3.114,0.961c4.025,2.323,7.298,8.023,7.298,12.708 C445.966,287.884,445.257,289.496,443.969,290.241z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.932,281.823 439.712,282.851 439.712,280.809 437.932,279.779  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1003_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.481,
    y: 265.879,
    transform: "matrix(-0.5079 -0.8614 0.8614 -0.5079 419.574 802.2001)",
    fill: "#FFFFFF",
    width: 0.902,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1001_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.43,
    y: 280.841,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 412.7086 801.8657)",
    fill: "#FFFFFF",
    width: 52.755,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_999_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.441,
    y: 263.938,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_997_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.366,
    y: 280.907,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 678.3307 744.4576)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_880_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.4814,
    y1: 305.1338,
    x2: 499.6279,
    y2: 305.1338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_69_)",
    d: "M491.969,290.312l-20.12-11.617c-3.274-1.89-7.367,0.473-7.367,4.254v23.744 c0,5.472,2.92,10.529,7.66,13.266l20.118,11.616c3.273,1.888,7.368-0.476,7.368-4.257v-23.741 C499.628,298.105,496.708,293.046,491.969,290.312z"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_881_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_882_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_932_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M491.11,292.24l-18.118-10.461c-1.28-0.739-2.805-0.737-4.081-0.001 c-1.279,0.74-2.043,2.059-2.043,3.536v21.356c0,4.595,2.473,8.88,6.453,11.176l18.117,10.461 c0.642,0.37,1.344,0.557,2.043,0.557c0.701,0,1.402-0.187,2.043-0.557c1.277-0.736,2.043-2.059,2.043-3.535v-21.356 C497.567,298.821,495.095,294.538,491.11,292.24z M496.665,324.772c0,1.149-0.596,2.18-1.593,2.757 c-0.998,0.572-2.189,0.576-3.183,0l-18.117-10.46c-3.703-2.139-6.001-6.124-6.001-10.398v-21.356 c0-1.151,0.593-2.18,1.592-2.755c0.993-0.577,2.189-0.573,3.179,0l18.118,10.46c3.702,2.137,6.005,6.124,6.005,10.396V324.772z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_928_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,287.276c-4.121-2.381-8.026-2.747-10.995-1.036c-2.999,1.733-4.651,5.354-4.651,10.201 c0,9.747,6.816,21.617,15.195,26.455c2.412,1.394,4.752,2.096,6.872,2.096c1.501,0,2.895-0.353,4.126-1.063 c2.997-1.732,4.65-5.354,4.65-10.201C497.712,303.981,490.895,292.113,482.515,287.276z M492.61,323.148 c-2.677,1.551-6.266,1.181-10.096-1.031c-8.131-4.697-14.743-16.212-14.743-25.675c0-4.51,1.491-7.855,4.2-9.42 c1.087-0.628,2.326-0.94,3.675-0.94c1.96,0,4.146,0.663,6.417,1.973c8.13,4.694,14.746,16.211,14.746,25.674 C496.81,318.238,495.317,321.583,492.61,323.148z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_924_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,295.943c-2.148-1.239-4.191-1.425-5.751-0.521c-1.58,0.914-2.449,2.802-2.449,5.32 c0,4.969,3.476,11.02,7.749,13.486c1.248,0.722,2.46,1.085,3.565,1.085c0.793,0,1.53-0.186,2.184-0.563 c1.582-0.912,2.45-2.803,2.45-5.32C490.263,304.459,486.786,298.408,482.515,295.943z M487.362,313.967 c-1.276,0.74-2.995,0.551-4.848-0.518c-4.025-2.324-7.3-8.024-7.3-12.708c0-2.182,0.712-3.796,1.999-4.54 c0.514-0.296,1.097-0.443,1.735-0.443c0.948,0,2.007,0.323,3.114,0.96c4.025,2.325,7.297,8.026,7.297,12.71 C489.36,311.612,488.651,313.224,487.362,313.967z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.325,305.551 483.107,306.581 483.107,304.536 481.325,303.508  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.876,
    y: 289.605,
    transform: "matrix(-0.5068 -0.862 0.862 -0.5068 463.8806 875.3379)",
    fill: "#FFFFFF",
    width: 0.902,
    height: 30.746
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_887_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.825,
    y: 304.571,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 457.0637 875.0435)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_885_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.839,
    y: 287.665,
    fill: "#FFFFFF",
    width: 0.899,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.762,
    y: 304.635,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 747.4255 810.4415)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_846_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.876,
    y1: 328.8618,
    x2: 543.0225,
    y2: 328.8618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_70_)",
    d: "M535.362,314.038l-20.116-11.615c-3.275-1.889-7.37,0.473-7.37,4.255v23.742 c0,5.474,2.92,10.53,7.66,13.266l20.119,11.616c3.275,1.891,7.367-0.473,7.367-4.254v-23.743 C543.022,321.833,540.103,316.773,535.362,314.038z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_847_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_848_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_874_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.507,315.966l-18.119-10.459c-1.282-0.74-2.806-0.738-4.082,0 c-1.278,0.737-2.042,2.059-2.042,3.535V330.4c0,4.594,2.473,8.878,6.452,11.175l18.12,10.462 c0.639,0.369,1.34,0.553,2.039,0.553c0.702,0,1.403-0.186,2.043-0.553c1.279-0.74,2.043-2.061,2.043-3.537v-21.356 C540.961,322.547,538.489,318.267,534.507,315.966z M540.06,348.5c0,1.15-0.595,2.18-1.592,2.756 c-1,0.574-2.189,0.576-3.183,0.002l-18.118-10.462c-3.703-2.137-6-6.122-6-10.396v-21.358c0-1.149,0.593-2.181,1.59-2.755 c0.996-0.576,2.189-0.573,3.179,0l18.12,10.46c3.703,2.141,6.004,6.124,6.004,10.397V348.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,311.002c-4.12-2.38-8.025-2.744-10.995-1.033c-3,1.731-4.65,5.354-4.65,10.201 c0,9.747,6.817,21.614,15.194,26.452c2.412,1.395,4.754,2.098,6.875,2.098c1.5,0,2.892-0.354,4.122-1.064 c2.999-1.731,4.65-5.354,4.65-10.2C541.105,327.708,534.289,315.842,525.909,311.002z M536.005,346.875 c-2.678,1.552-6.267,1.182-10.096-1.031c-8.132-4.694-14.742-16.213-14.742-25.674c0-4.512,1.489-7.855,4.198-9.422 c1.09-0.627,2.329-0.939,3.676-0.939c1.962,0,4.145,0.662,6.417,1.973c8.131,4.694,14.745,16.212,14.745,25.675 C540.203,341.966,538.711,345.312,536.005,346.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,319.67c-2.148-1.236-4.19-1.425-5.747-0.521c-1.585,0.915-2.454,2.802-2.454,5.32 c0,4.971,3.479,11.021,7.75,13.489c1.248,0.72,2.461,1.084,3.564,1.084c0.793,0,1.532-0.188,2.185-0.564 c1.583-0.914,2.452-2.804,2.452-5.32C533.659,328.187,530.181,322.134,525.909,319.67z M530.759,337.696 c-1.279,0.74-2.996,0.553-4.85-0.518c-4.026-2.323-7.298-8.025-7.298-12.709c0-2.183,0.711-3.795,1.998-4.538 c0.514-0.297,1.099-0.442,1.733-0.442c0.948,0,2.008,0.322,3.115,0.96c4.024,2.324,7.299,8.024,7.299,12.709 C532.757,335.34,532.046,336.953,530.759,337.696z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.722,329.28 526.501,330.307 526.501,328.264 524.722,327.235  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_855_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.271,
    y: 313.334,
    transform: "matrix(-0.5078 -0.8615 0.8615 -0.5078 509.4937 948.5186)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.221,
    y: 328.299,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 501.445 948.222)",
    fill: "#FFFFFF",
    width: 52.751,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.233,
    y: 311.394,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.839
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.158,
    y: 328.364,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 816.5142 876.4308)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_821_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.2725,
    y1: 352.5908,
    x2: 586.417,
    y2: 352.5908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5218,
    style: {
      stopColor: "#0430C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_71_)",
    d: "M578.757,337.766l-20.116-11.615c-3.274-1.89-7.368,0.471-7.368,4.255v23.741 c0,5.473,2.92,10.529,7.658,13.268l20.118,11.615c3.275,1.893,7.368-0.473,7.368-4.254v-23.742 C586.417,345.559,583.496,340.502,578.757,337.766z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_822_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_841_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.902,339.696l-18.12-10.46c-1.281-0.739-2.806-0.739-4.082-0.002 c-1.276,0.739-2.043,2.06-2.043,3.537v21.356c0,4.596,2.475,8.879,6.453,11.176l18.119,10.461 c0.64,0.371,1.342,0.553,2.043,0.553c0.699,0,1.401-0.186,2.042-0.553c1.278-0.736,2.043-2.061,2.043-3.535v-21.355 C584.357,346.278,581.884,341.997,577.902,339.696z M583.455,372.229c0,1.148-0.596,2.178-1.591,2.754 c-0.999,0.576-2.192,0.576-3.184,0.002l-18.12-10.459c-3.702-2.139-6-6.123-6-10.398v-21.356c0-1.149,0.593-2.181,1.592-2.755 c0.996-0.576,2.19-0.573,3.18,0l18.118,10.457c3.703,2.143,6.005,6.126,6.005,10.4V372.229z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_837_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,334.731c-4.119-2.382-8.025-2.745-10.994-1.034c-2.999,1.733-4.651,5.355-4.651,10.2 c0,9.75,6.817,21.619,15.195,26.453c2.413,1.396,4.754,2.1,6.874,2.1c1.5,0,2.895-0.355,4.124-1.064 c2.999-1.73,4.651-5.355,4.651-10.203C584.502,351.436,577.685,339.569,569.303,334.731z M579.4,370.604 c-2.679,1.553-6.267,1.18-10.098-1.031c-8.13-4.695-14.742-16.213-14.742-25.675c0-4.511,1.493-7.854,4.199-9.419 c1.09-0.63,2.33-0.942,3.676-0.942c1.961,0,4.146,0.662,6.417,1.975c8.133,4.694,14.745,16.212,14.745,25.671 C583.598,365.695,582.106,369.041,579.4,370.604z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_833_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,343.399c-2.147-1.238-4.19-1.425-5.747-0.52c-1.583,0.911-2.452,2.799-2.452,5.318 c0,4.97,3.478,11.021,7.749,13.488c1.248,0.719,2.46,1.084,3.564,1.084c0.793,0,1.531-0.188,2.184-0.564 c1.583-0.914,2.452-2.803,2.452-5.32C577.053,351.912,573.575,345.863,569.303,343.399z M574.153,361.426 c-1.279,0.738-2.996,0.549-4.851-0.521c-4.023-2.322-7.297-8.023-7.297-12.707c0-2.182,0.711-3.795,1.997-4.54 c0.516-0.295,1.099-0.44,1.737-0.44c0.948,0,2.006,0.322,3.112,0.961c4.024,2.324,7.298,8.023,7.298,12.707 C576.15,359.068,575.44,360.682,574.153,361.426z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "568.116,353.01 569.896,354.035 569.896,351.992 568.116,350.965  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_830_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "555.659,359.879 556.115,360.654 582.573,344.994 582.116,344.216  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.616,
    y: 352.025,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 545.8069 1021.3969)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.627,
    y: 335.122,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_824_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.551,
    y: 352.091,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 885.6519 942.3885)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1094_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.0869,
    y1: 339.6768,
    x2: 456.2305,
    y2: 339.6768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5218,
    style: {
      stopColor: "#0430C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_72_)",
    d: "M448.573,324.853l-20.118-11.615c-3.274-1.892-7.368,0.473-7.368,4.254v23.742 c0,5.472,2.921,10.532,7.66,13.268l20.118,11.615c3.273,1.891,7.365-0.475,7.365-4.256v-23.743 C456.23,332.647,453.314,327.588,448.573,324.853z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1095_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1096_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1114_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.717,326.782l-18.118-10.459c-1.281-0.74-2.808-0.739-4.081-0.003 c-1.279,0.74-2.043,2.06-2.043,3.537v21.356c0,4.596,2.472,8.878,6.451,11.177l18.118,10.459 c0.641,0.371,1.342,0.555,2.043,0.555c0.702,0,1.401-0.184,2.043-0.555c1.278-0.738,2.041-2.059,2.041-3.533v-21.358 C454.171,333.365,451.699,329.083,447.717,326.782z M453.27,359.316c0,1.148-0.596,2.178-1.591,2.754 c-0.999,0.574-2.189,0.576-3.183,0l-18.117-10.459c-3.704-2.139-6.002-6.123-6.002-10.398v-21.356 c0-1.151,0.592-2.181,1.59-2.755c0.996-0.576,2.19-0.573,3.181,0l18.117,10.459c3.704,2.139,6.005,6.125,6.005,10.397V359.316z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1110_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,321.82c-4.122-2.382-8.025-2.748-10.993-1.037c-3.001,1.733-4.651,5.355-4.651,10.2 c0,9.749,6.816,21.619,15.193,26.455c2.412,1.395,4.753,2.098,6.873,2.098c1.501,0,2.896-0.354,4.125-1.063 c2.999-1.734,4.651-5.355,4.651-10.202C454.317,338.522,447.501,326.655,439.119,321.82z M449.215,357.689 c-2.677,1.553-6.268,1.18-10.096-1.031c-8.13-4.695-14.742-16.212-14.742-25.675c0-4.509,1.491-7.855,4.2-9.417 c1.086-0.631,2.327-0.942,3.675-0.942c1.961,0,4.145,0.663,6.416,1.976c8.131,4.691,14.747,16.21,14.747,25.672 C453.415,352.783,451.922,356.127,449.215,357.689z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1106_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,330.485c-2.147-1.237-4.189-1.425-5.749-0.521c-1.581,0.914-2.452,2.804-2.452,5.319 c0,4.971,3.479,11.021,7.75,13.488c1.249,0.721,2.46,1.084,3.563,1.084c0.796,0,1.531-0.186,2.187-0.563 c1.582-0.913,2.45-2.801,2.45-5.321C446.868,339.001,443.392,332.949,439.119,330.485z M443.969,348.512 c-1.279,0.738-2.997,0.549-4.85-0.521c-4.025-2.322-7.298-8.022-7.298-12.707c0-2.182,0.71-3.792,1.997-4.54 c0.516-0.295,1.099-0.441,1.735-0.441c0.949,0,2.008,0.322,3.114,0.962c4.025,2.324,7.298,8.023,7.298,12.708 C445.966,346.154,445.257,347.767,443.969,348.512z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.932,340.092 439.712,341.122 439.712,339.078 437.932,338.05  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1103_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.481,
    y: 324.15,
    transform: "matrix(-0.5086 -0.861 0.861 -0.5086 369.8321 890.1229)",
    fill: "#FFFFFF",
    width: 0.901,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1101_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.432,
    y: 339.113,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 362.1507 889.0905)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1099_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.441,
    y: 322.208,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.841
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1097_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.366,
    y: 339.178,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 649.1796 853.1993)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.4814,
    y1: 363.4043,
    x2: 499.6279,
    y2: 363.4043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_73_)",
    d: "M491.969,348.58l-20.12-11.616c-3.274-1.889-7.367,0.473-7.367,4.256v23.741 c0,5.473,2.92,10.531,7.66,13.266l20.118,11.617c3.273,1.891,7.368-0.473,7.368-4.254v-23.742 C499.628,356.373,496.708,351.316,491.969,348.58z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1070_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1071_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1089_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M491.11,350.51l-18.118-10.458c-1.28-0.741-2.805-0.739-4.081-0.003 c-1.279,0.739-2.043,2.06-2.043,3.537v21.356c0,4.596,2.473,8.877,6.453,11.176l18.117,10.461 c0.642,0.371,1.344,0.555,2.043,0.555c0.701,0,1.402-0.188,2.043-0.555c1.277-0.738,2.043-2.061,2.043-3.535v-21.355 C497.567,357.092,495.095,352.809,491.11,350.51z M496.665,383.043c0,1.15-0.596,2.18-1.593,2.756 c-0.998,0.574-2.189,0.576-3.183,0.002l-18.117-10.463c-3.703-2.139-6.001-6.123-6.001-10.396v-21.356 c0-1.151,0.593-2.181,1.592-2.757c0.993-0.574,2.189-0.573,3.179,0l18.118,10.46c3.702,2.141,6.005,6.125,6.005,10.398V383.043 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1085_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,345.546c-4.121-2.382-8.026-2.746-10.995-1.035c-2.999,1.731-4.651,5.354-4.651,10.202 c0,9.746,6.816,21.615,15.195,26.453c2.412,1.393,4.752,2.096,6.872,2.096c1.501,0,2.895-0.354,4.126-1.061 c2.997-1.732,4.65-5.357,4.65-10.203C497.712,362.25,490.895,350.383,482.515,345.546z M492.61,381.418 c-2.677,1.551-6.266,1.18-10.096-1.029c-8.131-4.697-14.743-16.215-14.743-25.676c0-4.512,1.491-7.856,4.2-9.421 c1.087-0.629,2.326-0.941,3.675-0.941c1.96,0,4.146,0.663,6.417,1.976c8.13,4.694,14.746,16.211,14.746,25.672 C496.81,376.508,495.317,379.855,492.61,381.418z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1081_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,354.211c-2.148-1.234-4.191-1.424-5.751-0.518c-1.58,0.912-2.449,2.801-2.449,5.318 c0,4.969,3.476,11.021,7.749,13.488c1.248,0.719,2.46,1.084,3.565,1.084c0.793,0,1.53-0.188,2.184-0.564 c1.582-0.912,2.45-2.803,2.45-5.318C490.263,362.729,486.786,356.676,482.515,354.211z M487.362,372.24 c-1.276,0.738-2.995,0.551-4.848-0.52c-4.025-2.324-7.3-8.025-7.3-12.709c0-2.182,0.712-3.795,1.999-4.539 c0.514-0.297,1.097-0.441,1.735-0.441c0.948,0,2.007,0.322,3.114,0.959c4.025,2.326,7.297,8.027,7.297,12.711 C489.36,369.883,488.651,371.496,487.362,372.24z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.325,363.822 483.107,364.852 483.107,362.807 481.325,361.777  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1078_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.877,
    y: 347.877,
    transform: "matrix(-0.5078 -0.8615 0.8615 -0.5078 414.308 963.218)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1076_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.826,
    y: 362.84,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 406.5001 962.2638)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1074_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.839,
    y: 345.936,
    fill: "#FFFFFF",
    width: 0.899,
    height: 34.839
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1072_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.761,
    y: 362.905,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 718.2776 919.1799)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1044_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M535.362,372.309l-20.116-11.615c-3.275-1.891-7.37,0.473-7.37,4.254v23.742 c0,5.473,2.92,10.531,7.66,13.268l20.119,11.613c3.275,1.893,7.367-0.471,7.367-4.252v-23.742 C543.022,380.102,540.103,375.045,535.362,372.309z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1045_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1046_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1064_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.507,374.238l-18.119-10.461c-1.282-0.738-2.806-0.738-4.082-0.002 c-1.278,0.74-2.042,2.061-2.042,3.537v21.355c0,4.596,2.473,8.881,6.452,11.18l18.12,10.459 c0.639,0.371,1.34,0.555,2.039,0.555c0.702,0,1.403-0.186,2.043-0.555c1.279-0.738,2.043-2.061,2.043-3.535v-21.355 C540.961,380.818,538.489,376.537,534.507,374.238z M540.06,406.771c0,1.148-0.595,2.18-1.592,2.754 c-1,0.576-2.189,0.576-3.183,0.004l-18.118-10.463c-3.703-2.139-6-6.121-6-10.398v-21.355c0-1.15,0.593-2.18,1.59-2.756 c0.996-0.576,2.189-0.572,3.179,0l18.12,10.461c3.703,2.141,6.004,6.125,6.004,10.398V406.771z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1060_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,369.273c-4.12-2.379-8.025-2.746-10.995-1.033c-3,1.73-4.65,5.355-4.65,10.201 c0,9.746,6.817,21.615,15.194,26.453c2.412,1.393,4.754,2.098,6.875,2.098c1.5,0,2.892-0.355,4.122-1.064 c2.999-1.732,4.65-5.355,4.65-10.201C541.105,385.977,534.289,374.111,525.909,369.273z M536.005,405.146 c-2.678,1.551-6.267,1.182-10.096-1.031c-8.132-4.697-14.742-16.213-14.742-25.674c0-4.512,1.489-7.857,4.198-9.422 c1.09-0.629,2.329-0.941,3.676-0.941c1.962,0,4.145,0.662,6.417,1.975c8.131,4.695,14.745,16.211,14.745,25.674 C540.203,400.238,538.711,403.582,536.005,405.146z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1056_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,377.941c-2.148-1.238-4.19-1.426-5.747-0.52c-1.585,0.91-2.454,2.801-2.454,5.318 c0,4.969,3.479,11.02,7.75,13.488c1.248,0.719,2.461,1.084,3.564,1.084c0.793,0,1.532-0.189,2.185-0.564 c1.583-0.914,2.452-2.803,2.452-5.32C533.659,386.457,530.181,380.406,525.909,377.941z M530.759,395.969 c-1.279,0.736-2.996,0.551-4.85-0.521c-4.026-2.324-7.298-8.023-7.298-12.707c0-2.182,0.711-3.795,1.998-4.539 c0.514-0.297,1.099-0.441,1.733-0.441c0.948,0,2.008,0.32,3.115,0.959c4.024,2.326,7.299,8.025,7.299,12.709 C532.757,393.609,532.046,395.223,530.759,395.969z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.722,387.551 526.501,388.578 526.501,386.533 524.722,385.506  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "512.264,394.42 512.721,395.195 539.178,379.535 538.722,378.758  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1051_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.221,
    y: 386.57,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 450.8641 1035.4434)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1049_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.233,
    y: 369.664,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.158,
    y: 386.634,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 787.3915 985.1566)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1019_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.2725,
    y1: 410.8604,
    x2: 586.417,
    y2: 410.8604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_74_)",
    d: "M578.757,396.037l-20.116-11.613c-3.274-1.893-7.368,0.469-7.368,4.252v23.742 c0,5.475,2.92,10.531,7.658,13.268l20.118,11.613c3.275,1.891,7.368-0.473,7.368-4.252v-23.742 C586.417,403.83,583.496,398.773,578.757,396.037z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1020_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1021_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1039_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.902,397.965l-18.12-10.457c-1.281-0.742-2.806-0.74-4.082-0.002 c-1.276,0.736-2.043,2.059-2.043,3.535v21.355c0,4.596,2.475,8.879,6.453,11.178l18.119,10.463 c0.64,0.369,1.342,0.553,2.043,0.553c0.699,0,1.401-0.186,2.042-0.553c1.278-0.74,2.043-2.063,2.043-3.537v-21.357 C584.357,404.547,581.884,400.266,577.902,397.965z M583.455,430.5c0,1.148-0.596,2.178-1.591,2.754 c-0.999,0.576-2.192,0.576-3.184,0.002l-18.12-10.461c-3.702-2.139-6-6.123-6-10.398v-21.355c0-1.15,0.593-2.182,1.592-2.756 c0.996-0.576,2.19-0.574,3.18,0l18.118,10.459c3.703,2.141,6.005,6.125,6.005,10.398V430.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1035_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,393.002c-4.119-2.381-8.025-2.746-10.994-1.035c-2.999,1.732-4.651,5.355-4.651,10.201 c0,9.748,6.817,21.617,15.195,26.455c2.413,1.395,4.754,2.096,6.874,2.096c1.5,0,2.895-0.354,4.124-1.063 c2.999-1.734,4.651-5.355,4.651-10.201C584.502,409.705,577.685,397.84,569.303,393.002z M579.4,428.875 c-2.679,1.551-6.267,1.18-10.098-1.033c-8.13-4.693-14.742-16.211-14.742-25.674c0-4.512,1.493-7.857,4.199-9.418 c1.09-0.633,2.33-0.943,3.676-0.943c1.961,0,4.146,0.664,6.417,1.977c8.133,4.693,14.745,16.209,14.745,25.672 C583.598,423.965,582.106,427.309,579.4,428.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,401.668c-2.147-1.238-4.19-1.422-5.747-0.52c-1.583,0.912-2.452,2.803-2.452,5.322 c0,4.967,3.478,11.018,7.749,13.484c1.248,0.721,2.46,1.084,3.564,1.084c0.793,0,1.531-0.186,2.184-0.563 c1.583-0.914,2.452-2.801,2.452-5.32C577.053,410.186,573.575,404.135,569.303,401.668z M574.153,419.695 c-1.279,0.738-2.996,0.551-4.851-0.518c-4.023-2.326-7.297-8.023-7.297-12.707c0-2.186,0.711-3.795,1.997-4.541 c0.516-0.297,1.099-0.443,1.737-0.443c0.948,0,2.006,0.322,3.112,0.961c4.024,2.324,7.298,8.023,7.298,12.709 C576.15,417.338,575.44,418.949,574.153,419.695z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "568.116,411.277 569.896,412.307 569.896,410.262 568.116,409.234  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1028_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "555.659,418.146 556.115,418.924 582.573,403.264 582.116,402.488  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1026_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.615,
    y: 410.296,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 495.2278 1108.6185)",
    fill: "#FFFFFF",
    width: 52.755,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1024_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.627,
    y: 393.393,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1022_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.551,
    y: 410.363,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 856.5397 1051.114)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.899
  })))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1194_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010080",
    d: "M448.573,383.125l-20.118-11.615c-3.274-1.891-7.368,0.473-7.368,4.252v23.742 c0,5.475,2.921,10.531,7.66,13.268l20.118,11.613c3.273,1.893,7.365-0.473,7.365-4.252v-23.742 C456.23,390.916,453.314,385.859,448.573,383.125z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1195_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1196_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1214_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.717,385.055l-18.118-10.461c-1.281-0.742-2.808-0.74-4.081-0.002 c-1.279,0.738-2.043,2.059-2.043,3.535v21.357c0,4.594,2.472,8.877,6.451,11.176l18.118,10.463 c0.641,0.369,1.342,0.553,2.043,0.553c0.702,0,1.401-0.184,2.043-0.553c1.278-0.74,2.041-2.063,2.041-3.537v-21.357 C454.171,391.633,451.699,387.352,447.717,385.055z M453.27,417.586c0,1.148-0.596,2.18-1.591,2.756 c-0.999,0.574-2.189,0.574-3.183,0l-18.117-10.461c-3.704-2.139-6.002-6.123-6.002-10.396v-21.357 c0-1.15,0.592-2.18,1.59-2.756c0.996-0.576,2.19-0.574,3.181,0l18.117,10.461c3.704,2.139,6.005,6.125,6.005,10.396V417.586z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1210_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,380.09c-4.122-2.381-8.025-2.748-10.993-1.037c-3.001,1.732-4.651,5.355-4.651,10.201 c0,9.75,6.816,21.617,15.193,26.455c2.412,1.395,4.753,2.096,6.873,2.096c1.501,0,2.896-0.354,4.125-1.063 c2.999-1.732,4.651-5.354,4.651-10.199C454.317,396.795,447.501,384.926,439.119,380.09z M449.215,415.961 c-2.677,1.551-6.268,1.182-10.096-1.031c-8.13-4.695-14.742-16.213-14.742-25.676c0-4.51,1.491-7.854,4.2-9.418 c1.086-0.629,2.327-0.941,3.675-0.941c1.961,0,4.145,0.662,6.416,1.975c8.131,4.693,14.747,16.209,14.747,25.674 C453.415,411.051,451.922,414.396,449.215,415.961z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1206_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.119,388.754c-2.147-1.236-4.189-1.422-5.749-0.518c-1.581,0.91-2.452,2.801-2.452,5.316 c0,4.971,3.479,11.021,7.75,13.49c1.249,0.721,2.46,1.082,3.563,1.082c0.796,0,1.531-0.186,2.187-0.563 c1.582-0.914,2.45-2.801,2.45-5.32C446.868,397.273,443.392,391.221,439.119,388.754z M443.969,406.781 c-1.279,0.738-2.997,0.551-4.85-0.518c-4.025-2.324-7.298-8.023-7.298-12.711c0-2.182,0.71-3.791,1.997-4.537 c0.516-0.297,1.099-0.443,1.735-0.443c0.949,0,2.008,0.322,3.114,0.963c4.025,2.322,7.298,8.025,7.298,12.707 C445.966,404.424,445.257,406.037,443.969,406.781z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.932,398.363 439.712,399.393 439.712,397.348 437.932,396.318  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1203_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "425.475,405.232 425.933,406.012 452.389,390.348 451.931,389.574  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1201_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.431,
    y: 397.384,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 311.5786 976.3138)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1199_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.441,
    y: 380.479,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1197_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.365,
    y: 397.447,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 620.0109 961.9438)",
    fill: "#FFFFFF",
    width: 35.059,
    height: 0.9
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1169_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.4814,
    y1: 421.6758,
    x2: 499.6279,
    y2: 421.6758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F766FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8125C6"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_75_)",
    d: "M491.969,406.852l-20.12-11.615c-3.274-1.891-7.367,0.473-7.367,4.254v23.742 c0,5.473,2.92,10.529,7.66,13.266l20.118,11.615c3.273,1.893,7.368-0.473,7.368-4.252v-23.744 C499.628,414.643,496.708,409.588,491.969,406.852z"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1170_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1171_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1189_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M491.11,408.781l-18.118-10.461c-1.28-0.74-2.805-0.738-4.081,0c-1.279,0.736-2.043,2.061-2.043,3.537 v21.355c0,4.594,2.473,8.877,6.453,11.176l18.117,10.463c0.642,0.369,1.344,0.553,2.043,0.553c0.701,0,1.402-0.186,2.043-0.553 c1.277-0.74,2.043-2.063,2.043-3.539v-21.355C497.567,415.361,495.095,411.08,491.11,408.781z M496.665,441.313 c0,1.15-0.596,2.18-1.593,2.756c-0.998,0.576-2.189,0.576-3.183,0.002l-18.117-10.459c-3.703-2.141-6.001-6.125-6.001-10.398 v-21.355c0-1.15,0.593-2.184,1.592-2.758c0.993-0.576,2.189-0.572,3.179,0l18.118,10.459c3.702,2.141,6.005,6.127,6.005,10.398 V441.313z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1185_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,403.814c-4.121-2.379-8.026-2.744-10.995-1.031c-2.999,1.73-4.651,5.354-4.651,10.199 c0,9.75,6.816,21.617,15.195,26.455c2.412,1.393,4.752,2.096,6.872,2.096c1.501,0,2.895-0.354,4.126-1.063 c2.997-1.734,4.65-5.355,4.65-10.201C497.712,420.521,490.895,408.656,482.515,403.814z M492.61,439.688 c-2.677,1.553-6.266,1.184-10.096-1.029c-8.131-4.697-14.743-16.213-14.743-25.676c0-4.51,1.491-7.855,4.2-9.42 c1.087-0.627,2.326-0.941,3.675-0.941c1.96,0,4.146,0.664,6.417,1.975c8.13,4.693,14.746,16.211,14.746,25.674 C496.81,434.781,495.317,438.125,492.61,439.688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1181_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.515,412.482c-2.148-1.236-4.191-1.424-5.751-0.52c-1.58,0.914-2.449,2.803-2.449,5.318 c0,4.971,3.476,11.023,7.749,13.488c1.248,0.723,2.46,1.086,3.565,1.086c0.793,0,1.53-0.188,2.184-0.566 c1.582-0.91,2.45-2.803,2.45-5.318C490.263,421,486.786,414.949,482.515,412.482z M487.362,430.51 c-1.276,0.738-2.995,0.551-4.848-0.518c-4.025-2.324-7.3-8.025-7.3-12.711c0-2.182,0.712-3.793,1.999-4.537 c0.514-0.297,1.097-0.441,1.735-0.441c0.948,0,2.007,0.32,3.114,0.961c4.025,2.322,7.297,8.021,7.297,12.707 C489.36,428.154,488.651,429.766,487.362,430.51z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.325,422.094 483.107,423.121 483.107,421.08 481.325,420.049  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1178_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.877,
    y: 406.15,
    transform: "matrix(-0.5078 -0.8615 0.8615 -0.5078 364.1069 1051.08)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.743
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1176_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.827,
    y: 421.112,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 355.9439 1049.49)",
    fill: "#FFFFFF",
    width: 52.751,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1174_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.839,
    y: 404.207,
    fill: "#FFFFFF",
    width: 0.899,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1172_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.761,
    y: 421.176,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 689.141 1027.9154)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1144_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.876,
    y1: 445.4023,
    x2: 543.0225,
    y2: 445.4023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09008F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5218,
    style: {
      stopColor: "#0430C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005DFF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_76_)",
    d: "M535.362,430.578l-20.116-11.613c-3.275-1.893-7.37,0.473-7.37,4.254v23.742 c0,5.473,2.92,10.531,7.66,13.268l20.119,11.613c3.275,1.891,7.367-0.473,7.367-4.254v-23.742 C543.022,438.371,540.103,433.316,535.362,430.578z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1145_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1146_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1164_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.507,432.508l-18.119-10.459c-1.282-0.738-2.806-0.738-4.082,0 c-1.278,0.736-2.042,2.059-2.042,3.535v21.355c0,4.596,2.473,8.881,6.452,11.18l18.12,10.459 c0.639,0.369,1.34,0.553,2.039,0.553c0.702,0,1.403-0.186,2.043-0.553c1.279-0.738,2.043-2.061,2.043-3.537v-21.355 C540.961,439.09,538.489,434.807,534.507,432.508z M540.06,465.041c0,1.15-0.595,2.18-1.592,2.756 c-1,0.574-2.189,0.576-3.183,0l-18.118-10.457c-3.703-2.141-6-6.125-6-10.4v-21.355c0-1.15,0.593-2.182,1.59-2.756 c0.996-0.576,2.189-0.572,3.179,0l18.12,10.459c3.703,2.139,6.004,6.127,6.004,10.398V465.041z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1160_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,427.547c-4.12-2.383-8.025-2.75-10.995-1.037c-3,1.73-4.65,5.354-4.65,10.201 c0,9.75,6.817,21.617,15.194,26.453c2.412,1.395,4.754,2.098,6.875,2.098c1.5,0,2.892-0.354,4.122-1.064 c2.999-1.732,4.65-5.355,4.65-10.201C541.105,444.25,534.289,432.383,525.909,427.547z M536.005,463.416 c-2.678,1.553-6.267,1.182-10.096-1.033c-8.132-4.693-14.742-16.209-14.742-25.672c0-4.51,1.489-7.855,4.198-9.42 c1.09-0.629,2.329-0.941,3.676-0.941c1.962,0,4.145,0.664,6.417,1.975c8.131,4.695,14.745,16.211,14.745,25.672 C540.203,458.508,538.711,461.854,536.005,463.416z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1156_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.909,436.211c-2.148-1.238-4.19-1.424-5.747-0.521c-1.585,0.914-2.454,2.803-2.454,5.322 c0,4.969,3.479,11.02,7.75,13.486c1.248,0.719,2.461,1.084,3.564,1.084c0.793,0,1.532-0.186,2.185-0.563 c1.583-0.914,2.452-2.803,2.452-5.32C533.659,444.729,530.181,438.678,525.909,436.211z M530.759,454.238 c-1.279,0.738-2.996,0.549-4.85-0.518c-4.026-2.326-7.298-8.025-7.298-12.709c0-2.182,0.711-3.795,1.998-4.539 c0.514-0.297,1.099-0.443,1.733-0.443c0.948,0,2.008,0.322,3.115,0.961c4.024,2.324,7.299,8.023,7.299,12.709 C532.757,451.883,532.046,453.492,530.759,454.238z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.722,445.82 526.501,446.848 526.501,444.805 524.722,443.777  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1153_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "512.264,452.689 512.721,453.467 539.178,437.805 538.722,437.029  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1151_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.221,
    y: 444.84,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 400.2946 1122.6652)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.903
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1149_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.233,
    y: 427.934,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1147_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.158,
    y: 444.906,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 758.2856 1093.8828)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.901
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1119_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.2725,
    y1: 469.1309,
    x2: 586.417,
    y2: 469.1309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_77_)",
    d: "M578.757,454.307l-20.116-11.615c-3.274-1.891-7.368,0.475-7.368,4.256v23.742 c0,5.473,2.92,10.531,7.658,13.266l20.118,11.615c3.275,1.891,7.368-0.473,7.368-4.254v-23.742 C586.417,462.104,583.496,457.043,578.757,454.307z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1120_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1121_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1139_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.902,456.236l-18.12-10.459c-1.281-0.74-2.806-0.738-4.082-0.002 c-1.276,0.738-2.043,2.059-2.043,3.535v21.355c0,4.598,2.475,8.883,6.453,11.18l18.119,10.459 c0.64,0.371,1.342,0.555,2.043,0.555c0.699,0,1.401-0.184,2.042-0.555c1.278-0.738,2.043-2.059,2.043-3.533v-21.359 C584.357,462.82,581.884,458.535,577.902,456.236z M583.455,488.771c0,1.148-0.596,2.178-1.591,2.754 c-0.999,0.574-2.192,0.576-3.184,0l-18.12-10.461c-3.702-2.137-6-6.121-6-10.398v-21.355c0-1.15,0.593-2.18,1.592-2.754 c0.996-0.576,2.19-0.572,3.18,0l18.118,10.459c3.703,2.139,6.005,6.125,6.005,10.396V488.771z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1135_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,451.275c-4.119-2.383-8.025-2.75-10.994-1.039c-2.999,1.734-4.651,5.357-4.651,10.201 c0,9.75,6.817,21.617,15.195,26.455c2.413,1.395,4.754,2.098,6.874,2.098c1.5,0,2.895-0.354,4.124-1.063 c2.999-1.734,4.651-5.355,4.651-10.203C584.502,467.979,577.685,456.109,569.303,451.275z M579.4,487.145 c-2.679,1.553-6.267,1.18-10.098-1.031c-8.13-4.695-14.742-16.213-14.742-25.676c0-4.508,1.493-7.855,4.199-9.42 c1.09-0.627,2.33-0.939,3.676-0.939c1.961,0,4.146,0.664,6.417,1.973c8.133,4.695,14.745,16.213,14.745,25.674 C583.598,482.234,582.106,485.582,579.4,487.145z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1131_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M569.303,459.939c-2.147-1.238-4.19-1.424-5.747-0.521c-1.583,0.916-2.452,2.803-2.452,5.322 c0,4.969,3.478,11.021,7.749,13.484c1.248,0.723,2.46,1.084,3.564,1.084c0.793,0,1.531-0.184,2.184-0.561 c1.583-0.914,2.452-2.803,2.452-5.322C577.053,468.457,573.575,462.404,569.303,459.939z M574.153,477.967 c-1.279,0.738-2.996,0.549-4.851-0.52c-4.023-2.324-7.297-8.025-7.297-12.707c0-2.184,0.711-3.795,1.997-4.543 c0.516-0.293,1.099-0.441,1.737-0.441c0.948,0,2.006,0.322,3.112,0.963c4.024,2.324,7.298,8.025,7.298,12.707 C576.15,475.607,575.44,477.223,574.153,477.967z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "568.116,469.547 569.896,470.576 569.896,468.533 568.116,467.504  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1128_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.667,
    y: 453.604,
    transform: "matrix(-0.5079 -0.8614 0.8614 -0.5079 454.2057 1197.4187)",
    fill: "#FFFFFF",
    width: 0.898,
    height: 30.745
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1126_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.616,
    y: 468.568,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 444.6707 1195.844)",
    fill: "#FFFFFF",
    width: 52.754,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1124_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.627,
    y: 451.662,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1122_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.551,
    y: 468.632,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 827.3739 1159.8601)",
    fill: "#FFFFFF",
    width: 35.058,
    height: 0.9
  })))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1294_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DFF",
    d: "M578.757,536.305l-20.116-11.615c-3.274-1.889-7.368,0.475-7.368,4.254v23.744 c0,5.473,2.92,10.529,7.658,13.266l20.118,11.615c3.275,1.893,7.368-0.473,7.368-4.252v-23.744 C586.417,544.1,583.496,539.041,578.757,536.305z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1295_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1296_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M577.577,538.418l-18.117-10.461c-0.64-0.373-1.342-0.555-2.044-0.555c-0.701,0-1.4,0.184-2.042,0.555 c-1.278,0.736-2.043,2.059-2.043,3.533v21.357c0,4.594,2.475,8.877,6.456,11.178l18.118,10.459 c1.282,0.738,2.809,0.738,4.084,0.002c1.277-0.74,2.04-2.059,2.04-3.537v-21.355C584.029,545,581.558,540.715,577.577,538.418z  M583.129,570.949c0,1.15-0.593,2.182-1.592,2.756c-0.996,0.574-2.191,0.572-3.182,0l-18.116-10.459 c-3.703-2.141-6.005-6.125-6.005-10.398V531.49c0-1.148,0.596-2.178,1.592-2.754c0.998-0.574,2.188-0.578,3.182-0.002 l18.118,10.461c3.705,2.139,6.003,6.123,6.003,10.398V570.949z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1310_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M568.836,533.369c-2.412-1.396-4.754-2.098-6.873-2.098c-1.502,0-2.896,0.354-4.124,1.064 c-3,1.732-4.65,5.354-4.65,10.199c0,9.748,6.814,21.617,15.195,26.453c4.122,2.381,8.026,2.746,10.997,1.035 c2.998-1.732,4.648-5.355,4.648-10.201C584.029,550.074,577.215,538.207,568.836,533.369z M578.929,569.242 c-1.09,0.631-2.328,0.941-3.676,0.941c-1.962,0-4.146-0.664-6.417-1.975c-8.132-4.695-14.745-16.213-14.745-25.674 c0-4.51,1.491-7.854,4.198-9.42c2.679-1.551,6.267-1.18,10.095,1.033c8.133,4.695,14.745,16.213,14.745,25.674 C583.129,564.332,581.636,567.68,578.929,569.242z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1306_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M568.836,542.035c-1.248-0.721-2.461-1.086-3.563-1.086c-0.794,0-1.531,0.188-2.185,0.566 c-1.582,0.912-2.452,2.801-2.452,5.32c0,4.969,3.479,11.021,7.748,13.486c2.148,1.238,4.19,1.424,5.75,0.521 c1.582-0.914,2.452-2.803,2.452-5.32C576.586,550.553,573.107,544.502,568.836,542.035z M573.686,560.061 c-0.515,0.297-1.098,0.443-1.736,0.443c-0.947,0-2.006-0.322-3.113-0.961c-4.023-2.324-7.298-8.025-7.298-12.707 c0-2.182,0.708-3.795,1.998-4.541c1.278-0.736,2.995-0.551,4.848,0.52c4.025,2.324,7.3,8.023,7.3,12.709 C575.684,557.705,574.974,559.316,573.686,560.061z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "567.791,551.729 569.572,552.756 569.572,550.711 567.791,549.686  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1303_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "555.117,558.727 555.573,559.504 582.03,543.844 581.574,543.068  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1301_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.32,
    y: 550.792,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 372.8583 1318.6624)",
    fill: "#FFFFFF",
    width: 52.753,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1299_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.159,
    y: 533.758,
    fill: "#FFFFFF",
    width: 0.903,
    height: 34.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1297_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.081,
    y: 550.729,
    transform: "matrix(-0.8661 -0.4999 0.4999 -0.8661 785.5088 1312.801)",
    fill: "#FFFFFF",
    width: 35.056,
    height: 0.899
  })))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1269_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DFF",
    d: "M535.362,512.58l-20.116-11.615c-3.275-1.893-7.37,0.471-7.37,4.252v23.742 c0,5.473,2.92,10.531,7.66,13.268l20.119,11.613c3.275,1.893,7.367-0.473,7.367-4.254v-23.74 C543.022,520.371,540.103,515.314,535.362,512.58z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1270_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1289_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M534.184,514.689l-18.118-10.461c-0.642-0.371-1.342-0.555-2.043-0.555 c-0.702,0-1.401,0.186-2.043,0.555c-1.278,0.736-2.042,2.061-2.042,3.535v21.357c0,4.594,2.473,8.877,6.456,11.176 l18.117,10.457c1.281,0.742,2.807,0.74,4.081,0.004c1.28-0.74,2.044-2.059,2.044-3.535v-21.357 C540.636,521.271,538.164,516.988,534.184,514.689z M539.733,547.223c0,1.15-0.593,2.18-1.592,2.754 c-0.996,0.576-2.189,0.574-3.18,0l-18.118-10.461c-3.701-2.139-6.003-6.121-6.003-10.395v-21.357 c0-1.148,0.596-2.182,1.59-2.758c0.999-0.572,2.19-0.574,3.184,0l18.118,10.461c3.702,2.139,6.001,6.125,6.001,10.398V547.223z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1285_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.441,509.639c-2.412-1.393-4.753-2.094-6.874-2.094c-1.5,0-2.894,0.354-4.124,1.063 c-2.999,1.732-4.651,5.354-4.651,10.199c0,9.748,6.816,21.615,15.198,26.453c4.122,2.381,8.026,2.746,10.994,1.035 c3-1.73,4.651-5.354,4.651-10.201C540.636,526.348,533.819,514.477,525.441,509.639z M535.532,545.514 c-1.087,0.629-2.326,0.941-3.675,0.941c-1.962,0-4.146-0.664-6.416-1.975c-8.131-4.693-14.747-16.211-14.747-25.674 c0-4.508,1.493-7.855,4.2-9.42c2.677-1.549,6.268-1.178,10.096,1.033c8.13,4.695,14.743,16.213,14.743,25.674 C539.733,540.604,538.241,543.951,535.532,545.514z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1281_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.441,518.307c-1.25-0.721-2.46-1.084-3.566-1.084c-0.793,0-1.529,0.188-2.182,0.564 c-1.583,0.912-2.452,2.803-2.452,5.32c0,4.971,3.478,11.021,7.749,13.486c2.146,1.236,4.189,1.426,5.749,0.52 c1.581-0.912,2.45-2.801,2.45-5.32C533.189,526.826,529.713,520.773,525.441,518.307z M530.289,536.334 c-0.514,0.295-1.097,0.441-1.734,0.441c-0.948,0-2.005-0.322-3.113-0.959c-4.026-2.324-7.298-8.027-7.298-12.709 c0-2.184,0.709-3.797,1.999-4.541c1.276-0.738,2.995-0.549,4.848,0.52c4.024,2.324,7.298,8.023,7.298,12.707 C532.288,533.979,531.577,535.59,530.289,536.334z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "524.397,528 526.179,529.029 526.179,526.984 524.397,525.955  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1278_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.727,
    y: 512.185,
    transform: "matrix(-0.5094 -0.8605 0.8605 -0.5094 338.7129 1248.2236)",
    fill: "#FFFFFF",
    width: 0.901,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1276_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.925,
    y: 527.064,
    transform: "matrix(-0.4968 -0.8678 0.8678 -0.4968 328.4828 1245.4814)",
    fill: "#FFFFFF",
    width: 52.755,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1274_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.765,
    y: 510.029,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1272_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.686,
    y: 527,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 716.3598 1246.8369)",
    fill: "#FFFFFF",
    width: 35.057,
    height: 0.9
  })))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1244_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DFF",
    d: "M491.969,488.852l-20.12-11.615c-3.274-1.893-7.367,0.471-7.367,4.252v23.744 c0,5.471,2.92,10.529,7.66,13.264l20.118,11.617c3.273,1.891,7.368-0.473,7.368-4.254v-23.742 C499.628,496.645,496.708,491.588,491.969,488.852z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1245_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1264_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M490.787,490.959l-18.116-10.461c-0.642-0.369-1.344-0.553-2.043-0.553 c-0.701,0-1.403,0.186-2.043,0.553c-1.279,0.74-2.043,2.063-2.043,3.539v21.354c0,4.598,2.473,8.877,6.457,11.178 l18.118,10.461c1.28,0.738,2.805,0.736,4.081,0c1.277-0.738,2.043-2.059,2.043-3.535v-21.359 C497.241,497.543,494.768,493.258,490.787,490.959z M496.337,523.494c0,1.15-0.592,2.18-1.59,2.756 c-0.995,0.576-2.19,0.572-3.18,0l-18.119-10.461c-3.702-2.141-6.004-6.125-6.004-10.398v-21.354 c0-1.15,0.596-2.182,1.592-2.758c1-0.574,2.19-0.576,3.184-0.002l18.117,10.463c3.702,2.139,6,6.123,6,10.395V523.494z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1260_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.048,485.912c-2.414-1.395-4.755-2.096-6.877-2.096c-1.499,0-2.892,0.354-4.122,1.063 c-3,1.732-4.65,5.354-4.65,10.201c0,9.748,6.816,21.615,15.196,26.453c4.121,2.381,8.025,2.746,10.995,1.033 c3-1.73,4.651-5.354,4.651-10.201C497.241,502.617,490.424,490.75,482.048,485.912z M492.139,521.787 c-1.089,0.629-2.329,0.941-3.676,0.941c-1.961,0-4.146-0.664-6.415-1.977c-8.133-4.691-14.747-16.209-14.747-25.672 c0-4.51,1.491-7.855,4.198-9.42c2.678-1.551,6.267-1.182,10.096,1.031c8.132,4.697,14.742,16.213,14.742,25.674 C496.337,516.877,494.847,520.223,492.139,521.787z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1256_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.048,494.58c-1.25-0.721-2.462-1.086-3.566-1.086c-0.794,0-1.531,0.188-2.185,0.564 c-1.582,0.912-2.449,2.803-2.449,5.32c0,4.971,3.476,11.021,7.747,13.486c2.148,1.24,4.191,1.426,5.75,0.52 c1.582-0.912,2.449-2.801,2.449-5.318C489.794,503.096,486.319,497.047,482.048,494.58z M486.896,512.605 c-0.516,0.297-1.1,0.441-1.735,0.441c-0.947,0-2.007-0.32-3.112-0.961c-4.027-2.322-7.299-8.023-7.299-12.707 c0-2.184,0.709-3.795,1.995-4.541c1.281-0.736,2.998-0.551,4.851,0.52c4.025,2.322,7.297,8.025,7.297,12.709 C488.892,510.248,488.184,511.863,486.896,512.605z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "481.002,504.271 482.784,505.301 482.784,503.256 481.002,502.229  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1253_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.333,
    y: 488.457,
    transform: "matrix(-0.5078 -0.8615 0.8615 -0.5078 292.3798 1174.713)",
    fill: "#FFFFFF",
    width: 0.9,
    height: 30.744
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1251_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.531,
    y: 503.336,
    transform: "matrix(-0.4968 -0.8679 0.8679 -0.4968 284.11 1172.302)",
    fill: "#FFFFFF",
    width: 52.752,
    height: 0.903
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1249_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.368,
    y: 486.303,
    fill: "#FFFFFF",
    width: 0.905,
    height: 34.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1247_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.29,
    y: 503.272,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 647.2322 1180.8674)",
    fill: "#FFFFFF",
    width: 35.059,
    height: 0.901
  })))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1219_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DFF",
    d: "M448.573,465.123l-20.118-11.617c-3.274-1.889-7.368,0.475-7.368,4.256v23.742 c0,5.473,2.921,10.529,7.66,13.266l20.118,11.615c3.273,1.893,7.365-0.471,7.365-4.254v-23.742 C456.23,472.916,453.314,467.857,448.573,465.123z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1220_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1221_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1239_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.394,467.23l-18.118-10.459c-0.641-0.369-1.342-0.553-2.045-0.553 c-0.698,0-1.399,0.186-2.039,0.553c-1.279,0.738-2.043,2.061-2.043,3.537v21.355c0,4.594,2.472,8.877,6.454,11.178 l18.118,10.459c1.282,0.738,2.807,0.738,4.083,0c1.278-0.736,2.043-2.059,2.043-3.535v-21.357 C453.847,473.814,451.374,469.529,447.394,467.23z M452.943,499.766c0,1.15-0.593,2.182-1.591,2.754 c-0.997,0.576-2.189,0.574-3.179,0l-18.12-10.457c-3.703-2.141-6.003-6.127-6.003-10.398v-21.355c0-1.15,0.594-2.18,1.59-2.756 c1.001-0.574,2.19-0.576,3.183-0.002l18.119,10.461c3.703,2.137,6.001,6.123,6.001,10.396V499.766z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1235_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M438.651,462.186c-2.412-1.396-4.754-2.098-6.874-2.098c-1.501,0-2.892,0.354-4.124,1.064 c-2.998,1.732-4.65,5.354-4.65,10.199c0,9.75,6.817,21.615,15.198,26.453c4.121,2.381,8.025,2.746,10.994,1.035 c3-1.732,4.651-5.357,4.651-10.201C453.847,478.889,447.028,467.021,438.651,462.186z M448.744,498.057 c-1.09,0.631-2.329,0.943-3.676,0.943c-1.962,0-4.145-0.662-6.417-1.977c-8.13-4.693-14.745-16.209-14.745-25.672 c0-4.51,1.492-7.855,4.199-9.42c2.677-1.551,6.266-1.18,10.096,1.033c8.131,4.693,14.742,16.211,14.742,25.674 C452.943,493.15,451.452,496.494,448.744,498.057z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1231_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M438.651,470.85c-1.248-0.719-2.461-1.084-3.564-1.084c-0.793,0-1.532,0.188-2.184,0.564 c-1.582,0.914-2.452,2.803-2.452,5.32c0,4.971,3.477,11.021,7.75,13.486c2.147,1.236,4.189,1.424,5.747,0.523 c1.583-0.916,2.452-2.803,2.452-5.322C446.4,479.367,442.923,473.318,438.651,470.85z M443.5,488.877 c-0.514,0.297-1.098,0.443-1.736,0.443c-0.945,0-2.004-0.324-3.112-0.963c-4.024-2.322-7.299-8.021-7.299-12.707 c0-2.182,0.712-3.793,1.998-4.539c1.279-0.738,2.996-0.551,4.851,0.52c4.022,2.322,7.297,8.023,7.297,12.707 C445.498,486.52,444.788,488.133,443.5,488.877z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "437.608,480.545 439.388,481.57 439.388,479.529 437.608,478.502  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1228_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "424.932,487.545 425.388,488.32 451.846,472.66 451.389,471.883  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1226_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.136,
    y: 479.608,
    transform: "matrix(-0.4969 -0.8678 0.8678 -0.4969 239.78 1099.134)",
    fill: "#FFFFFF",
    width: 52.751,
    height: 0.901
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1224_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.975,
    y: 462.572,
    fill: "#FFFFFF",
    width: 0.902,
    height: 34.842
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1222_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.895,
    y: 479.545,
    transform: "matrix(-0.8661 -0.4999 0.4999 -0.8661 578.1594 1114.8834)",
    fill: "#FFFFFF",
    width: 35.059,
    height: 0.898
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2886_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.4521,
    y1: 538.0557,
    x2: 370.4639,
    y2: 538.0557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4787,
    style: {
      stopColor: "#3E00A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#4403AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6152,
    style: {
      stopColor: "#560DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#741DC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#9D34D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9173,
    style: {
      stopColor: "#D050EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD69FF"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_78_)",
    d: "M267.068,593.084L242.1,580.766l23.899-24.908l-45.439-25.459l-48.565,12.949l-28.543-15.6 l202.741-44.721l24.271,13.727L267.068,593.084z M283.722,540.135l42.004-36.354l-78.589,16.441L283.722,540.135z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6425_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.3853,
    y1: 473.126,
    x2: 303.5965,
    y2: 581.952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_79_)",
    d: "M142.02,527.863l-1.548,0.91l127.137,67.184l0.624,0.324l140.031-78.684l1.629-0.918 l-128.098-70.816L142.02,527.863z M268.388,593.945L144.84,528.604l136.786-80.18l123.852,68.414L268.388,593.945z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6424_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.4609,
    y1: 473.0869,
    x2: 303.6726,
    y2: 581.9138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_80_)",
    d: "M345.767,481.223c-35.457-19.6-96.699-16.863-135.675,6.006 c-19.189,11.256-30,25.514-30.534,40.111c-0.208,5.699,1.171,11.166,4.024,16.248c4.164,7.416,11.451,14.008,21.507,19.328 c34.97,18.48,94.127,15.961,132.667-5.689c19.357-10.889,30.81-24.879,32.151-39.455 C371.236,503.586,362.685,490.568,345.767,481.223z M367.498,517.865c-1.269,13.861-12.277,27.244-30.917,37.725 c-37.805,21.258-95.833,23.736-130.11,5.607c-16.277-8.611-25.005-20.658-24.514-33.939c0.521-13.887,10.924-27.51,29.389-38.336 c38.206-22.4,98.197-25.08,132.93-5.893c9.699,5.355,16.547,11.939,20.219,19.254 C366.963,507.199,367.995,512.441,367.498,517.865z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1419_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.4668,
    y1: 473.082,
    x2: 303.6805,
    y2: 581.9131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_81_)",
    d: "M297.522,508.086c-4.937-2.73-11.676-4.234-18.973-4.234c-8.97,0-17.919,2.232-24.554,6.121 c-6.326,3.717-9.909,8.494-10.09,13.457c-0.07,1.973,0.401,3.877,1.397,5.654c1.421,2.531,3.831,4.713,7.172,6.482 c4.872,2.572,11.461,3.99,18.552,3.99c8.702,0,17.449-2.109,23.998-5.787c6.389-3.594,10.159-8.281,10.61-13.193 C306.095,515.662,303.215,511.225,297.522,508.086z M302.702,520.406c-0.36,3.955-3.599,7.844-9.116,10.945 c-6.112,3.438-14.306,5.406-22.484,5.406H271.1c-6.605,0-12.702-1.301-17.17-3.666c-4.711-2.49-7.229-5.904-7.089-9.607 c0.148-3.967,3.223-7.906,8.655-11.094c6.178-3.621,14.551-5.701,22.965-5.701c6.787,0,13.018,1.377,17.537,3.873 c2.795,1.543,4.828,3.465,5.877,5.557C302.559,517.482,302.838,518.924,302.702,520.406z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.1265,
    y1: 473.2539,
    x2: 303.3318,
    y2: 582.0677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_82_)",
    points: "267.023,523.051 274.543,527.107 282.711,522.426 275.189,518.355  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6403_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.8901,
    y1: 472.8818,
    x2: 304.1014,
    y2: 581.708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_83_)",
    points: "267.134,595.127 269.487,595.098 282.937,447.121 280.487,447.166  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6402_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.4121,
    y1: 473.1133,
    x2: 303.6225,
    y2: 581.9376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_84_)",
    points: "142.644,529.707 407.59,517.779 407.781,515.736 142.671,527.672  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6401_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.7915,
    y1: 472.9229,
    x2: 304.0086,
    y2: 581.761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_85_)",
    points: "205.162,561.24 206.397,562.873 345.619,482.982 344.422,481.271  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6400_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.5566,
    y1: 473.5195,
    x2: 302.769,
    y2: 582.3478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_86_)",
    points: "209.103,488.484 337.316,557.742 338.769,556.016 210.518,486.686  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.5142,
    y1: 465.4922,
    x2: 393.5945,
    y2: 680.3466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_87_)",
    points: "266.192,447.572 282.001,438.293 297.236,446.727 281.431,455.98  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.0435,
    y1: 321.5718,
    x2: 419.7282,
    y2: 541.8548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_88_)",
    points: "392.188,517.105 408.169,508.111 423.192,516.422 407.213,525.398  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.0049,
    y1: 523.1592,
    x2: 244.5283,
    y2: 741.0215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_89_)",
    points: "127.227,529.17 142.716,520.07 158.091,528.213 142.6,537.285  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.1885,
    y1: 378.0889,
    x2: 271.3282,
    y2: 601.4046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    style: {
      stopColor: "#FF8C60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5973,
    style: {
      stopColor: "#FF765F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    style: {
      stopColor: "#FF695E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_90_)",
    points: "252.879,595.508 268.562,586.684 283.74,594.717 268.055,603.521  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.812,
    y1: 146.9702,
    x2: 119.7284,
    y2: 102.3362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFE0ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_91_)",
    points: "34.103,134.864 66.892,153.797 141.925,111.494 109.136,92.561  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.2866,
    y1: 124.7886,
    x2: 83.2866,
    y2: 67.9971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#0852F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#1C33D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9768,
    style: {
      stopColor: "#3C03AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E00A7"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_92_)",
    points: "66.892,124.789 99.682,105.857 99.682,67.997 66.892,86.928  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1025,
    y1: 67.9976,
    x2: 99.6797,
    y2: 67.9976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9895,
    style: {
      stopColor: "#FF665E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_93_)",
    points: "34.103,67.997 66.892,86.928 99.68,67.998 66.891,49.067  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#010080",
    points: "51.521,67.998 66.892,76.873 82.262,67.998 66.891,59.122  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.5762,
    y1: 76.8726,
    x2: 74.5762,
    y2: 59.1221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#0852F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#1C33D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9768,
    style: {
      stopColor: "#3C03AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E00A7"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_94_)",
    points: "66.892,76.873 82.262,67.998 66.891,59.122  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#005DFF",
    points: "34.103,105.857 66.892,124.789 66.892,86.928 34.103,67.997  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.0474,
    y1: 76.8726,
    x2: 69.0474,
    y2: 69.4009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#0852F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#1C33D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9768,
    style: {
      stopColor: "#3C03AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E00A7"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_95_)",
    points: "66.891,76.873 71.204,74.381 71.204,69.401 66.891,71.892  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.5786,
    y1: 69.4014,
    x2: 71.2036,
    y2: 69.4014
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#FEAA62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9895,
    style: {
      stopColor: "#FF665E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF655E"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_96_)",
    points: "62.579,69.401 66.891,71.892 71.204,69.401 66.891,66.911  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#005DFF",
    points: "62.579,74.381 66.891,76.873 66.891,71.892 62.579,69.401  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature-3.d41ae0253b8841dd3d5fd3b670a75080.svg";
export { ForwardRef as ReactComponent };